// This file is auto-generated by @hey-api/openapi-ts

import type {
  ActionAuditLogControllerCreateData,
  ActionAuditLogControllerCreateResponses,
  ActionAuditLogControllerFindAllData,
  ActionAuditLogControllerFindAllResponses,
  AdminFulfillmentRequestsControllerListData,
  AdminFulfillmentRequestsControllerListResponses,
  AdminIncentiveAdjustmentsControllerAdjustProjectIncentivesData,
  AdminIncentiveAdjustmentsControllerAdjustProjectIncentivesResponses,
  AdminIncentiveAdjustmentsControllerGetProjectIncentiveAdjustmentsData,
  AdminIncentiveAdjustmentsControllerGetProjectIncentiveAdjustmentsResponses,
  AdminOrganizationsControllerCreateMergeData,
  AdminOrganizationsControllerCreateMergeResponses,
  AdminOrganizationsControllerListActiveUsersData,
  AdminOrganizationsControllerListActiveUsersResponses,
  AdminOrganizationsControllerListData,
  AdminOrganizationsControllerListResponses,
  AdminOrganizationsControllerUpdateData,
  AdminOrganizationsControllerUpdateResponses,
  AdminParticipantPaymentsControllerListRespondentPayoutsData,
  AdminParticipantPaymentsControllerListRespondentPayoutsResponses,
  AdminParticipantsControllerExportData,
  AdminParticipantsControllerExportResponses,
  AdminParticipantsControllerGetParticipantHistoryData,
  AdminParticipantsControllerGetParticipantHistoryResponses,
  AdminParticipantsControllerListData,
  AdminParticipantsControllerListResponses,
  AdminParticipantsControllerUpdateParticipantData,
  AdminParticipantsControllerUpdateParticipantResponses,
  AdminProjectsControllerGetAiModProjectStatsData,
  AdminProjectsControllerGetAiModProjectStatsResponses,
  AdminProjectsControllerGetProjectInsightsStatusData,
  AdminProjectsControllerGetProjectInsightsStatusResponses,
  AdminProjectsControllerPinFeaturesSchemaVersionData,
  AdminProjectsControllerPinFeaturesSchemaVersionResponses,
  AdminProjectsControllerUpdateRecruitingStatusData,
  AdminProjectsControllerUpdateRecruitingStatusResponses,
  AdminRepairControllerAdminRepairAtlasDisableTriggersCatchupData,
  AdminRepairControllerAdminRepairAtlasDisableTriggersCatchupResponses,
  AdminRepairControllerAdminRepairAtlasDisableTriggersData,
  AdminRepairControllerAdminRepairAtlasDisableTriggersResponses,
  AdminRepairControllerAdminRepairAtlasEnableTriggersCatchupData,
  AdminRepairControllerAdminRepairAtlasEnableTriggersCatchupResponses,
  AdminRepairControllerAdminRepairAtlasEnableTriggersData,
  AdminRepairControllerAdminRepairAtlasEnableTriggersResponses,
  AdminRepairControllerAdminRepairData,
  AdminRepairControllerAdminRepairJobTitleGroupingData,
  AdminRepairControllerAdminRepairJobTitleGroupingResponses,
  AdminRepairControllerAdminRepairMethodologyPricingData,
  AdminRepairControllerAdminRepairMethodologyPricingResponses,
  AdminRepairControllerAdminRepairPricingPlanCapabilitiesData,
  AdminRepairControllerAdminRepairPricingPlanCapabilitiesResponses,
  AdminRepairControllerAdminRepairProfileProjectMatchEmailEligibilityData,
  AdminRepairControllerAdminRepairProfileProjectMatchEmailEligibilityResponses,
  AdminRepairControllerAdminRepairProfileProjectMatchTargetedResearchInvitationData,
  AdminRepairControllerAdminRepairProfileProjectMatchTargetedResearchInvitationResponses,
  AdminRepairControllerAdminRepairProfileRiskManualReviewAuditData,
  AdminRepairControllerAdminRepairProfileRiskManualReviewAuditResponses,
  AdminRepairControllerAdminRepairProfileRiskPlaidTemplateIdData,
  AdminRepairControllerAdminRepairProfileRiskPlaidTemplateIdResponses,
  AdminRepairControllerAdminRepairProfilesRollupData,
  AdminRepairControllerAdminRepairProfilesRollupResponses,
  AdminRepairControllerAdminRepairProjectTitleFamiliesData,
  AdminRepairControllerAdminRepairProjectTitleFamiliesResponses,
  AdminRepairControllerAdminRepairResponses,
  AdminResearchersControllerListData,
  AdminResearchersControllerListResponses,
  AdminResearchersControllerUpdateResearcherData,
  AdminResearchersControllerUpdateResearcherResponses,
  AdminTeamsControllerListData,
  AdminTeamsControllerListResponses,
  AdminUsersControllerConvertParticipantToResearcherData,
  AdminUsersControllerConvertParticipantToResearcherResponses,
  AdminUsersControllerRemoveUserFromOrganizationData,
  AdminUsersControllerRemoveUserFromOrganizationResponses,
  AdminUsersControllerUpdateData,
  AdminUsersControllerUpdateResponses,
  AiChatControllerFindByProjectData,
  AiChatControllerFindByProjectResponses,
  AiChatControllerUpsertData,
  AiChatControllerUpsertResponses,
  AnalyticsSnapshotsControllerGetOrganizationSnapshotsData,
  AnalyticsSnapshotsControllerGetOrganizationSnapshotsResponses,
  AnalyticsSnapshotsControllerGetSnapshotsData,
  AnalyticsSnapshotsControllerGetSnapshotsResponses,
  ApiPartnerControllerDisableCredentialData,
  ApiPartnerControllerDisableCredentialResponses,
  ApiPartnerControllerEnsureAccountData,
  ApiPartnerControllerEnsureAccountResponses,
  ApiPartnerControllerListCredentialsData,
  ApiPartnerControllerListCredentialsResponses,
  ApiPartnerControllerLookupData,
  ApiPartnerControllerLookupResponses,
  ApiPartnerControllerProvisionData,
  ApiPartnerControllerProvisionResponses,
  AtlasAppAdminControllerSyncData,
  AtlasAppAdminControllerSyncResponses,
  AuthControllerInitiatePasswordResetData,
  AuthControllerInitiatePasswordResetResponses,
  AuthControllerParticipantSignupData,
  AuthControllerParticipantSignupResponses,
  AuthControllerResearcherSignupData,
  AuthControllerResearcherSignupResponses,
  AuthControllerSendPublicApplyVerificationData,
  AuthControllerSendPublicApplyVerificationResponses,
  AuthControllerVerifyEmailData,
  AuthControllerVerifyEmailResponses,
  BalanceManagementControllerProcessBalanceManagementData,
  BalanceManagementControllerProcessBalanceManagementResponses,
  BalancesControllerDownloadData,
  BalancesControllerDownloadResponses,
  BalancesControllerFindAllData,
  BalancesControllerFindAllResponses,
  BillingHistoryControllerFindAllForTeamData,
  BillingHistoryControllerFindAllForTeamResponses,
  CalendarConnectionControllerDisconnectData,
  CalendarConnectionControllerDisconnectResponses,
  CalendarConnectionControllerGetData,
  CalendarConnectionControllerGetResponses,
  CalendarConnectionControllerUpdateData,
  CalendarConnectionControllerUpdateResponses,
  ClearbitRiskHistoryControllerCreateData,
  ClearbitRiskHistoryControllerCreateResponses,
  ClientAuthControllerAuthenticateData,
  ClientAuthControllerAuthenticateResponses,
  ClientAuthControllerDeleteData,
  ClientAuthControllerDeleteResponses,
  ClientAuthControllerUpsertTokenData,
  ClientAuthControllerUpsertTokenResponses,
  CompaniesControllerUpsertCompanyByDomainData,
  CompaniesControllerUpsertCompanyByDomainResponses,
  ConversationsControllerAddParticipantData,
  ConversationsControllerAddParticipantResponses,
  ConversationsControllerCreateData,
  ConversationsControllerCreateResponses,
  ConversationsControllerFindAllData,
  ConversationsControllerFindAllResponses,
  ConversationsControllerFindOneData,
  ConversationsControllerFindOneResponses,
  ConversationsControllerInitiateAttachmentUploadData,
  ConversationsControllerInitiateAttachmentUploadResponses,
  ConversationsControllerMarkAsReadData,
  ConversationsControllerMarkAsReadResponses,
  ConversationsControllerRemoveData,
  ConversationsControllerRemoveParticipantData,
  ConversationsControllerRemoveParticipantResponses,
  ConversationsControllerRemoveResponses,
  ConversationsControllerUpdateData,
  ConversationsControllerUpdateResponses,
  ConversationsControllerUploadAttachmentData,
  ConversationsControllerUploadAttachmentResponses,
  CreditCardsControllerCreateData,
  CreditCardsControllerCreateResponses,
  CreditCardsControllerGetAllData,
  CreditCardsControllerGetAllResponses,
  CreditCardsControllerGetClientTokenData,
  CreditCardsControllerGetClientTokenResponses,
  CreditCardsControllerRemoveData,
  CreditCardsControllerRemoveResponses,
  CreditCardsControllerUpdateData,
  CreditCardsControllerUpdateDefaultCardData,
  CreditCardsControllerUpdateDefaultCardResponses,
  CreditCardsControllerUpdateResponses,
  CreditsManagementControllerCancelData,
  CreditsManagementControllerCancelResponses,
  CreditsManagementControllerExtendCreditData,
  CreditsManagementControllerExtendCreditResponses,
  CreditsManagementControllerGetCreditExpirySummaryForTeamData,
  CreditsManagementControllerGetCreditExpirySummaryForTeamResponses,
  CreditsManagementControllerRestoreData,
  CreditsManagementControllerRestoreResponses,
  CspControllerReportCspViolationData,
  CspControllerReportCspViolationResponses,
  EmailEventsControllerCreateEmailEventData,
  EmailEventsControllerCreateEmailEventResponses,
  EmailQueueControllerQueueEmailData,
  EmailQueueControllerQueueEmailNewMessageAvailableData,
  EmailQueueControllerQueueEmailNewMessageAvailableResponses,
  EmailQueueControllerQueueEmailResponses,
  ExternalInvitesControllerSendVerificationData,
  ExternalInvitesControllerSendVerificationResponses,
  ExternalInvitesControllerSubmitApplicationData,
  ExternalInvitesControllerSubmitApplicationResponses,
  ExternalInvitesControllerValidateData,
  ExternalInvitesControllerValidateResponses,
  ExternalScreenerControllerGetScreenerData,
  ExternalScreenerControllerGetScreenerResponses,
  ExternalScreenerControllerSaveScreenerResponseData,
  ExternalScreenerControllerSaveScreenerResponseErrors,
  ExternalScreenerControllerSaveScreenerResponseResponses,
  FeatureFlagsControllerAddOrganizationData,
  FeatureFlagsControllerAddOrganizationErrors,
  FeatureFlagsControllerAddOrganizationResponses,
  FeatureFlagsControllerFindAllData,
  FeatureFlagsControllerFindAllResponses,
  FeatureFlagsControllerGetFeatureFlagActiveData,
  FeatureFlagsControllerGetFeatureFlagActiveErrors,
  FeatureFlagsControllerGetFeatureFlagActiveResponses,
  FeatureFlagsControllerListAllData,
  FeatureFlagsControllerListAllResponses,
  FeatureFlagsControllerRemoveOrganizationData,
  FeatureFlagsControllerRemoveOrganizationErrors,
  FeatureFlagsControllerRemoveOrganizationResponses,
  FeatureFlagsControllerSetActiveData,
  FeatureFlagsControllerSetActiveErrors,
  FeatureFlagsControllerSetActiveResponses,
  FeedbackControllerCreateData,
  FeedbackControllerCreateResponses,
  FeedbackControllerFindData,
  FeedbackControllerFindResponses,
  FeedbackControllerListData,
  FeedbackControllerListResponses,
  FeedbackControllerUpdateData,
  FeedbackControllerUpdateResponses,
  FlaggedRespondentsControllerCreateData,
  FlaggedRespondentsControllerCreateResponses,
  FlaggedRespondentsControllerFindAllByOrganizationAndProfileData,
  FlaggedRespondentsControllerFindAllByOrganizationAndProfileQueryData,
  FlaggedRespondentsControllerFindAllByOrganizationAndProfileQueryResponses,
  FlaggedRespondentsControllerFindAllByOrganizationAndProfileResponses,
  FlaggedRespondentsControllerFindOneData,
  FlaggedRespondentsControllerFindOneResponses,
  FlaggedRespondentsControllerRemoveData,
  FlaggedRespondentsControllerRemoveResponses,
  FlaggedRespondentsControllerUpdateData,
  FlaggedRespondentsControllerUpdateResponses,
  ForbiddenWorkDomainsControllerAddForbiddenWorkDomainData,
  ForbiddenWorkDomainsControllerAddForbiddenWorkDomainResponses,
  FraudMetricsControllerGetPlaidRiskVerificationsOverTimeData,
  FraudMetricsControllerGetPlaidRiskVerificationsOverTimeResponses,
  FraudMetricsControllerGetRejectedIpApplicationsOverTimeData,
  FraudMetricsControllerGetRejectedIpApplicationsOverTimeResponses,
  FraudMetricsControllerGetRejectedVpnApplicationsOverTimeData,
  FraudMetricsControllerGetRejectedVpnApplicationsOverTimeResponses,
  FraudMetricsControllerGetReportedUsersOverTimeData,
  FraudMetricsControllerGetReportedUsersOverTimeResponses,
  FraudSignalsControllerCreateData,
  FraudSignalsControllerCreateResponses,
  FraudWorkDomainsControllerBlockWorkDomainData,
  FraudWorkDomainsControllerBlockWorkDomainResponses,
  GdprDeletionsControllerCreateData,
  GdprDeletionsControllerCreateResponses,
  GdprDeletionsControllerFindAllData,
  GdprDeletionsControllerFindAllResponses,
  GdprDeletionsControllerUpdateData,
  GdprDeletionsControllerUpdateResponses,
  GetInterviewCaptionsData,
  GetInterviewCaptionsErrors,
  GetInterviewCaptionsResponses,
  GhostInspectorControllerDeleteOrganizationData,
  GhostInspectorControllerDeleteOrganizationErrors,
  GhostInspectorControllerDeleteOrganizationResponses,
  IndustriesControllerFindAllData,
  IndustriesControllerFindAllResponses,
  IndustriesControllerFindOneData,
  IndustriesControllerFindOneResponses,
  InsightsChatControllerDeleteThreadData,
  InsightsChatControllerDeleteThreadResponses,
  InsightsChatControllerEvaluateChartData,
  InsightsChatControllerEvaluateChartResponses,
  InsightsChatControllerGetThreadData,
  InsightsChatControllerGetThreadResponses,
  InsightsChatControllerListThreadsData,
  InsightsChatControllerListThreadsResponses,
  InsightsChatControllerRenameThreadData,
  InsightsChatControllerRenameThreadResponses,
  InsightsChatControllerSendMessageData,
  InsightsChatControllerSendMessageResponses,
  IntegrationsControllerCreateIntegrationData,
  IntegrationsControllerCreateIntegrationResponses,
  IntegrationsControllerCreateTaskForParticipantData,
  IntegrationsControllerCreateTaskForParticipantResponses,
  IntegrationsControllerDeleteIntegrationData,
  IntegrationsControllerDeleteIntegrationResponses,
  IntegrationsControllerDownloadCompletesData,
  IntegrationsControllerDownloadCompletesResponses,
  IntegrationsControllerFindAllSurveyResponsesWithTasksForProjectData,
  IntegrationsControllerFindAllSurveyResponsesWithTasksForProjectResponses,
  IntegrationsControllerFindAllSurveysForIntegrationData,
  IntegrationsControllerFindAllSurveysForIntegrationResponses,
  IntegrationsControllerGetSurveyResponseDetailsData,
  IntegrationsControllerGetSurveyResponseDetailsResponses,
  IntegrationsControllerMarkTaskAsCompleteByProjectCompletionIdData,
  IntegrationsControllerMarkTaskAsCompleteByProjectCompletionIdResponses,
  IntegrationsControllerUpdateTaskOnProjectData,
  IntegrationsControllerUpdateTaskOnProjectResponses,
  IntegrationsControllerUpdateTaskOnSurveyResponseData,
  IntegrationsControllerUpdateTaskOnSurveyResponseErrors,
  IntegrationsControllerUpdateTaskOnSurveyResponseResponses,
  InterviewMediaControllerAbortUploadData,
  InterviewMediaControllerAbortUploadErrors,
  InterviewMediaControllerAbortUploadResponses,
  InterviewMediaControllerCompleteUploadData,
  InterviewMediaControllerCompleteUploadErrors,
  InterviewMediaControllerCompleteUploadResponses,
  InterviewMediaControllerGetTranscriptionTokenData,
  InterviewMediaControllerGetTranscriptionTokenErrors,
  InterviewMediaControllerGetTranscriptionTokenResponses,
  InterviewMediaControllerInitiateUploadData,
  InterviewMediaControllerInitiateUploadErrors,
  InterviewMediaControllerInitiateUploadResponses,
  InterviewMediaControllerUploadPartData,
  InterviewMediaControllerUploadPartErrors,
  InterviewMediaControllerUploadPartResponses,
  InterviewMediaControllerUploadTranscriptWordsData,
  InterviewMediaControllerUploadTranscriptWordsErrors,
  InterviewMediaControllerUploadTranscriptWordsResponses,
  InvitationsControllerCreateData,
  InvitationsControllerCreateResponses,
  InvitationsControllerFindAllData,
  InvitationsControllerFindAllResponses,
  InvitationsControllerFindOneData,
  InvitationsControllerFindOneResponses,
  InvitationsControllerFindPendingForParticipantData,
  InvitationsControllerFindPendingForParticipantResponses,
  InvitationsControllerFindPendingForProjectData,
  InvitationsControllerFindPendingForProjectResponses,
  InvitationsControllerRemoveData,
  InvitationsControllerRemoveResponses,
  InvitationsControllerUpdateData,
  InvitationsControllerUpdateResponses,
  JobTitlesControllerFindAllData,
  JobTitlesControllerFindAllResponses,
  JobTitlesControllerFindOneData,
  JobTitlesControllerFindOneResponses,
  JobTitlesControllerGroupingCoverageData,
  JobTitlesControllerGroupingCoverageResponses,
  LeadsControllerConsumeLeadData,
  LeadsControllerConsumeLeadResponses,
  LeadsControllerCreateData,
  LeadsControllerCreateManyData,
  LeadsControllerCreateManyResponses,
  LeadsControllerCreateResponses,
  LeadsControllerDeleteData,
  LeadsControllerDeleteResponses,
  LeadsControllerFindAllData,
  LeadsControllerFindAllResponses,
  LeadsControllerFindOneData,
  LeadsControllerFindOneResponses,
  LeadsControllerFindUtmTrackedResponsesData,
  LeadsControllerFindUtmTrackedResponsesResponses,
  LeadsControllerFindUtmTrackedUsersData,
  LeadsControllerFindUtmTrackedUsersResponses,
  LeadsControllerRejectLeadData,
  LeadsControllerRejectLeadResponses,
  LeadsControllerUpdateData,
  LeadsControllerUpdateResponses,
  LeadsControllerValidateLeadData,
  LeadsControllerValidateLeadResponses,
  LookupsControllerFindAllData,
  LookupsControllerFindAllExpandedData,
  LookupsControllerFindAllExpandedResponses,
  LookupsControllerFindAllResponses,
  LookupsControllerIndustriesLookupData,
  LookupsControllerIndustriesLookupResponses,
  LookupsControllerJobTitlesLookupData,
  LookupsControllerJobTitlesLookupResponses,
  LookupsControllerSkillsLookupData,
  LookupsControllerSkillsLookupResponses,
  LookupsControllerTopicsLookupData,
  LookupsControllerTopicsLookupResponses,
  ManageTeamPlansControllerManagePausedPlansData,
  ManageTeamPlansControllerManagePausedPlansResponses,
  ManageTeamPlansControllerManagePlanRenewalsData,
  ManageTeamPlansControllerManagePlanRenewalsResponses,
  ManageTeamPlansControllerManagePricingTeamBalanceData,
  ManageTeamPlansControllerManagePricingTeamBalanceResponses,
  ManageTeamPlansControllerManagePricingTeamCreateCustomPlanData,
  ManageTeamPlansControllerManagePricingTeamCreateCustomPlanResponses,
  ManualReviewControllerApproveManualReviewResponseData,
  ManualReviewControllerApproveManualReviewResponseResponses,
  ManualReviewControllerFindManualReviewResponsesData,
  ManualReviewControllerFindManualReviewResponsesResponses,
  ManualReviewControllerParticipantFlagHistoryData,
  ManualReviewControllerParticipantFlagHistoryResponses,
  ManualReviewControllerParticipantIdentityVerificationData,
  ManualReviewControllerParticipantIdentityVerificationResponses,
  ManualReviewControllerParticipantIpSummaryData,
  ManualReviewControllerParticipantIpSummaryResponses,
  ManualReviewControllerRejectManualReviewResponseData,
  ManualReviewControllerRejectManualReviewResponseResponses,
  ManualReviewControllerReportManualReviewResponseData,
  ManualReviewControllerReportManualReviewResponseResponses,
  MatchingControllerCalculateB2bFeasibilityByAttributesData,
  MatchingControllerCalculateB2bFeasibilityByAttributesErrors,
  MatchingControllerCalculateB2bFeasibilityByAttributesResponses,
  MatchingControllerCalculateB2cFeasibilityByAttributesData,
  MatchingControllerCalculateB2cFeasibilityByAttributesErrors,
  MatchingControllerCalculateB2cFeasibilityByAttributesResponses,
  MatchingControllerCheckIfStopEmailsData,
  MatchingControllerCheckIfStopEmailsResponses,
  MatchingControllerCreateMatchingProjectData,
  MatchingControllerCreateMatchingProjectResponses,
  MatchingControllerFindMatchedProjectsData,
  MatchingControllerFindMatchedProjectsNoAuthData,
  MatchingControllerFindMatchedProjectsNoAuthResponses,
  MatchingControllerFindMatchedProjectsResponses,
  MatchingControllerGetExistingScoringModifiersData,
  MatchingControllerGetExistingScoringModifiersResponses,
  MatchingControllerGetProcessingMatchingProjectsData,
  MatchingControllerGetProcessingMatchingProjectsResponses,
  MatchingControllerGetProfileRollupMetadataData,
  MatchingControllerGetProfileRollupMetadataResponses,
  MatchingControllerGetRecontactProfilesData,
  MatchingControllerGetRecontactProfilesResponses,
  MatchingControllerGetRecruitingMatchingProjectsData,
  MatchingControllerGetRecruitingMatchingProjectsResponses,
  MatchingControllerGetTopMatchedProfilesData,
  MatchingControllerGetTopMatchedProfilesResponses,
  MatchingControllerGetUpdatedExternalResearcherRespondentTransactionsData,
  MatchingControllerGetUpdatedExternalResearcherRespondentTransactionsResponses,
  MatchingControllerGetUpdatedFlaggedRespondentsData,
  MatchingControllerGetUpdatedFlaggedRespondentsResponses,
  MatchingControllerGetUpdatedProfileProjectMatchesData,
  MatchingControllerGetUpdatedProfileProjectMatchesResponses,
  MatchingControllerGetUpdatedRespondentTransactionsData,
  MatchingControllerGetUpdatedRespondentTransactionsResponses,
  MatchingControllerHandleProfileProjectScoreAndUpsertData,
  MatchingControllerHandleProfileProjectScoreAndUpsertResponses,
  MatchingControllerInsertProfileProjectMatchesEmailEventData,
  MatchingControllerInsertProfileProjectMatchesEmailEventResponses,
  MatchingControllerMarkMatchingProjectCheckedData,
  MatchingControllerMarkMatchingProjectCheckedResponses,
  MatchingControllerMarkMatchingProjectRecontactCheckedData,
  MatchingControllerMarkMatchingProjectRecontactCheckedResponses,
  MatchingControllerMonitorRecruitingData,
  MatchingControllerMonitorRecruitingResponses,
  MatchingControllerPrequalifiesForProjectData,
  MatchingControllerPrequalifiesForProjectResponses,
  MatchingControllerProjectAudienceSizeEstimateData,
  MatchingControllerProjectAudienceSizeEstimateResponses,
  MatchingControllerProjectFeasibilityData,
  MatchingControllerProjectFeasibilityResponses,
  MatchingControllerRebuildQuotaPredictionsData,
  MatchingControllerRebuildQuotaPredictionsResponses,
  MatchingControllerRunInitialMatchingCheckData,
  MatchingControllerRunInitialMatchingCheckResponses,
  MatchingControllerSweepRecruitingStalledProjectsData,
  MatchingControllerSweepRecruitingStalledProjectsResponses,
  MatchingControllerTriggerRematchForExistingProjectData,
  MatchingControllerTriggerRematchForExistingProjectResponses,
  MatchingControllerUpdateData,
  MatchingControllerUpdateMatchingProjectData,
  MatchingControllerUpdateMatchingProjectResponses,
  MatchingControllerUpdateResponses,
  MatchingControllerUpsertProfileProjectScoresData,
  MatchingControllerUpsertProfileProjectScoresResponses,
  MatchingControllerUpsertProjectScoreByProfileData,
  MatchingControllerUpsertProjectScoreByProfileResponses,
  MatchingControllerUpsertProjectScoreData,
  MatchingControllerUpsertProjectScoreResponses,
  MatchingControllerUpsertProjectScoresFromProfileIdData,
  MatchingControllerUpsertProjectScoresFromProfileIdResponses,
  MessageAttachmentUploadsControllerAbortData,
  MessageAttachmentUploadsControllerAbortResponses,
  MessageAttachmentUploadsControllerCompleteData,
  MessageAttachmentUploadsControllerCompleteResponses,
  MessageAttachmentUploadsControllerUploadPartData,
  MessageAttachmentUploadsControllerUploadPartResponses,
  MessagesControllerCreateDeprecatedData,
  MessagesControllerCreateDeprecatedResponses,
  MessagesControllerCreateMessageData,
  MessagesControllerCreateMessageResponses,
  MessagesControllerDeleteData,
  MessagesControllerDeleteResponses,
  MessagesControllerFindAllData,
  MessagesControllerFindAllResponses,
  MessagesControllerFindOneData,
  MessagesControllerFindOneResponses,
  MessagesControllerGetInboxData,
  MessagesControllerGetInboxResponses,
  MessagesControllerGetProjectUnreadCountsData,
  MessagesControllerGetProjectUnreadCountsResponses,
  MessagesControllerGetUserInboxData,
  MessagesControllerGetUserInboxResponses,
  MessagingOrganizationsControllerCreateOrganizationData,
  MessagingOrganizationsControllerCreateOrganizationResponses,
  MessagingOrganizationsControllerCreateTeamData,
  MessagingOrganizationsControllerCreateTeamResponses,
  MessagingOrganizationsControllerFindOneData,
  MessagingOrganizationsControllerFindOneResponses,
  MessagingOrganizationsControllerFindTeamData,
  MessagingOrganizationsControllerFindTeamResponses,
  MessagingOrganizationsControllerUpdateOrganizationData,
  MessagingOrganizationsControllerUpdateOrganizationResponses,
  MessagingOrganizationsControllerUpdateTeamData,
  MessagingOrganizationsControllerUpdateTeamResponses,
  MessagingUsersControllerCreateData,
  MessagingUsersControllerCreateResponses,
  MessagingUsersControllerFindOneByEmailData,
  MessagingUsersControllerFindOneByEmailResponses,
  MessagingUsersControllerFindOneData,
  MessagingUsersControllerFindOneResponses,
  MessagingUsersControllerUpdateData,
  MessagingUsersControllerUpdateResponses,
  MissingCompanyDomainsControllerApplyVerificationData,
  MissingCompanyDomainsControllerApplyVerificationResponses,
  MissingCompanyDomainsControllerBulkUpdateMissingDomainStatusData,
  MissingCompanyDomainsControllerBulkUpdateMissingDomainStatusResponses,
  MissingCompanyDomainsControllerGetMissingCompanyDomainsData,
  MissingCompanyDomainsControllerGetMissingCompanyDomainsResponses,
  MissingCompanyDomainsControllerGetMissingDomainReviewData,
  MissingCompanyDomainsControllerGetMissingDomainReviewResponses,
  MissingCompanyDomainsControllerListMissingCompanyDomainsData,
  MissingCompanyDomainsControllerListMissingCompanyDomainsResponses,
  MissingCompanyDomainsControllerRecordSecurityCheckAttemptData,
  MissingCompanyDomainsControllerRecordSecurityCheckAttemptResponses,
  MissingCompanyDomainsControllerRejectDomainProfilesData,
  MissingCompanyDomainsControllerRejectDomainProfilesResponses,
  MissingCompanyDomainsControllerUpDateDomainData,
  MissingCompanyDomainsControllerUpDateDomainResponses,
  MissingCompanyDomainsControllerUpdateMissingDomainStatusData,
  MissingCompanyDomainsControllerUpdateMissingDomainStatusResponses,
  MissingCompanyDomainsControllerUpdateWebsiteCheckData,
  MissingCompanyDomainsControllerUpdateWebsiteCheckResponses,
  NotificationsControllerCancelPendingTaskCompletionRemindersData,
  NotificationsControllerCancelPendingTaskCompletionRemindersResponses,
  NotificationsControllerGetEmailPayloadByStatusData,
  NotificationsControllerGetEmailPayloadByStatusResponses,
  NotificationsControllerUpdateStatusByIdData,
  NotificationsControllerUpdateStatusByIdResponses,
  OrganizationRateCardsControllerGetForOrganizationData,
  OrganizationRateCardsControllerGetForOrganizationResponses,
  OrganizationRateCardsControllerUpsertForOrganizationData,
  OrganizationRateCardsControllerUpsertForOrganizationResponses,
  OrganizationsControllerCreateNewTeamRequestData,
  OrganizationsControllerCreateNewTeamRequestResponses,
  OrganizationsControllerFindOneData,
  OrganizationsControllerFindOneResponses,
  OrganizationsControllerGetOrganizationsForUserData,
  OrganizationsControllerGetOrganizationsForUserResponses,
  OrganizationsControllerMergeData,
  OrganizationsControllerMergeResponses,
  OrganizationsControllerRemoveData,
  OrganizationsControllerRemoveResponses,
  OrganizationsControllerUpdateData,
  OrganizationsControllerUpdateNewTeamRequestData,
  OrganizationsControllerUpdateNewTeamRequestResponses,
  OrganizationsControllerUpdateResponses,
  OrganizationsControllerUploadFilesFormDataData,
  OrganizationsControllerUploadFilesFormDataResponses,
  ParticipantBookingControllerBookData,
  ParticipantBookingControllerBookResponses,
  ParticipantBookingControllerCancelData,
  ParticipantBookingControllerCancelErrors,
  ParticipantBookingControllerCancelResponses,
  ParticipantBookingControllerFindTimesData,
  ParticipantBookingControllerFindTimesResponses,
  ParticipantBookingControllerGetBookingData,
  ParticipantBookingControllerGetBookingResponses,
  ParticipantBookingControllerNotifyResearcherData,
  ParticipantBookingControllerNotifyResearcherErrors,
  ParticipantBookingControllerNotifyResearcherResponses,
  ParticipantBookingControllerRescheduleData,
  ParticipantBookingControllerRescheduleResponses,
  ParticipantMatchingControllerCheckQualificationForProjectData,
  ParticipantMatchingControllerCheckQualificationForProjectResponses,
  ParticipantMatchingControllerFindMatchedProjectsForParticipantData,
  ParticipantMatchingControllerFindMatchedProjectsForParticipantResponses,
  ParticipantMatchingControllerUpdateProfileAndCheckQualificationData,
  ParticipantMatchingControllerUpdateProfileAndCheckQualificationResponses,
  ParticipantPaymentsControllerCreatePaymentBatchesData,
  ParticipantPaymentsControllerCreatePaymentBatchesResponses,
  ParticipantPaymentsControllerGetPaymentBatchesPendingConfirmationData,
  ParticipantPaymentsControllerGetPaymentBatchesPendingConfirmationResponses,
  ParticipantPaymentsControllerGetPaymentBatchesPendingPaymentData,
  ParticipantPaymentsControllerGetPaymentBatchesPendingPaymentResponses,
  ParticipantPaymentsControllerGetPendingRespondentPayoutsBeforeDateData,
  ParticipantPaymentsControllerGetPendingRespondentPayoutsBeforeDateResponses,
  ParticipantPaymentsControllerUpdateManyPaymentBatchData,
  ParticipantPaymentsControllerUpdateManyPaymentBatchResponses,
  ParticipantPaymentsControllerUpdateManyRespondentPayoutsData,
  ParticipantPaymentsControllerUpdateManyRespondentPayoutsResponses,
  ParticipantPaymentsControllerUpdatePaymentBatchData,
  ParticipantPaymentsControllerUpdatePaymentBatchResponses,
  ParticipantPaymentsControllerUpdateRespondentPayoutsData,
  ParticipantPaymentsControllerUpdateRespondentPayoutsResponses,
  ParticipantProfilesControllerAcceptCodeOfConductData,
  ParticipantProfilesControllerAcceptCodeOfConductResponses,
  ParticipantProfilesControllerChangePasswordData,
  ParticipantProfilesControllerChangePasswordResponses,
  ParticipantProfilesControllerDeactivateData,
  ParticipantProfilesControllerDeactivateResponses,
  ParticipantProfilesControllerFindByUserIdData,
  ParticipantProfilesControllerFindByUserIdResponses,
  ParticipantProfilesControllerSendEmploymentEmailVerificationData,
  ParticipantProfilesControllerSendEmploymentEmailVerificationResponses,
  ParticipantProfilesControllerVerifyEmploymentEmailCodeData,
  ParticipantProfilesControllerVerifyEmploymentEmailCodeResponses,
  ParticipantProjectsControllerCancelApplicationData,
  ParticipantProjectsControllerCancelApplicationResponses,
  ParticipantProjectsControllerCheckPublicApplyWorkEmailData,
  ParticipantProjectsControllerCheckPublicApplyWorkEmailResponses,
  ParticipantProjectsControllerCompleteInterviewData,
  ParticipantProjectsControllerCompleteInterviewErrors,
  ParticipantProjectsControllerCompleteInterviewResponses,
  ParticipantProjectsControllerGenerateFollowUpData,
  ParticipantProjectsControllerGenerateFollowUpResponses,
  ParticipantProjectsControllerGetApplicationSignalsData,
  ParticipantProjectsControllerGetApplicationSignalsResponses,
  ParticipantProjectsControllerGetInterviewData,
  ParticipantProjectsControllerGetInterviewErrors,
  ParticipantProjectsControllerGetInterviewQuestionMediaData,
  ParticipantProjectsControllerGetInterviewQuestionMediaErrors,
  ParticipantProjectsControllerGetInterviewQuestionMediaResponses,
  ParticipantProjectsControllerGetInterviewResponses,
  ParticipantProjectsControllerGetMessagingProjectsData,
  ParticipantProjectsControllerGetMessagingProjectsResponses,
  ParticipantProjectsControllerGetMyProjectsData,
  ParticipantProjectsControllerGetMyProjectsResponses,
  ParticipantProjectsControllerGetNextScreenerQuestionData,
  ParticipantProjectsControllerGetNextScreenerQuestionErrors,
  ParticipantProjectsControllerGetNextScreenerQuestionResponses,
  ParticipantProjectsControllerGetParticipantPaidCountData,
  ParticipantProjectsControllerGetParticipantPaidCountResponses,
  ParticipantProjectsControllerGetPastProjectsData,
  ParticipantProjectsControllerGetPastProjectsResponses,
  ParticipantProjectsControllerGetProfileCompletionQuestionsData,
  ParticipantProjectsControllerGetProfileCompletionQuestionsErrors,
  ParticipantProjectsControllerGetProfileCompletionQuestionsResponses,
  ParticipantProjectsControllerGetProjectB2bQuestionsData,
  ParticipantProjectsControllerGetProjectB2bQuestionsErrors,
  ParticipantProjectsControllerGetProjectB2bQuestionsResponses,
  ParticipantProjectsControllerGetProjectDetailsData,
  ParticipantProjectsControllerGetProjectDetailsResponses,
  ParticipantProjectsControllerGetProjectProfileQuestionsData,
  ParticipantProjectsControllerGetProjectProfileQuestionsErrors,
  ParticipantProjectsControllerGetProjectProfileQuestionsResponses,
  ParticipantProjectsControllerGetScreenerData,
  ParticipantProjectsControllerGetScreenerQuestionsData,
  ParticipantProjectsControllerGetScreenerQuestionsResponses,
  ParticipantProjectsControllerGetScreenerResponses,
  ParticipantProjectsControllerHideProjectData,
  ParticipantProjectsControllerHideProjectResponses,
  ParticipantProjectsControllerMarkPlaidCompleteData,
  ParticipantProjectsControllerMarkPlaidCompleteResponses,
  ParticipantProjectsControllerRecalculateScreenerStatusData,
  ParticipantProjectsControllerRecalculateScreenerStatusResponses,
  ParticipantProjectsControllerResendPayoutEmailData,
  ParticipantProjectsControllerResendPayoutEmailResponses,
  ParticipantProjectsControllerSaveInterviewResponsesData,
  ParticipantProjectsControllerSaveInterviewResponsesErrors,
  ParticipantProjectsControllerSaveInterviewResponsesResponses,
  ParticipantProjectsControllerSaveScreenerResponseData,
  ParticipantProjectsControllerSaveScreenerResponseErrors,
  ParticipantProjectsControllerSaveScreenerResponseResponses,
  ParticipantProjectsControllerSetInterviewResponseLanguageData,
  ParticipantProjectsControllerSetInterviewResponseLanguageErrors,
  ParticipantProjectsControllerSetInterviewResponseLanguageResponses,
  ParticipantProjectsControllerStartExternalScreenerData,
  ParticipantProjectsControllerStartExternalScreenerResponses,
  ParticipantProjectsControllerStartUnmoderatedProjectData,
  ParticipantProjectsControllerStartUnmoderatedProjectResponses,
  ParticipantProjectsControllerSubmitPublicApplicationData,
  ParticipantProjectsControllerSubmitPublicApplicationErrors,
  ParticipantProjectsControllerSubmitPublicApplicationResponses,
  ParticipantProjectsControllerViewProjectData,
  ParticipantProjectsControllerViewProjectResponses,
  ParticipantReferralsControllerFindByReferrerUserIdData,
  ParticipantReferralsControllerFindByReferrerUserIdResponses,
  PaymentProcessingControllerCreatePaygData,
  PaymentProcessingControllerCreatePaygResponses,
  PaymentProcessingControllerDownloadPastPaymentsData,
  PaymentProcessingControllerDownloadPastPaymentsResponses,
  PaymentProcessingControllerGetOverviewData,
  PaymentProcessingControllerGetOverviewResponses,
  PaymentProcessingControllerListLegacyProjectPaymentsData,
  PaymentProcessingControllerListLegacyProjectPaymentsResponses,
  PaymentProcessingControllerListParticipantsToPayData,
  PaymentProcessingControllerListParticipantsToPayResponses,
  PaymentProcessingControllerListPastPaymentsData,
  PaymentProcessingControllerListPastPaymentsResponses,
  PaymentProcessingControllerPayoutCancelData,
  PaymentProcessingControllerPayoutCancelResponses,
  PaymentProcessingControllerPayoutProjectData,
  PaymentProcessingControllerPayoutProjectResponses,
  PaymentProcessingControllerPayoutSummaryData,
  PaymentProcessingControllerPayoutSummaryResponses,
  PaymentProcessingControllerProcessAutoPayData,
  PaymentProcessingControllerProcessAutoPayResponses,
  PrepayControllerPrepayProjectData,
  PrepayControllerPrepayProjectResponses,
  PricingChargesControllerAddDisputeData,
  PricingChargesControllerAddDisputeResponses,
  PricingChargesControllerCreateChargesPdfData,
  PricingChargesControllerCreateChargesPdfResponses,
  PricingChargesControllerCreateProjectChargesPdfData,
  PricingChargesControllerCreateProjectChargesPdfResponses,
  PricingChargesControllerFindAllData,
  PricingChargesControllerFindAllForOrganizationData,
  PricingChargesControllerFindAllForOrganizationResponses,
  PricingChargesControllerFindAllForTeamData,
  PricingChargesControllerFindAllForTeamResponses,
  PricingChargesControllerFindAllResponses,
  PricingChargesControllerFindOneData,
  PricingChargesControllerFindOneResponses,
  PricingChargesControllerSendReceiptEmailData,
  PricingChargesControllerSendReceiptEmailResponses,
  PricingCreditsAuditControllerFindAllData,
  PricingCreditsAuditControllerFindAllResponses,
  PricingCreditsControllerExpireCreditData,
  PricingCreditsControllerExpireCreditResponses,
  PricingCreditsControllerFindAllData,
  PricingCreditsControllerFindAllExpiredData,
  PricingCreditsControllerFindAllExpiredResponses,
  PricingCreditsControllerFindAllForOrganizationData,
  PricingCreditsControllerFindAllForOrganizationResponses,
  PricingCreditsControllerFindAllForTeamData,
  PricingCreditsControllerFindAllForTeamPlanData,
  PricingCreditsControllerFindAllForTeamPlanResponses,
  PricingCreditsControllerFindAllForTeamResponses,
  PricingCreditsControllerFindAllResponses,
  PricingCreditsControllerFindAllWithOneWeekExpiryData,
  PricingCreditsControllerFindAllWithOneWeekExpiryResponses,
  PricingCreditsControllerFindOneData,
  PricingCreditsControllerFindOneResponses,
  PricingCreditsControllerGetRequirementsForProjectData,
  PricingCreditsControllerGetRequirementsForProjectResponses,
  PricingCreditsControllerGetRequirementsToEditProjectData,
  PricingCreditsControllerGetRequirementsToEditProjectResponses,
  PricingCreditsControllerManageCreditExpiryData,
  PricingCreditsControllerManageCreditExpiryResponses,
  PricingCreditsControllerReleaseAllData,
  PricingCreditsControllerReleaseAllResponses,
  PricingCreditsControllerReleaseData,
  PricingCreditsControllerReleaseResponses,
  PricingCreditsControllerReservationsData,
  PricingCreditsControllerReservationsResponses,
  PricingCreditsControllerReserveData,
  PricingCreditsControllerReserveResponses,
  PricingCreditsControllerSendNotificationData,
  PricingCreditsControllerSendNotificationResponses,
  PricingCreditsControllerTransferData,
  PricingCreditsControllerTransferResponses,
  PricingPlansControllerCreateData,
  PricingPlansControllerCreateResponses,
  PricingPlansControllerFindAllData,
  PricingPlansControllerFindAllResponses,
  PricingPlansControllerFindOneData,
  PricingPlansControllerFindOneResponses,
  PricingPlansControllerGetStandardPlansSummaryData,
  PricingPlansControllerGetStandardPlansSummaryResponses,
  PricingPlansControllerRemoveData,
  PricingPlansControllerRemoveResponses,
  PricingPlansControllerUpdateData,
  PricingPlansControllerUpdateResponses,
  PricingPromotionsControllerCreateData,
  PricingPromotionsControllerCreateResponses,
  PricingPromotionsControllerFindAllData,
  PricingPromotionsControllerFindAllResponses,
  PricingPromotionsControllerFindOneData,
  PricingPromotionsControllerFindOneResponses,
  PricingPromotionsControllerRedeemData,
  PricingPromotionsControllerRedeemResponses,
  PricingPromotionsControllerUpdateData,
  PricingPromotionsControllerUpdateErrors,
  PricingPromotionsControllerUpdateResponses,
  PricingPurchaseOrdersControllerCreateData,
  PricingPurchaseOrdersControllerCreateResponses,
  PricingPurchaseOrdersControllerFindAllData,
  PricingPurchaseOrdersControllerFindAllResponses,
  PricingPurchaseOrdersControllerFindOneData,
  PricingPurchaseOrdersControllerFindOneResponses,
  PricingPurchaseOrdersControllerUpdateData,
  PricingPurchaseOrdersControllerUpdateErrors,
  PricingPurchaseOrdersControllerUpdateResponses,
  PricingTeamPlansControllerBulkUpgradeData,
  PricingTeamPlansControllerBulkUpgradeResponses,
  PricingTeamPlansControllerCheckV2TeamDataForMigrationToV3Data,
  PricingTeamPlansControllerCheckV2TeamDataForMigrationToV3Responses,
  PricingTeamPlansControllerCreateData,
  PricingTeamPlansControllerCreateResponses,
  PricingTeamPlansControllerFindAllData,
  PricingTeamPlansControllerFindAllForTeamData,
  PricingTeamPlansControllerFindAllForTeamResponses,
  PricingTeamPlansControllerFindAllResponses,
  PricingTeamPlansControllerFindOneData,
  PricingTeamPlansControllerFindOneResponses,
  PricingTeamPlansControllerGetActiveRateCardData,
  PricingTeamPlansControllerGetActiveRateCardResponses,
  PricingTeamPlansControllerGetActiveTeamPlanData,
  PricingTeamPlansControllerGetActiveTeamPlanResponses,
  PricingTeamPlansControllerGetSummaryForTeamData,
  PricingTeamPlansControllerGetSummaryForTeamResponses,
  PricingTeamPlansControllerHandleCreditBalanceChangeData,
  PricingTeamPlansControllerHandleCreditBalanceChangeResponses,
  PricingTeamPlansControllerMigratePricingV2ToV3Data,
  PricingTeamPlansControllerMigratePricingV2ToV3Responses,
  PricingTeamPlansControllerPauseData,
  PricingTeamPlansControllerPauseResponses,
  PricingTeamPlansControllerTeamUpgradeData,
  PricingTeamPlansControllerTeamUpgradeResponses,
  PricingTeamPlansControllerTransferTeamToNewCustomPlanData,
  PricingTeamPlansControllerTransferTeamToNewCustomPlanResponses,
  PricingTeamPlansControllerUnpauseData,
  PricingTeamPlansControllerUnpauseResponses,
  PricingTeamPlansControllerUpdateCapabilitiesData,
  PricingTeamPlansControllerUpdateCapabilitiesResponses,
  PricingTeamPlansControllerUpdateData,
  PricingTeamPlansControllerUpdateResponses,
  ProfileLocksControllerGetByProfileIdData,
  ProfileLocksControllerGetByProfileIdResponses,
  ProfileLocksControllerGetLockedFieldsByProfileIdData,
  ProfileLocksControllerGetLockedFieldsByProfileIdResponses,
  ProfilesControllerCreateData,
  ProfilesControllerCreateResponses,
  ProfilesControllerFindByEmailData,
  ProfilesControllerFindByEmailResponses,
  ProfilesControllerFindByUserIdData,
  ProfilesControllerFindByUserIdResponses,
  ProfilesControllerFindExternalResearcherWithoutProfilePictureData,
  ProfilesControllerFindExternalResearcherWithoutProfilePictureResponses,
  ProfilesControllerFindOneData,
  ProfilesControllerFindOneResponses,
  ProfilesControllerGetIdByPhoneNumberData,
  ProfilesControllerGetIdByPhoneNumberResponses,
  ProfilesControllerGetScreenerCycleData,
  ProfilesControllerGetScreenerCycleResponses,
  ProfilesControllerHandleRejectedProfileData,
  ProfilesControllerHandleRejectedProfileResponses,
  ProfilesControllerLinkedinVolOAuthCallbackData,
  ProfilesControllerLinkedinVolOAuthCallbackResponses,
  ProfilesControllerProfileParticipationStatsForProfileData,
  ProfilesControllerProfileParticipationStatsForProfileResponses,
  ProfilesControllerRecheckRiskHiddenResponsesData,
  ProfilesControllerRecheckRiskHiddenResponsesResponses,
  ProfilesControllerRejectProfilesData,
  ProfilesControllerRejectProfilesResponses,
  ProfilesControllerStartLinkedinVolData,
  ProfilesControllerStartLinkedinVolResponses,
  ProfilesControllerUpdateData,
  ProfilesControllerUpdateProfileRiskData,
  ProfilesControllerUpdateProfileRiskResponses,
  ProfilesControllerUpdateResponses,
  ProfilesControllerUpdateTrustedCompanyData,
  ProfilesControllerUpdateTrustedCompanyResponses,
  ProfilesControllerVerifyPaypalData,
  ProfilesControllerVerifyPaypalResponses,
  ProfilesControllerVerifyWorkEmailData,
  ProfilesControllerVerifyWorkEmailResponses,
  ProgramsControllerAddProjectData,
  ProgramsControllerAddProjectResponses,
  ProgramsControllerArchiveData,
  ProgramsControllerArchiveResponses,
  ProgramsControllerCreateData,
  ProgramsControllerCreateResponses,
  ProgramsControllerFindAllData,
  ProgramsControllerFindAllResponses,
  ProgramsControllerFindByProjectData,
  ProgramsControllerFindByProjectResponses,
  ProgramsControllerFindOneData,
  ProgramsControllerFindOneResponses,
  ProgramsControllerFindParticipantsData,
  ProgramsControllerFindParticipantsResponses,
  ProgramsControllerUnarchiveData,
  ProgramsControllerUnarchiveResponses,
  ProgramsControllerUpdateData,
  ProgramsControllerUpdateResponses,
  ProjectMetricsControllerUpsertDailyMetricsData,
  ProjectMetricsControllerUpsertDailyMetricsResponses,
  ProjectsControllerAdminListData,
  ProjectsControllerAdminListResponses,
  ProjectsControllerAdminUpdateData,
  ProjectsControllerAdminUpdateResponses,
  ProjectsControllerArchiveData,
  ProjectsControllerArchiveResponses,
  ProjectsControllerAutoPauseProjectData,
  ProjectsControllerAutoPauseProjectResponses,
  ProjectsControllerAutoResumeProjectsData,
  ProjectsControllerAutoResumeProjectsResponses,
  ProjectsControllerBulkUpsertExternalQuestionsData,
  ProjectsControllerBulkUpsertExternalQuestionsResponses,
  ProjectsControllerCloseData,
  ProjectsControllerCloseResponses,
  ProjectsControllerCopyData,
  ProjectsControllerCopyResponses,
  ProjectsControllerCreateData,
  ProjectsControllerCreateResponses,
  ProjectsControllerDeleteProjectData,
  ProjectsControllerDeleteProjectResponses,
  ProjectsControllerFindAllData,
  ProjectsControllerFindAllForProjectApprovalData,
  ProjectsControllerFindAllForProjectApprovalResponses,
  ProjectsControllerFindAllProjectsForTeamData,
  ProjectsControllerFindAllProjectsForTeamResponses,
  ProjectsControllerFindAllRecruitingProjectsData,
  ProjectsControllerFindAllRecruitingProjectsResponses,
  ProjectsControllerFindAllResponses,
  ProjectsControllerFindOneData,
  ProjectsControllerFindOneDiyData,
  ProjectsControllerFindOneDiyResponses,
  ProjectsControllerFindOneResponses,
  ProjectsControllerGetComputedProjectMetricsData,
  ProjectsControllerGetComputedProjectMetricsResponses,
  ProjectsControllerGetExternalSchedulingEventTypesData,
  ProjectsControllerGetExternalSchedulingEventTypesResponses,
  ProjectsControllerGetPitchSuggestionsData,
  ProjectsControllerGetPitchSuggestionsErrors,
  ProjectsControllerGetPitchSuggestionsResponses,
  ProjectsControllerGetPlaidVerificationData,
  ProjectsControllerGetPlaidVerificationResponses,
  ProjectsControllerGetRecruitingProjectsDataData,
  ProjectsControllerGetRecruitingProjectsDataResponses,
  ProjectsControllerPauseData,
  ProjectsControllerPauseResponses,
  ProjectsControllerProcessAllProjectsAutoInviteData,
  ProjectsControllerProcessAllProjectsAutoInviteResponses,
  ProjectsControllerProcessAutoInviteData,
  ProjectsControllerProcessAutoInviteResponses,
  ProjectsControllerPublishAndUpdateTrustLevelData,
  ProjectsControllerPublishAndUpdateTrustLevelResponses,
  ProjectsControllerPublishData,
  ProjectsControllerPublishResponses,
  ProjectsControllerRejectProjectData,
  ProjectsControllerRejectProjectResponses,
  ProjectsControllerSendAutocompleteEmailsData,
  ProjectsControllerSendAutocompleteEmailsResponses,
  ProjectsControllerUpdateData,
  ProjectsControllerUpdateExternalSchedulingEventTypesData,
  ProjectsControllerUpdateExternalSchedulingEventTypesResponses,
  ProjectsControllerUpdateProjectMetricsData,
  ProjectsControllerUpdateProjectMetricsResponses,
  ProjectsControllerUpdateRecruitingStatusData,
  ProjectsControllerUpdateRecruitingStatusResponses,
  ProjectsControllerUpdateResponses,
  ProjectsControllerUploadFilesFormDataData,
  ProjectsControllerUploadFilesFormDataResponses,
  ProjectsControllerValidatePublishData,
  ProjectsControllerValidatePublishResponses,
  QuotaControllerCreateQuotaData,
  QuotaControllerCreateQuotaErrors,
  QuotaControllerCreateQuotaResponses,
  QuotaControllerGetQuotaByProjectIdData,
  QuotaControllerGetQuotaByProjectIdResponses,
  QuotaControllerUpdateQuotaData,
  QuotaControllerUpdateQuotaErrors,
  QuotaControllerUpdateQuotaResponses,
  QuotasControllerDeleteData,
  QuotasControllerDeleteErrors,
  QuotasControllerDeleteQuotaData,
  QuotasControllerDeleteQuotaErrors,
  QuotasControllerDeleteQuotaResponses,
  QuotasControllerDeleteResponses,
  QuotasControllerGetData,
  QuotasControllerGetErrors,
  QuotasControllerGetResponses,
  QuotasControllerPatchTargets2Data,
  QuotasControllerPatchTargets2Errors,
  QuotasControllerPatchTargets2Responses,
  QuotasControllerPatchTargetsData,
  QuotasControllerPatchTargetsErrors,
  QuotasControllerPatchTargetsResponses,
  QuotasControllerSetExternalFills2Data,
  QuotasControllerSetExternalFills2Errors,
  QuotasControllerSetExternalFills2Responses,
  QuotasControllerSetExternalFillsData,
  QuotasControllerSetExternalFillsErrors,
  QuotasControllerSetExternalFillsResponses,
  QuotasControllerUpsert2Data,
  QuotasControllerUpsert2Errors,
  QuotasControllerUpsert2Responses,
  QuotasControllerUpsertData,
  QuotasControllerUpsertErrors,
  QuotasControllerUpsertResponses,
  RateCardsControllerGetDefaultRateCardData,
  RateCardsControllerGetDefaultRateCardResponses,
  RateCardsControllerGetStandardPlanRateCardsData,
  RateCardsControllerGetStandardPlanRateCardsResponses,
  RateCardsControllerGetStandardPlanRatesData,
  RateCardsControllerGetStandardPlanRatesResponses,
  ResearcherProjectsControllerAddFollowerData,
  ResearcherProjectsControllerAddFollowerResponses,
  ResearcherProjectsControllerChatData,
  ResearcherProjectsControllerChatResponses,
  ResearcherProjectsControllerCheckProjectMediaEmbedData,
  ResearcherProjectsControllerCheckProjectMediaEmbedResponses,
  ResearcherProjectsControllerCreateData,
  ResearcherProjectsControllerCreateResponses,
  ResearcherProjectsControllerDownloadLegacyInsightsReportPdfData,
  ResearcherProjectsControllerDownloadLegacyInsightsReportPdfResponses,
  ResearcherProjectsControllerEvaluateInsightsReportChartData,
  ResearcherProjectsControllerEvaluateInsightsReportChartResponses,
  ResearcherProjectsControllerFindAllData,
  ResearcherProjectsControllerFindAllResponses,
  ResearcherProjectsControllerFindOneData,
  ResearcherProjectsControllerFindOneResponses,
  ResearcherProjectsControllerGeneratePreviewFollowUpData,
  ResearcherProjectsControllerGeneratePreviewFollowUpResponses,
  ResearcherProjectsControllerGenerateProjectMediaContextData,
  ResearcherProjectsControllerGenerateProjectMediaContextResponses,
  ResearcherProjectsControllerGetAllInterviewResponsesData,
  ResearcherProjectsControllerGetAllInterviewResponsesResponses,
  ResearcherProjectsControllerGetConceptReportData,
  ResearcherProjectsControllerGetConceptReportResponses,
  ResearcherProjectsControllerGetFeaturesSchemaVersionsData,
  ResearcherProjectsControllerGetFeaturesSchemaVersionsResponses,
  ResearcherProjectsControllerGetIncentiveRecommendationData,
  ResearcherProjectsControllerGetIncentiveRecommendationResponses,
  ResearcherProjectsControllerGetInsightsReportData,
  ResearcherProjectsControllerGetInsightsReportResponses,
  ResearcherProjectsControllerGetInsightsReportStatementsData,
  ResearcherProjectsControllerGetInsightsReportStatementsResponses,
  ResearcherProjectsControllerGetInterviewContentTranslationData,
  ResearcherProjectsControllerGetInterviewContentTranslationResponses,
  ResearcherProjectsControllerGetInterviewResponsesData,
  ResearcherProjectsControllerGetInterviewResponsesResponses,
  ResearcherProjectsControllerGetPricingMultiplierData,
  ResearcherProjectsControllerGetPricingMultiplierResponses,
  ResearcherProjectsControllerGetQuestionSummariesData,
  ResearcherProjectsControllerGetQuestionSummariesResponses,
  ResearcherProjectsControllerGetQuoteClipsData,
  ResearcherProjectsControllerGetQuoteClipsResponses,
  ResearcherProjectsControllerGetRecruitmentStatsData,
  ResearcherProjectsControllerGetRecruitmentStatsResponses,
  ResearcherProjectsControllerImportProjectMediaFromUrlData,
  ResearcherProjectsControllerImportProjectMediaFromUrlResponses,
  ResearcherProjectsControllerInitiateMessageAttachmentUploadData,
  ResearcherProjectsControllerInitiateMessageAttachmentUploadResponses,
  ResearcherProjectsControllerLaunchData,
  ResearcherProjectsControllerLaunchResponses,
  ResearcherProjectsControllerListFollowersData,
  ResearcherProjectsControllerListFollowersResponses,
  ResearcherProjectsControllerNotifyInsightsUpdatedData,
  ResearcherProjectsControllerNotifyInsightsUpdatedResponses,
  ResearcherProjectsControllerReExtractInterviewResponseData,
  ResearcherProjectsControllerReExtractInterviewResponseResponses,
  ResearcherProjectsControllerRegenerateInsightsReportData,
  ResearcherProjectsControllerRegenerateInsightsReportResponses,
  ResearcherProjectsControllerRemoveFollowerData,
  ResearcherProjectsControllerRemoveFollowerResponses,
  ResearcherProjectsControllerSearchInsightsReportStatementsData,
  ResearcherProjectsControllerSearchInsightsReportStatementsResponses,
  ResearcherProjectsControllerUpdateDraftData,
  ResearcherProjectsControllerUpdateDraftResponses,
  ResearcherProjectsControllerUpdateInsightsInclusionData,
  ResearcherProjectsControllerUpdateInsightsInclusionResponses,
  ResearcherProjectsControllerUpdateInterviewContentTranslationData,
  ResearcherProjectsControllerUpdateInterviewContentTranslationResponses,
  ResearcherProjectsControllerUpdatePublishedDetailsData,
  ResearcherProjectsControllerUpdatePublishedDetailsResponses,
  ResearcherProjectsControllerUploadMessageAttachmentData,
  ResearcherProjectsControllerUploadMessageAttachmentResponses,
  ResearcherProjectsControllerUploadNdaFileData,
  ResearcherProjectsControllerUploadNdaFileResponses,
  ResearcherProjectsControllerUploadProjectMediaData,
  ResearcherProjectsControllerUploadProjectMediaResponses,
  RespondentMessagesControllerCreateData,
  RespondentMessagesControllerCreateResponses,
  RespondentMessagesControllerGetThreadData,
  RespondentMessagesControllerGetThreadResponses,
  RespondentMessagesControllerMarkAllReadData,
  RespondentMessagesControllerMarkAllReadResponses,
  RespondentTransactionsControllerDownloadData,
  RespondentTransactionsControllerDownloadDeprecatedData,
  RespondentTransactionsControllerDownloadDeprecatedResponses,
  RespondentTransactionsControllerDownloadResponses,
  RespondentTransactionsControllerFindAllByTeamData,
  RespondentTransactionsControllerFindAllByTeamResponses,
  RespondentTransactionsControllerFindAllData,
  RespondentTransactionsControllerFindAllResponses,
  RespondentTransactionsControllerGetParticipantPaidCountData,
  RespondentTransactionsControllerGetParticipantPaidCountResponses,
  RoundtableVerificationsControllerFindAllData,
  RoundtableVerificationsControllerFindAllResponses,
  RoundtableVerificationsControllerFindOneData,
  RoundtableVerificationsControllerFindOneResponses,
  RoundtableVerificationsControllerRemoveData,
  RoundtableVerificationsControllerRemoveResponses,
  RoundtableVerificationsControllerTriggerRoundtableVerificationData,
  RoundtableVerificationsControllerTriggerRoundtableVerificationResponses,
  RoundtableVerificationsControllerUpdateData,
  RoundtableVerificationsControllerUpdateResponses,
  SchedulerEventsControllerCreateData,
  SchedulerEventsControllerCreateResponses,
  SchedulerEventsControllerDuplicateData,
  SchedulerEventsControllerDuplicateResponses,
  SchedulerEventsControllerGetByUidData,
  SchedulerEventsControllerGetByUidResponses,
  SchedulerEventsControllerListForProjectData,
  SchedulerEventsControllerListForProjectResponses,
  SchedulerEventsControllerRemoveData,
  SchedulerEventsControllerRemoveResponses,
  SchedulerEventsControllerUpdateData,
  SchedulerEventsControllerUpdateResponses,
  ScreenerFileUploadsControllerAbortData,
  ScreenerFileUploadsControllerAbortErrors,
  ScreenerFileUploadsControllerAbortResponses,
  ScreenerFileUploadsControllerCompleteData,
  ScreenerFileUploadsControllerCompleteErrors,
  ScreenerFileUploadsControllerCompleteResponses,
  ScreenerFileUploadsControllerInitiateData,
  ScreenerFileUploadsControllerInitiateErrors,
  ScreenerFileUploadsControllerInitiateResponses,
  ScreenerFileUploadsControllerUploadPartData,
  ScreenerFileUploadsControllerUploadPartErrors,
  ScreenerFileUploadsControllerUploadPartResponses,
  ScreenerQuestionsControllerBulkUpsertData,
  ScreenerQuestionsControllerBulkUpsertResponses,
  ScreenerQuestionsControllerCreateData,
  ScreenerQuestionsControllerCreateResponses,
  ScreenerQuestionsControllerFindAllData,
  ScreenerQuestionsControllerFindAllResponses,
  ScreenerQuestionsControllerFindOneData,
  ScreenerQuestionsControllerFindOneResponses,
  ScreenerQuestionsControllerOrderData,
  ScreenerQuestionsControllerOrderResponses,
  ScreenerQuestionsControllerRemoveData,
  ScreenerQuestionsControllerRemoveResponses,
  ScreenerQuestionsControllerSearchPreviouslyUsedData,
  ScreenerQuestionsControllerSearchPreviouslyUsedProjectsData,
  ScreenerQuestionsControllerSearchPreviouslyUsedProjectsResponses,
  ScreenerQuestionsControllerSearchPreviouslyUsedResponses,
  ScreenerQuestionsControllerUpdateData,
  ScreenerQuestionsControllerUpdateResponses,
  ScreenerQuestionsControllerValidateQuestionsData,
  ScreenerQuestionsControllerValidateQuestionsResponses,
  ScreenerResponsesControllerAutocompleteData,
  ScreenerResponsesControllerAutocompleteResponses,
  ScreenerResponsesControllerBatchInviteData,
  ScreenerResponsesControllerBatchInviteResponses,
  ScreenerResponsesControllerBatchUpdateMeetingInformationData,
  ScreenerResponsesControllerBatchUpdateMeetingInformationResponses,
  ScreenerResponsesControllerCancelBookingAndReinviteData,
  ScreenerResponsesControllerCancelBookingAndReinviteResponses,
  ScreenerResponsesControllerCancelBookingData,
  ScreenerResponsesControllerCancelBookingResponses,
  ScreenerResponsesControllerCancelInviteData,
  ScreenerResponsesControllerCancelInviteResponses,
  ScreenerResponsesControllerEnableRescheduleData,
  ScreenerResponsesControllerEnableRescheduleResponses,
  ScreenerResponsesControllerFavoriteData,
  ScreenerResponsesControllerFavoriteResponses,
  ScreenerResponsesControllerFindAllData,
  ScreenerResponsesControllerFindAllResponses,
  ScreenerResponsesControllerFindOneData,
  ScreenerResponsesControllerFindOneResponses,
  ScreenerResponsesControllerGetResponseCountByProjectIdData,
  ScreenerResponsesControllerGetResponseCountByProjectIdResponses,
  ScreenerResponsesControllerHideData,
  ScreenerResponsesControllerHideResponses,
  ScreenerResponsesControllerIngestExternalScreenerAnswersData,
  ScreenerResponsesControllerIngestExternalScreenerAnswersResponses,
  ScreenerResponsesControllerInsertEmailEventData,
  ScreenerResponsesControllerInsertEmailEventResponses,
  ScreenerResponsesControllerInsertTaskReminderEmailEventData,
  ScreenerResponsesControllerInsertTaskReminderEmailEventResponses,
  ScreenerResponsesControllerInviteData,
  ScreenerResponsesControllerInviteResponses,
  ScreenerResponsesControllerMarkAttendedData,
  ScreenerResponsesControllerMarkAttendedResponses,
  ScreenerResponsesControllerMarkNoShowData,
  ScreenerResponsesControllerMarkNoShowResponses,
  ScreenerResponsesControllerNextQuestionData,
  ScreenerResponsesControllerNextQuestionResponses,
  ScreenerResponsesControllerParticipantCancelBookingData,
  ScreenerResponsesControllerParticipantCancelBookingExternalData,
  ScreenerResponsesControllerParticipantCancelBookingExternalResponses,
  ScreenerResponsesControllerParticipantCancelBookingResponses,
  ScreenerResponsesControllerProcessAutoInviteByScreenerResponseIdData,
  ScreenerResponsesControllerProcessAutoInviteByScreenerResponseIdResponses,
  ScreenerResponsesControllerQualifyData,
  ScreenerResponsesControllerQualifyResponses,
  ScreenerResponsesControllerRejectedData,
  ScreenerResponsesControllerRejectedResponses,
  ScreenerResponsesControllerReportData,
  ScreenerResponsesControllerReportResponses,
  ScreenerResponsesControllerSaveBookingData,
  ScreenerResponsesControllerSaveBookingResponses,
  ScreenerResponsesControllerScheduleExternalData,
  ScreenerResponsesControllerScheduleExternalResponses,
  ScreenerResponsesControllerUpdateData,
  ScreenerResponsesControllerUpdateInvitationMessageData,
  ScreenerResponsesControllerUpdateInvitationMessageResponses,
  ScreenerResponsesControllerUpdateResponses,
  ScreenerResponsesControllerUpsertData,
  ScreenerResponsesControllerUpsertResponses,
  SecureFilesControllerCreateSignedUrlData,
  SecureFilesControllerCreateSignedUrlResponses,
  SkillsControllerFindAllData,
  SkillsControllerFindAllResponses,
  SkillsControllerFindOneData,
  SkillsControllerFindOneResponses,
  StudyChecksControllerCheckData,
  StudyChecksControllerCheckResponses,
  StudyChecksControllerFeedbackData,
  StudyChecksControllerFeedbackResponses,
  StudyChecksControllerRecordEventsData,
  StudyChecksControllerRecordEventsResponses,
  SuggestionsControllerGetIncentiveSuggestionData,
  SuggestionsControllerGetIncentiveSuggestionErrors,
  SuggestionsControllerGetIncentiveSuggestionResponses,
  SurveyResponsesControllerDownloadData,
  SurveyResponsesControllerDownloadDeprecatedData,
  SurveyResponsesControllerDownloadDeprecatedResponses,
  SurveyResponsesControllerDownloadResponses,
  SurveyResponsesControllerFindAllProjectResponsesData,
  SurveyResponsesControllerFindAllProjectResponsesResponses,
  SurveyResponsesControllerGetSurveyResponseByUserAndProjectData,
  SurveyResponsesControllerGetSurveyResponseByUserAndProjectResponses,
  SurveyResponsesControllerGetSurveyResponseData,
  SurveyResponsesControllerGetSurveyResponseResponses,
  SurveyResponsesControllerProfileParticipationStatsData,
  SurveyResponsesControllerProfileParticipationStatsResponses,
  SurveyResponsesControllerUpdateVisibilityByUserIdData,
  SurveyResponsesControllerUpdateVisibilityByUserIdResponses,
  SynchronizeControllerAddTestOrgUserData,
  SynchronizeControllerAddTestOrgUserResponses,
  SynchronizeControllerRemoveTestOrgUserData,
  SynchronizeControllerRemoveTestOrgUserResponses,
  SynchronizeControllerSyncOrganizationData,
  SynchronizeControllerSyncOrganizationResponses,
  SynchronizeControllerSyncTeamData,
  SynchronizeControllerSyncTeamResponses,
  SynchronizeControllerSyncUserData,
  SynchronizeControllerSyncUserResponses,
  SystemParamsControllerFindAllData,
  SystemParamsControllerFindAllResponses,
  SystemParamsControllerGetSystemParamByNameData,
  SystemParamsControllerGetSystemParamByNameErrors,
  SystemParamsControllerGetSystemParamByNameResponses,
  TeamRespondentsControllerBatchInviteData,
  TeamRespondentsControllerBatchInviteResponses,
  TeamRespondentsControllerFindAllData,
  TeamRespondentsControllerFindAllResponses,
  TeamRespondentsControllerFindOneData,
  TeamRespondentsControllerFindOneResponses,
  TeamsControllerCreateJoinRequestData,
  TeamsControllerCreateJoinRequestResponses,
  TeamsControllerFindAllForOrganizationData,
  TeamsControllerFindAllForOrganizationResponses,
  TeamsControllerFindOneData,
  TeamsControllerFindOneResponses,
  TeamsControllerFindTeamMembersData,
  TeamsControllerFindTeamMembersResponses,
  TeamsControllerGetAllTeamsWithUserJoinRequestData,
  TeamsControllerGetAllTeamsWithUserJoinRequestResponses,
  TeamsControllerGetBalanceManagementSettingsData,
  TeamsControllerGetBalanceManagementSettingsResponses,
  TeamsControllerUpdateBalanceManagementSettingsData,
  TeamsControllerUpdateBalanceManagementSettingsResponses,
  TeamsControllerUpdateJoinRequestData,
  TeamsControllerUpdateJoinRequestResponses,
  TeamsControllerUploadFilesFormDataData,
  TeamsControllerUploadFilesFormDataResponses,
  TestSetupControllerAddFeatureFlagAllowOrganizationData,
  TestSetupControllerAddFeatureFlagAllowOrganizationResponses,
  TestSetupControllerAddFeatureFlagDenyOrganizationData,
  TestSetupControllerAddFeatureFlagDenyOrganizationResponses,
  TestSetupControllerBulkUpsertScreenerQuestionsData,
  TestSetupControllerBulkUpsertScreenerQuestionsResponses,
  TestSetupControllerCreateProjectData,
  TestSetupControllerCreateProjectResponses,
  TestSetupControllerDeleteProjectDataData,
  TestSetupControllerDeleteProjectDataResponses,
  TestSetupControllerDeleteSurveyResponsesData,
  TestSetupControllerDeleteSurveyResponsesResponses,
  TestSetupControllerDeleteUserDataData,
  TestSetupControllerDeleteUserDataResponses,
  TestSetupControllerFindUserByEmailData,
  TestSetupControllerFindUserByEmailResponses,
  TestSetupControllerGetUserVerificationTokenData,
  TestSetupControllerGetUserVerificationTokenResponses,
  TestSetupControllerGetWorkEmailVerificationCodeData,
  TestSetupControllerGetWorkEmailVerificationCodeResponses,
  TestSetupControllerGetWorkEmailVerificationLinkData,
  TestSetupControllerGetWorkEmailVerificationLinkResponses,
  TestSetupControllerInviteScreenerResponseData,
  TestSetupControllerInviteScreenerResponseResponses,
  TestSetupControllerPublishProjectData,
  TestSetupControllerPublishProjectResponses,
  TestSetupControllerRecomputeProfileRiskData,
  TestSetupControllerRecomputeProfileRiskResponses,
  TestSetupControllerRemoveFeatureFlagAllowOrganizationData,
  TestSetupControllerRemoveFeatureFlagAllowOrganizationResponses,
  TestSetupControllerRemoveFeatureFlagDenyOrganizationData,
  TestSetupControllerRemoveFeatureFlagDenyOrganizationResponses,
  TestSetupControllerSetProfileRiskSignalsData,
  TestSetupControllerSetProfileRiskSignalsResponses,
  TestSetupControllerUpdateTestUserData,
  TestSetupControllerUpdateTestUserResponses,
  TopicsControllerFindAllData,
  TopicsControllerFindAllResponses,
  TopicsControllerFindOneData,
  TopicsControllerFindOneResponses,
  UsersControllerAcceptTermsData,
  UsersControllerAcceptTermsResponses,
  UsersControllerAddProviderData,
  UsersControllerAddProviderResponses,
  UsersControllerCreateData,
  UsersControllerCreateResponses,
  UsersControllerDeleteGhostUsersData,
  UsersControllerDeleteGhostUsersErrors,
  UsersControllerDeleteGhostUsersResponses,
  UsersControllerDeleteProviderData,
  UsersControllerDeleteProviderResponses,
  UsersControllerFindByEmailData,
  UsersControllerFindByEmailResponses,
  UsersControllerFindManyByIdsData,
  UsersControllerFindManyByIdsResponses,
  UsersControllerFindOneData,
  UsersControllerFindOneResponses,
  UsersControllerGdprDeleteData,
  UsersControllerGdprDeleteResponses,
  UsersControllerGetCalendlyEventTypesData,
  UsersControllerGetCalendlyEventTypesResponses,
  UsersControllerIsCalendlyTokenValidData,
  UsersControllerIsCalendlyTokenValidResponses,
  UsersControllerIsZoomTokenValidData,
  UsersControllerIsZoomTokenValidResponses,
  UsersControllerResendVerificationEmailData,
  UsersControllerResendVerificationEmailResponses,
  UsersControllerSearchData,
  UsersControllerSearchResponses,
  UsersControllerUpdateData,
  UsersControllerUpdateResponses,
  UsersControllerUploadFilesFormDataData,
  UsersControllerUploadFilesFormDataResponses,
  UsersSessionsControllerCreateData,
  UsersSessionsControllerCreateResponses,
  UsersSessionsControllerGetOneByUserIdData,
  UsersSessionsControllerGetOneByUserIdResponses,
  VerificationControllerCreateData,
  VerificationControllerCreateResponses,
  VerificationControllerVerifyCodeData,
  VerificationControllerVerifyCodeResponses,
  VerificationsControllerGetPlaidVerificationLinkTokenData,
  VerificationsControllerGetPlaidVerificationLinkTokenResponses,
  VerificationsControllerPatchPersonaInquiryData,
  VerificationsControllerPatchPersonaInquiryResponses,
  VerificationsControllerPatchPlaidSessionData,
  VerificationsControllerPatchPlaidSessionResponses,
  VerificationsControllerTwilioCreateData,
  VerificationsControllerTwilioCreateResponses,
  VerificationsControllerTwilioVerifyCodeData,
  VerificationsControllerTwilioVerifyCodeResponses,
  WebhooksControllerCreateData,
  WebhooksControllerCreateResponses,
  WebhooksControllerDeactivateData,
  WebhooksControllerDeactivateResponses,
  WebhooksControllerFindAllData,
  WebhooksControllerFindAllResponses,
  WebhooksControllerFindEventTypesData,
  WebhooksControllerFindEventTypesResponses,
  WebhooksControllerFindOneData,
  WebhooksControllerFindOneResponses,
  WebhooksControllerSimulateData,
  WebhooksControllerSimulateResponses,
  WebhooksOrganizationsControllerCreateData,
  WebhooksOrganizationsControllerCreateResponses,
  WebhooksOrganizationsControllerDeactivateData,
  WebhooksOrganizationsControllerDeactivateResponses,
  WebhooksOrganizationsControllerFindAllData,
  WebhooksOrganizationsControllerFindAllResponses,
  WebhooksOrganizationsControllerFindEventTypesData,
  WebhooksOrganizationsControllerFindEventTypesResponses,
  WebhooksOrganizationsControllerFindOneData,
  WebhooksOrganizationsControllerFindOneResponses,
  WebhooksOrganizationsControllerSimulateData,
  WebhooksOrganizationsControllerSimulateResponses,
  WebhooksReceivedControllerCreateData,
  WebhooksReceivedControllerCreateResponses,
  WebhooksReceivedControllerDeleteData,
  WebhooksReceivedControllerDeleteResponses,
  WebhooksReceivedControllerFindAllData,
  WebhooksReceivedControllerFindAllResponses,
  WebhooksReceivedControllerTestData,
  WebhooksReceivedControllerTestResponses,
} from './types.gen';

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Return all action audit logs
 */
export const actionAuditLogControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ActionAuditLogControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ActionAuditLogControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/action-audit-log',
    ...options,
  });

/**
 * Create an action audit log
 */
export const actionAuditLogControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ActionAuditLogControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ActionAuditLogControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/action-audit-log',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const analyticsSnapshotsControllerGetSnapshots = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AnalyticsSnapshotsControllerGetSnapshotsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AnalyticsSnapshotsControllerGetSnapshotsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/analytics-snapshots',
    ...options,
  });

export const analyticsSnapshotsControllerGetOrganizationSnapshots = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AnalyticsSnapshotsControllerGetOrganizationSnapshotsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    AnalyticsSnapshotsControllerGetOrganizationSnapshotsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/analytics-snapshots/organizations',
    ...options,
  });

export const apiPartnerControllerListCredentials = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ApiPartnerControllerListCredentialsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiPartnerControllerListCredentialsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/api-partner/credentials',
    ...options,
  });

export const apiPartnerControllerLookup = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ApiPartnerControllerLookupData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiPartnerControllerLookupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/api-partner/lookup',
    ...options,
  });

/**
 * Provisions api-partner credentials. Admin-level by design; the acting
 * admin is recorded on the audit trail.
 */
export const apiPartnerControllerProvision = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiPartnerControllerProvisionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiPartnerControllerProvisionResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/api-partner/provision',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Disables (soft-deletes) an api-partner credential. Admin-level by design;
 * the acting admin is recorded on the audit trail.
 */
export const apiPartnerControllerDisableCredential = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiPartnerControllerDisableCredentialData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ApiPartnerControllerDisableCredentialResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/api-partner/credentials/{clientId}',
    ...options,
  });

/**
 * Create the researcher account an API partner needs
 *
 * Non-production only. Creates only what is missing: the researcher user, an organization with its default team, and a v3 pay-as-you-go plan on that team. Never returns credentials or passwords; a new user signs in through the password-reset flow.
 */
export const apiPartnerControllerEnsureAccount = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiPartnerControllerEnsureAccountData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiPartnerControllerEnsureAccountResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/api-partner/ensure-account',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create or update client-auth entry;
 * To update an existing client-auth you must pass in a client-id to update an existing entry.
 * If no client-id is passed in, a new client-id will be generated.
 */
export const clientAuthControllerUpsertToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClientAuthControllerUpsertTokenData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ClientAuthControllerUpsertTokenResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/client-auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Mark client-auth entry as deleted. Will no longer be valid for authentication.
 * Deleting an already-deleted entry succeeds without changing anything.
 */
export const clientAuthControllerDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClientAuthControllerDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ClientAuthControllerDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/client-auth/{clientId}',
    ...options,
  });

/**
 * Returns organization for client-auth entry
 */
export const clientAuthControllerAuthenticate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClientAuthControllerAuthenticateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ClientAuthControllerAuthenticateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/client-auth/authenticate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a user. Respondents only — `NotImplementedException` otherwise.
 *
 * Two callers provision participant test accounts through this, both outside
 * production:
 * - `serverless/public-api` → `POST /v1/profiles` ("Create test participant",
 * excluded from production), which partners use to seed accounts for their
 * own automated testing.
 * - `e2e/ui-tests` → `ApiClient.seedParticipant`, used by the active
 * advanced-attributes and self-serve specs.
 *
 * Real signup bypasses this controller (`AuthController.participantSignup`
 * → `UsersService.create` in-process), so this route sees no production
 * traffic — but deleting it would break API-partner test-account
 * provisioning and the e2e suite.
 *
 * Adding a user-creation side effect? This path does NOT get what signup
 * gets, and nothing here backfills it. `AuthService` stamps terms acceptance
 * during signup; a user created through this route has none, so every caller
 * records it itself afterwards — the public API via
 * `PUT /users/terms-acceptance/:audience`, `e2e/ui-tests` via
 * `ApiClient.acceptCurrentTerms`. Add a caller and you inherit that
 * obligation; add a side effect and you have to reach all of them.
 */
export const usersControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UsersControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find a user by id.
 *
 * On the hot path for all production public-API traffic: the public API's
 * auth guard (`serverless/public-api/src/guards/auth.guard.ts`) calls this to
 * resolve the credential's owning user on EVERY request. Internal flows use
 * the legacy `GET /users/:id` instead.
 */
export const usersControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}',
    ...options,
  });

/**
 * Admin route for updating a user.
 *
 * NOT unused (a previous note here claimed no caller): the legacy admin
 * Researchers page's trust-level modal calls this via the website `/api/v4`
 * proxy (`website/apps/legacy/admin/researchers/researcher.resource.js`).
 * The new admin uses `PATCH /v4/admin/researchers/:userId` instead (which
 * also writes the action audit log this route skips); this stays until the
 * legacy admin is decommissioned.
 */
export const usersControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UsersControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * GDPR delete a user by id.
 *
 *
 * audit note above.
 *
 * @deprecated
 */
export const usersControllerGdprDelete = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerGdprDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    UsersControllerGdprDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/gdpr/{userId}',
    ...options,
  });

/**
 * Find a user by email.
 *
 *
 * audit note above.
 *
 * @deprecated
 */
export const usersControllerFindByEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerFindByEmailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersControllerFindByEmailResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/email/{email}',
    ...options,
  });

export const usersControllerUploadFilesFormData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerUploadFilesFormDataData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UsersControllerUploadFilesFormDataResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}/files/form-data',
    ...options,
  });

/**
 * See if zoom provider token is up to date.
 */
export const usersControllerIsZoomTokenValid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerIsZoomTokenValidData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersControllerIsZoomTokenValidResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}/providers/zoom/valid-token',
    ...options,
  });

/**
 * See if Calendly provider token is up to date.
 *
 *
 * audit note above.
 *
 * @deprecated
 */
export const usersControllerIsCalendlyTokenValid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerIsCalendlyTokenValidData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersControllerIsCalendlyTokenValidResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}/providers/calendly/valid-token',
    ...options,
  });

/**
 * Get Calendly event types for a user.
 *
 *
 * audit note above.
 *
 * @deprecated
 */
export const usersControllerGetCalendlyEventTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerGetCalendlyEventTypesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersControllerGetCalendlyEventTypesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}/calendly/event-types',
    ...options,
  });

/**
 * Add an OAuth provider for a user.
 * For Calendly providers, this also creates the webhook subscription.
 *
 *
 * audit note above.
 *
 * @deprecated
 */
export const usersControllerAddProvider = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerAddProviderData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UsersControllerAddProviderResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}/providers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete/disconnect a provider from a user.
 *
 *
 * audit note above.
 *
 * @deprecated
 */
export const usersControllerDeleteProvider = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerDeleteProviderData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    UsersControllerDeleteProviderResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/{userId}/providers/{providerKey}',
    ...options,
  });

export const usersControllerResendVerificationEmail = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<UsersControllerResendVerificationEmailData, ThrowOnError>,
) =>
  (options?.client ?? client).put<
    UsersControllerResendVerificationEmailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/resend-verification-email',
    ...options,
  });

export const usersControllerAcceptTerms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerAcceptTermsData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UsersControllerAcceptTermsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/terms-acceptance/{audience}',
    ...options,
  });

export const usersControllerSearch = <ThrowOnError extends boolean = false>(
  options: Options<UsersControllerSearchData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UsersControllerSearchResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetch users by a bounded list of ids. Used by the matching recruitment cron
 * to pull a batch's users in one request (e.g. to read lastLoginAt) instead
 * of a findOne per user. `userIds` is required and capped, keeping the query
 * a bounded `_id` $in lookup.
 */
export const usersControllerFindManyByIds = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersControllerFindManyByIdsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UsersControllerFindManyByIdsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/by-ids',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * This endpoint is used to delete all Ghost Inspector users in database.
 * Note: We obfuscate the delete users in Postgres, so you will not find them in DB by name and email,
 * but other information still exists there.
 *
 *
 * audit note above.
 *
 * @deprecated
 */
export const usersControllerDeleteGhostUsers = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<UsersControllerDeleteGhostUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    UsersControllerDeleteGhostUsersResponses,
    UsersControllerDeleteGhostUsersErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users/ghost',
    ...options,
  });

/**
 * Find all active system params.
 */
export const systemParamsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SystemParamsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    SystemParamsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/system-params',
    ...options,
  });

/**
 * Find the system params by name.
 */
export const systemParamsControllerGetSystemParamByName = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SystemParamsControllerGetSystemParamByNameData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    SystemParamsControllerGetSystemParamByNameResponses,
    SystemParamsControllerGetSystemParamByNameErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/system-params/{name}',
    ...options,
  });

/**
 * Create a message in a conversation.
 */
export const messagesControllerCreateMessage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagesControllerCreateMessageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagesControllerCreateMessageResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}/messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all messages for a user.
 * Will return messages from both the researcher and the participant.
 *
 * `conversation.metadata.externalResearcherId` can be used to link the message to an external researcher.
 *
 * `conversation.metadata.projectId` can be used to link the message to a project.
 */
export const messagesControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<MessagesControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    MessagesControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/messages',
    ...options,
  });

/**
 * Use POST /messaging/conversations/:conversationUid/message
 *
 * Use `POST /messaging/conversations/:conversationUid/message`.
 *
 * @deprecated
 */
export const messagesControllerCreateDeprecated = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagesControllerCreateDeprecatedData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagesControllerCreateDeprecatedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * The caller's own cross-project inbox summary (unread conversation
 * count). Unlike the team-scoped inbox below, this needs no team — it is
 * scoped by the caller's messaging identity, so participants can use it
 * (the participant nav unread badge).
 */
export const messagesControllerGetUserInbox = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<MessagesControllerGetUserInboxData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    MessagesControllerGetUserInboxResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/inbox',
    ...options,
  });

/**
 * Get unread message counts for a batch of projects.
 */
export const messagesControllerGetProjectUnreadCounts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagesControllerGetProjectUnreadCountsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagesControllerGetProjectUnreadCountsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/teams/{teamId}/messages/unread-counts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all conversations with unread messages.
 */
export const messagesControllerGetInbox = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagesControllerGetInboxData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MessagesControllerGetInboxResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/teams/{teamId}/messages/inbox',
    ...options,
  });

export const messagesControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<MessagesControllerDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    MessagesControllerDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/messages/{messageUid}',
    ...options,
  });

/**
 * Get a message by its UID.
 */
export const messagesControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<MessagesControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MessagesControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/messages/{messageUid}',
    ...options,
  });

/**
 * Get all conversations.
 */
export const conversationsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ConversationsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ConversationsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations',
    ...options,
  });

/**
 * Create a conversation.
 * This must be done before sending a message.
 */
export const conversationsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ConversationsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a conversation by its UID.
 */
export const conversationsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ConversationsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}',
    ...options,
  });

/**
 * Get a conversation by its UID.
 */
export const conversationsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ConversationsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}',
    ...options,
  });

/**
 * Update a conversation by its UID.
 */
export const conversationsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ConversationsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Mark a conversation as read.
 */
export const conversationsControllerMarkAsRead = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerMarkAsReadData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ConversationsControllerMarkAsReadResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}/read',
    ...options,
  });

/**
 * Upload a file to attach to a message in a conversation the caller belongs
 * to. Open to respondents as well as researchers — access is enforced by the
 * caller's messaging token, which only resolves conversations they
 * participate in. Returns the durable S3 bucket key (stored on the message
 * so the URL can be re-signed) and a freshly-signed preview URL.
 */
export const conversationsControllerUploadAttachment = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerUploadAttachmentData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ConversationsControllerUploadAttachmentResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}/attachment',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Start a chunked upload of a file to attach to a message in a conversation
 * the caller belongs to. For files too large for the single-request upload
 * above (e.g. diary videos); continue with `messaging/attachment-uploads*`.
 */
export const conversationsControllerInitiateAttachmentUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ConversationsControllerInitiateAttachmentUploadData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ConversationsControllerInitiateAttachmentUploadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}/attachment-uploads/initiate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a participant from a conversation.
 */
export const conversationsControllerRemoveParticipant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerRemoveParticipantData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ConversationsControllerRemoveParticipantResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}/participants/{participantUserId}',
    ...options,
  });

/**
 * Add a participant to a conversation.
 */
export const conversationsControllerAddParticipant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConversationsControllerAddParticipantData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ConversationsControllerAddParticipantResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/conversations/{conversationUid}/participants/{participantUserId}',
    ...options,
  });

export const messagingOrganizationsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingOrganizationsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MessagingOrganizationsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/organizations/{organizationId}',
    ...options,
  });

export const messagingOrganizationsControllerCreateOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MessagingOrganizationsControllerCreateOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MessagingOrganizationsControllerCreateOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/organizations/{organizationId}',
    ...options,
  });

export const messagingOrganizationsControllerUpdateOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MessagingOrganizationsControllerUpdateOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    MessagingOrganizationsControllerUpdateOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/organizations/{organizationId}',
    ...options,
  });

export const messagingOrganizationsControllerCreateTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MessagingOrganizationsControllerCreateTeamData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MessagingOrganizationsControllerCreateTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/organizations/{organizationId}/teams/{teamForeignId}',
    ...options,
  });

export const messagingOrganizationsControllerUpdateTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MessagingOrganizationsControllerUpdateTeamData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    MessagingOrganizationsControllerUpdateTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/organizations/{organizationId}/teams/{teamForeignId}',
    ...options,
  });

export const messagingOrganizationsControllerFindTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingOrganizationsControllerFindTeamData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MessagingOrganizationsControllerFindTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/organizations/{organizationUid}/teams/{teamForeignId}',
    ...options,
  });

export const messagingUsersControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingUsersControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagingUsersControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/users/{userId}',
    ...options,
  });

export const messagingUsersControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingUsersControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    MessagingUsersControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/users/{userId}',
    ...options,
  });

export const messagingUsersControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingUsersControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MessagingUsersControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/users/{userUid}',
    ...options,
  });

export const messagingUsersControllerFindOneByEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingUsersControllerFindOneByEmailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MessagingUsersControllerFindOneByEmailResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/users/find/{email}',
    ...options,
  });

export const synchronizeControllerSyncUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SynchronizeControllerSyncUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SynchronizeControllerSyncUserResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/synchronize/users/{userId}',
    ...options,
  });

export const synchronizeControllerSyncOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SynchronizeControllerSyncOrganizationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SynchronizeControllerSyncOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/synchronize/organizations/{organizationId}',
    ...options,
  });

export const synchronizeControllerSyncTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SynchronizeControllerSyncTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SynchronizeControllerSyncTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/synchronize/teams/{teamId}',
    ...options,
  });

/**
 * Only to be used for testing purposes via the PublicAPI e2e tests.
 * LongTerm: Remove this method when OrganizationController implements the same functionality.
 */
export const synchronizeControllerRemoveTestOrgUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SynchronizeControllerRemoveTestOrgUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    SynchronizeControllerRemoveTestOrgUserResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/synchronize/testOrgUser/organizations/{organizationId}/users/{userId}',
    ...options,
  });

/**
 * Only to be used for testing purposes via the PublicAPI e2e tests.
 * LongTerm: Remove this method when OrganizationController implements the same functionality.
 */
export const synchronizeControllerAddTestOrgUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SynchronizeControllerAddTestOrgUserData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    SynchronizeControllerAddTestOrgUserResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/synchronize/testOrgUser/organizations/{organizationId}/users/{userId}',
    ...options,
  });

/**
 * Toggles a feature flag's global active state. Restricted to users with the
 * `developer` role — RoleGuard enforces developer-only declarations against
 * the acting principal, admins included.
 */
export const featureFlagsControllerSetActive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FeatureFlagsControllerSetActiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    FeatureFlagsControllerSetActiveResponses,
    FeatureFlagsControllerSetActiveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feature-flags/{id}/active',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Adds an organization to a feature flag's allow or deny list. Restricted to
 * developers (enforced explicitly here — see the note on `setActive`).
 */
export const featureFlagsControllerAddOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FeatureFlagsControllerAddOrganizationData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    FeatureFlagsControllerAddOrganizationResponses,
    FeatureFlagsControllerAddOrganizationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feature-flags/{id}/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Removes an organization from a feature flag's allow or deny list.
 * Restricted to developers (enforced explicitly here — see `setActive`).
 */
export const featureFlagsControllerRemoveOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FeatureFlagsControllerRemoveOrganizationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    FeatureFlagsControllerRemoveOrganizationResponses,
    FeatureFlagsControllerRemoveOrganizationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feature-flags/{id}/organizations/{organizationId}',
    ...options,
  });

/**
 * Lists every feature flag with its allow/deny organizations resolved to
 * `{ id, name }`. Used by the admin dashboard to manage feature flags.
 */
export const featureFlagsControllerListAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<FeatureFlagsControllerListAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    FeatureFlagsControllerListAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feature-flags/all',
    ...options,
  });

/**
 * This endpoint is used to find all active feature flags.
 */
export const featureFlagsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<FeatureFlagsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    FeatureFlagsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feature-flags',
    ...options,
  });

/**
 * This endpoint is used to find the specific feature flag that you want, and tells you if it is active.
 */
export const featureFlagsControllerGetFeatureFlagActive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    FeatureFlagsControllerGetFeatureFlagActiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    FeatureFlagsControllerGetFeatureFlagActiveResponses,
    FeatureFlagsControllerGetFeatureFlagActiveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feature-flags/{name}/active',
    ...options,
  });

export const secureFilesControllerCreateSignedUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SecureFilesControllerCreateSignedUrlData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SecureFilesControllerCreateSignedUrlResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/secure-files/signed-url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload one part of a message attachment
 */
export const messageAttachmentUploadsControllerUploadPart = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MessageAttachmentUploadsControllerUploadPartData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MessageAttachmentUploadsControllerUploadPartResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/attachment-uploads/upload-part',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete a chunked message-attachment upload
 */
export const messageAttachmentUploadsControllerComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MessageAttachmentUploadsControllerCompleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MessageAttachmentUploadsControllerCompleteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/attachment-uploads/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Abort a chunked message-attachment upload
 */
export const messageAttachmentUploadsControllerAbort = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessageAttachmentUploadsControllerAbortData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessageAttachmentUploadsControllerAbortResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/messaging/attachment-uploads/abort',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPlansControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPlansControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingPlansControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/plans',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPlansControllerGetStandardPlansSummary = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PricingPlansControllerGetStandardPlansSummaryData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    PricingPlansControllerGetStandardPlansSummaryResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/plans/standard',
    ...options,
  });

export const pricingPlansControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPlansControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingPlansControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/plans/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPlansControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPlansControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    PricingPlansControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/plans/{id}',
    ...options,
  });

export const pricingPlansControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPlansControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingPlansControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/plans/{id}',
    ...options,
  });

export const pricingPlansControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPlansControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingPlansControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/plans/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * TODO should be replaced in the admin UI before removal
 *
 * @deprecated
 */
export const rateCardsControllerGetStandardPlanRates = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RateCardsControllerGetStandardPlanRatesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    RateCardsControllerGetStandardPlanRatesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/rate-cards/rates/standard',
    ...options,
  });

/**
 * TODO should be replaced in the researcher/admin UI before removal
 *
 * @deprecated
 */
export const rateCardsControllerGetDefaultRateCard = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RateCardsControllerGetDefaultRateCardData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    RateCardsControllerGetDefaultRateCardResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/rate-cards/default',
    ...options,
  });

/**
 * TODO should be replaced in the researcher/admin UI before removal
 *
 * @deprecated
 */
export const rateCardsControllerGetStandardPlanRateCards = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RateCardsControllerGetStandardPlanRateCardsData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    RateCardsControllerGetStandardPlanRateCardsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/rate-cards/standard',
    ...options,
  });

export const adminResearchersControllerList = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminResearchersControllerListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminResearchersControllerListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/researchers/list',
    ...options,
  });

export const adminResearchersControllerUpdateResearcher = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminResearchersControllerUpdateResearcherData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    AdminResearchersControllerUpdateResearcherResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/researchers/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminTeamsControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<AdminTeamsControllerListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminTeamsControllerListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/teams/list',
    ...options,
  });

/**
 * Block a work-email domain or TLD and remediate participants already on it
 *
 * Block a work-email domain or TLD and remediate participants already on it.
 * Defaults to a dry run; send `dryRun: false` to apply.
 */
export const fraudWorkDomainsControllerBlockWorkDomain = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FraudWorkDomainsControllerBlockWorkDomainData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FraudWorkDomainsControllerBlockWorkDomainResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/fraud-work-domains',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * requests page, latest request first.
 */
export const adminFulfillmentRequestsControllerList = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminFulfillmentRequestsControllerListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminFulfillmentRequestsControllerListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/fulfillment-requests/list',
    ...options,
  });

export const manualReviewControllerFindManualReviewResponses = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ManualReviewControllerFindManualReviewResponsesData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ManualReviewControllerFindManualReviewResponsesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/manual-review',
    ...options,
  });

export const manualReviewControllerParticipantIpSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManualReviewControllerParticipantIpSummaryData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ManualReviewControllerParticipantIpSummaryResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/users/{userId}/ip-summary',
    ...options,
  });

export const manualReviewControllerApproveManualReviewResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManualReviewControllerApproveManualReviewResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ManualReviewControllerApproveManualReviewResponseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/manual-review/{responseId}/approve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const manualReviewControllerRejectManualReviewResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManualReviewControllerRejectManualReviewResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ManualReviewControllerRejectManualReviewResponseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/manual-review/{responseId}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const manualReviewControllerReportManualReviewResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManualReviewControllerReportManualReviewResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ManualReviewControllerReportManualReviewResponseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/manual-review/{responseId}/report',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const manualReviewControllerParticipantFlagHistory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManualReviewControllerParticipantFlagHistoryData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ManualReviewControllerParticipantFlagHistoryResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/users/{userId}/flag-history',
    ...options,
  });

export const manualReviewControllerParticipantIdentityVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManualReviewControllerParticipantIdentityVerificationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ManualReviewControllerParticipantIdentityVerificationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/users/{userId}/identity-verification',
    ...options,
  });

export const screenerResponsesControllerBatchInvite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerBatchInviteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerBatchInviteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/batch-invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerNextQuestion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerNextQuestionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ScreenerResponsesControllerNextQuestionResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/next-question',
    ...options,
  });

export const screenerResponsesControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ScreenerResponsesControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses',
    ...options,
  });

export const screenerResponsesControllerUpsert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerUpsertData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ScreenerResponsesControllerUpsertResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerGetResponseCountByProjectId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerGetResponseCountByProjectIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ScreenerResponsesControllerGetResponseCountByProjectIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/count',
    ...options,
  });

export const screenerResponsesControllerUpdateInvitationMessage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerUpdateInvitationMessageData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerUpdateInvitationMessageResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/invitation-message',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Updates moderated meeting information for multiple screener responses at once
 */
export const screenerResponsesControllerBatchUpdateMeetingInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerBatchUpdateMeetingInformationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerBatchUpdateMeetingInformationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/batch-update-meeting-information',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ScreenerResponsesControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}',
    ...options,
  });

export const screenerResponsesControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Auto-invites screener response for a published, unexpired, not-closed
 * project with auto-invite enabled (regardless of recruiting status)
 */
export const screenerResponsesControllerProcessAutoInviteByScreenerResponseId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ScreenerResponsesControllerProcessAutoInviteByScreenerResponseIdData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).patch<
      ScreenerResponsesControllerProcessAutoInviteByScreenerResponseIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/process-auto-invite',
      ...options,
    });

export const screenerResponsesControllerSaveBooking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerSaveBookingData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerSaveBookingResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/save-booking',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerReport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerReportData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerReportResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/report',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerFavorite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerFavoriteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/favorite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * External-screener flow (WS5): bulk-ingest partner external-screener answers.
 * Rows upsert idempotently per questionId while the response is
 * EXTERNAL_SCREENER_IN_PROGRESS; covering every declared external question
 * (or `complete: true`) performs the IN_PROGRESS → PENDING promotion with
 * the derived verdict.
 */
export const screenerResponsesControllerIngestExternalScreenerAnswers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerIngestExternalScreenerAnswersData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ScreenerResponsesControllerIngestExternalScreenerAnswersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/external-screener-answers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerQualify = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerQualifyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerQualifyResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/qualify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerHide = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerHideData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerHideResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/hide',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Once the invite is sent, here's what to expect:
 * - The respondent will receive an email and text message
 * - Invitations cannot be undone. They include your name, project name, and session link (for remote interviews).
 * - Email reminders are sent 5 days, 1 day, and 4 hours prior to booked time.
 */
export const screenerResponsesControllerInvite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerInviteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerInviteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerScheduleExternal = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerScheduleExternalData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerScheduleExternalResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/schedule-external',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerMarkAttended = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerMarkAttendedData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerMarkAttendedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/attended',
    ...options,
  });

export const screenerResponsesControllerCancelBookingAndReinvite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerCancelBookingAndReinviteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerCancelBookingAndReinviteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/cancel-booking-reinvite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerAutocomplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerAutocompleteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerAutocompleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/autocomplete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerMarkNoShow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerMarkNoShowData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerMarkNoShowResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/no-show',
    ...options,
  });

/**
 * Lets the participant reschedule their own booking (before or after the
 * booked time) by flagging the scheduled response. The participant's
 * reschedule flow reads this flag.
 */
export const screenerResponsesControllerEnableReschedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerEnableRescheduleData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerEnableRescheduleResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/enable-reschedule',
    ...options,
  });

/**
 * This method is used for both research types - quantitative as well as qualitative; since the participant did not meet researcher's selection criteria.
 * Qualitative: Researcher rejects a participant after their scheduled meeting with the participant.
 * Quantitative: Researcher rejects a participant after looking at the participant's response.
 * Participant will not be paid.
 */
export const screenerResponsesControllerRejected = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerRejectedData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerRejectedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerCancelInvite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerCancelInviteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerCancelInviteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/cancel-invite',
    ...options,
  });

/**
 * Researcher-initiated cancel. Any cancellations within 4 hours prior to a
 * scheduled booking or after the booking time has passed will result in the
 * participant being marked as attended. Researcher will be charged the full
 * incentive and service fee in this case.
 * NOTE: This method as it is written is only responsible for updating the document. Side effects still need to be brought over from
 * from #cancelBooking method in `lib/models/survey/scheduling.js` in website repo
 */
export const screenerResponsesControllerCancelBooking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerResponsesControllerCancelBookingData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerCancelBookingResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/cancel-booking',
    ...options,
  });

export const screenerResponsesControllerParticipantCancelBooking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerParticipantCancelBookingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerParticipantCancelBookingResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/participant-cancel-booking',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Participant-initiated cancel. Always cancelled. The participant is not
 * paid. No lead-time window. Do not use Cancel booking. That endpoint pays
 * the participant if the session is less than 4 hours away.
 */
export const screenerResponsesControllerParticipantCancelBookingExternal = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerParticipantCancelBookingExternalData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerResponsesControllerParticipantCancelBookingExternalResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/participant-cancel-booking/external',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerInsertEmailEvent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerInsertEmailEventData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ScreenerResponsesControllerInsertEmailEventResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/email-events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerResponsesControllerInsertTaskReminderEmailEvent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerResponsesControllerInsertTaskReminderEmailEventData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ScreenerResponsesControllerInsertTaskReminderEmailEventResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-responses/{screenerResponseId}/task-reminder-email-events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Initiate a multipart upload for a screener-response file
 */
export const screenerFileUploadsControllerInitiate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerFileUploadsControllerInitiateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ScreenerFileUploadsControllerInitiateResponses,
    ScreenerFileUploadsControllerInitiateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/screener-file-uploads/initiate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload a single part of a multipart upload
 */
export const screenerFileUploadsControllerUploadPart = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerFileUploadsControllerUploadPartData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ScreenerFileUploadsControllerUploadPartResponses,
    ScreenerFileUploadsControllerUploadPartErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/screener-file-uploads/upload-part',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete a multipart upload
 */
export const screenerFileUploadsControllerComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerFileUploadsControllerCompleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ScreenerFileUploadsControllerCompleteResponses,
    ScreenerFileUploadsControllerCompleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/screener-file-uploads/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Abort a multipart upload
 */
export const screenerFileUploadsControllerAbort = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerFileUploadsControllerAbortData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ScreenerFileUploadsControllerAbortResponses,
    ScreenerFileUploadsControllerAbortErrors,
    ThrowOnError
  >({
    url: '/v4/participant/screener-file-uploads/abort',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const fraudSignalsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FraudSignalsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FraudSignalsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/fraud-signals',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a task on a participant's survey response
 */
export const integrationsControllerCreateTaskForParticipant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IntegrationsControllerCreateTaskForParticipantData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    IntegrationsControllerCreateTaskForParticipantResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/survey-responses/{id}/task',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a task on project by projectId
 */
export const integrationsControllerUpdateTaskOnProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<IntegrationsControllerUpdateTaskOnProjectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    IntegrationsControllerUpdateTaskOnProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/projects/{projectId}/task',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a task on a survey response by the taskId
 */
export const integrationsControllerUpdateTaskOnSurveyResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IntegrationsControllerUpdateTaskOnSurveyResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    IntegrationsControllerUpdateTaskOnSurveyResponseResponses,
    IntegrationsControllerUpdateTaskOnSurveyResponseErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/survey-responses/tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Return all survey responses with tasks of specific status and specified type for this project
 */
export const integrationsControllerFindAllSurveyResponsesWithTasksForProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IntegrationsControllerFindAllSurveyResponsesWithTasksForProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    IntegrationsControllerFindAllSurveyResponsesWithTasksForProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/projects/{id}/survey-responses',
    ...options,
  });

/**
 * Return CSV of all SurveyResponses with completed task
 */
export const integrationsControllerDownloadCompletes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<IntegrationsControllerDownloadCompletesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    IntegrationsControllerDownloadCompletesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/project/{projectId}/survey-responses/completes/download',
    ...options,
  });

/**
 * Create an integration in teams collection
 */
export const integrationsControllerCreateIntegration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<IntegrationsControllerCreateIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    IntegrationsControllerCreateIntegrationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/teams/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete the integration in teams collection
 */
export const integrationsControllerDeleteIntegration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<IntegrationsControllerDeleteIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    IntegrationsControllerDeleteIntegrationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/teams/{id}/{type}',
    ...options,
  });

/**
 * Mark a task on a survey response as complete by the projectCompletionId
 */
export const integrationsControllerMarkTaskAsCompleteByProjectCompletionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IntegrationsControllerMarkTaskAsCompleteByProjectCompletionIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    IntegrationsControllerMarkTaskAsCompleteByProjectCompletionIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/survey-responses/tasks/{projectCompletionId}/complete',
    ...options,
  });

/**
 * Return all surveys for a specific team integration
 */
export const integrationsControllerFindAllSurveysForIntegration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IntegrationsControllerFindAllSurveysForIntegrationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    IntegrationsControllerFindAllSurveysForIntegrationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/teams/{id}/surveys',
    ...options,
  });

/**
 * Returns response details given a specified response
 */
export const integrationsControllerGetSurveyResponseDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IntegrationsControllerGetSurveyResponseDetailsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    IntegrationsControllerGetSurveyResponseDetailsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/integrations/{taskType}/projects/{projectId}/collectors/{collectorId}/responses/{responseId}',
    ...options,
  });

export const notificationsControllerGetEmailPayloadByStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    NotificationsControllerGetEmailPayloadByStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    NotificationsControllerGetEmailPayloadByStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/notifications/email-payload/{status}',
    ...options,
  });

export const notificationsControllerUpdateStatusById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<NotificationsControllerUpdateStatusByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    NotificationsControllerUpdateStatusByIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/notifications/{notificationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const notificationsControllerCancelPendingTaskCompletionReminders = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    NotificationsControllerCancelPendingTaskCompletionRemindersData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    NotificationsControllerCancelPendingTaskCompletionRemindersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/notifications/projects/{projectId}/screener-reponses/{screenerResponseId}',
    ...options,
  });

export const quotasControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<QuotasControllerDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    QuotasControllerDeleteResponses,
    QuotasControllerDeleteErrors,
    ThrowOnError
  >({ url: '/v4/projects/{projectId}/quotas', ...options });

export const quotasControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<QuotasControllerGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    QuotasControllerGetResponses,
    QuotasControllerGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quotas',
    ...options,
  });

export const quotasControllerUpsert = <ThrowOnError extends boolean = false>(
  options: Options<QuotasControllerUpsertData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    QuotasControllerUpsertResponses,
    QuotasControllerUpsertErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quotas',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const quotasControllerDeleteQuota = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotasControllerDeleteQuotaData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    QuotasControllerDeleteQuotaResponses,
    QuotasControllerDeleteQuotaErrors,
    ThrowOnError
  >({ url: '/v4/projects/{projectId}/quota', ...options });

export const quotaControllerGetQuotaByProjectId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotaControllerGetQuotaByProjectIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    QuotaControllerGetQuotaByProjectIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quota',
    ...options,
  });

export const quotaControllerUpdateQuota = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotaControllerUpdateQuotaData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    QuotaControllerUpdateQuotaResponses,
    QuotaControllerUpdateQuotaErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quota',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const quotaControllerCreateQuota = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotaControllerCreateQuotaData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    QuotaControllerCreateQuotaResponses,
    QuotaControllerCreateQuotaErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quota',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const quotasControllerUpsert2 = <ThrowOnError extends boolean = false>(
  options: Options<QuotasControllerUpsert2Data, ThrowOnError>,
) =>
  (options.client ?? client).put<
    QuotasControllerUpsert2Responses,
    QuotasControllerUpsert2Errors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quota',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const quotasControllerPatchTargets = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotasControllerPatchTargetsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    QuotasControllerPatchTargetsResponses,
    QuotasControllerPatchTargetsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quotas/targets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const quotasControllerPatchTargets2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotasControllerPatchTargets2Data, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    QuotasControllerPatchTargets2Responses,
    QuotasControllerPatchTargets2Errors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quota/targets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const quotasControllerSetExternalFills = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotasControllerSetExternalFillsData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    QuotasControllerSetExternalFillsResponses,
    QuotasControllerSetExternalFillsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quotas/external-fills',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const quotasControllerSetExternalFills2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<QuotasControllerSetExternalFills2Data, ThrowOnError>,
) =>
  (options.client ?? client).put<
    QuotasControllerSetExternalFills2Responses,
    QuotasControllerSetExternalFills2Errors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/projects/{projectId}/quota/external-fills',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Sampled, read-only B2B job-title grouping coverage. Consumed by the internal-integrations
 * weekly monitor (which applies alert thresholds + emits the NewRelic event). Admin-only;
 * the monitor calls it as a service-admin.
 */
export const jobTitlesControllerGroupingCoverage = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<JobTitlesControllerGroupingCoverageData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    JobTitlesControllerGroupingCoverageResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/job-titles/grouping/coverage',
    ...options,
  });

/**
 * Find all job titles, filtered and paginated
 */
export const jobTitlesControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<JobTitlesControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    JobTitlesControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/job-titles',
    ...options,
  });

export const jobTitlesControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<JobTitlesControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    JobTitlesControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/job-titles/{id}',
    ...options,
  });

export const invitationsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<InvitationsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    InvitationsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/invitations',
    ...options,
  });

export const invitationsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InvitationsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/invitations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Pending invitations on a project — people the team invited who have not
 * applied. The `projectId` param is what the role guard resolves the team
 * from, so a researcher outside the project's team gets a 403 here as they
 * do on the applicants list.
 */
export const invitationsControllerFindPendingForProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    InvitationsControllerFindPendingForProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    InvitationsControllerFindPendingForProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/invitations',
    ...options,
  });

export const invitationsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    InvitationsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/invitations/{id}',
    ...options,
  });

export const invitationsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    InvitationsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/invitations/{id}',
    ...options,
  });

export const invitationsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    InvitationsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/invitations/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Live projects this participant was invited to and has not started applying
 * to. Listed by the "my projects" Invited tab beside the screener-response
 * cards, so an out-of-project invitation (Participant Database, program
 * follow-up) is reachable from the dashboard and not only from the email.
 *
 * Lives here, beside the researcher's list, rather than on the
 * participant-projects controller: it is an invitation read with no
 * participant-projects logic in it.
 */
export const invitationsControllerFindPendingForParticipant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    InvitationsControllerFindPendingForParticipantData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    InvitationsControllerFindPendingForParticipantResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{userId}/invitations',
    ...options,
  });

/**
 * Post project data and get feasibility data back
 */
export const matchingControllerProjectFeasibility = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerProjectFeasibilityData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MatchingControllerProjectFeasibilityResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/feasibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Calculate feasibility for B2B project attributes
 *
 * Returns the total count of profiles matching the specified B2B project attributes
 */
export const matchingControllerCalculateB2bFeasibilityByAttributes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerCalculateB2bFeasibilityByAttributesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MatchingControllerCalculateB2bFeasibilityByAttributesResponses,
    MatchingControllerCalculateB2bFeasibilityByAttributesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/feasibility-attributes/b2b',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Calculate feasibility for B2C project attributes
 *
 * Returns the total count of profiles matching the specified B2C project attributes
 */
export const matchingControllerCalculateB2cFeasibilityByAttributes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerCalculateB2cFeasibilityByAttributesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MatchingControllerCalculateB2cFeasibilityByAttributesResponses,
    MatchingControllerCalculateB2cFeasibilityByAttributesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/feasibility-attributes/b2c',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const matchingControllerGetExistingScoringModifiers = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    MatchingControllerGetExistingScoringModifiersData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    MatchingControllerGetExistingScoringModifiersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/scoring-modifiers',
    ...options,
  });

export const matchingControllerFindMatchedProjectsNoAuth = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    MatchingControllerFindMatchedProjectsNoAuthData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    MatchingControllerFindMatchedProjectsNoAuthResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/search',
    ...options,
  });

export const matchingControllerPrequalifiesForProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerPrequalifiesForProjectData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MatchingControllerPrequalifiesForProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}/qualify/profiles/{profileId}',
    ...options,
  });

/**
 * This endpoint is for audience size estimate
 */
export const matchingControllerProjectAudienceSizeEstimate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerProjectAudienceSizeEstimateData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MatchingControllerProjectAudienceSizeEstimateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}/feasibility/audience-size-estimate',
    ...options,
  });

/**
 * Create or Update matching data
 */
export const matchingControllerUpsertProjectScore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerUpsertProjectScoreData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    MatchingControllerUpsertProjectScoreResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}',
    ...options,
  });

export const matchingControllerUpsertProjectScoresFromProfileId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerUpsertProjectScoresFromProfileIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    MatchingControllerUpsertProjectScoresFromProfileIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profiles/{profileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const matchingControllerHandleProfileProjectScoreAndUpsert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerHandleProfileProjectScoreAndUpsertData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    MatchingControllerHandleProfileProjectScoreAndUpsertResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profiles/{profileId}/projects/{projectId}',
    ...options,
  });

export const matchingControllerUpsertProjectScoreByProfile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerUpsertProjectScoreByProfileData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    MatchingControllerUpsertProjectScoreByProfileResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}/profiles/{profileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const matchingControllerUpsertProfileProjectScores = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerUpsertProfileProjectScoresData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    MatchingControllerUpsertProfileProjectScoresResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profile-project-matches/scores',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const matchingControllerGetTopMatchedProfiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerGetTopMatchedProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MatchingControllerGetTopMatchedProfilesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}/top-matched',
    ...options,
  });

export const matchingControllerGetRecontactProfiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerGetRecontactProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MatchingControllerGetRecontactProfilesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}/recontact-profiles',
    ...options,
  });

export const matchingControllerFindMatchedProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerFindMatchedProjectsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MatchingControllerFindMatchedProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/search/profiles/{profileId}',
    ...options,
  });

export const matchingControllerUpdateMatchingProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerUpdateMatchingProjectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    MatchingControllerUpdateMatchingProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/matching-projects/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const matchingControllerCreateMatchingProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerCreateMatchingProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MatchingControllerCreateMatchingProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/matching-projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const matchingControllerCheckIfStopEmails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerCheckIfStopEmailsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MatchingControllerCheckIfStopEmailsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/is-stop-emails/{projectId}',
    ...options,
  });

/**
 * Record that the recruitment cron has looked at this project, whether or
 * not an email went out, so the processing sweep can back off instead of
 * re-selecting an exhausted project on every tick.
 */
export const matchingControllerMarkMatchingProjectChecked = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerMarkMatchingProjectCheckedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MatchingControllerMarkMatchingProjectCheckedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/matching-projects/{projectId}/checked',
    ...options,
  });

/**
 * List of projects info which is in processing status and ready for sending emails in matchingprojects collection
 */
export const matchingControllerGetProcessingMatchingProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerGetProcessingMatchingProjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MatchingControllerGetProcessingMatchingProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/matching-projects/processing',
    ...options,
  });

/**
 * Record that the recontact cron has looked at this project, whether or not
 * an email went out, so the next sweep gives a different project a turn.
 * Separate from `/checked`, which paces the recruitment cron.
 */
export const matchingControllerMarkMatchingProjectRecontactChecked = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerMarkMatchingProjectRecontactCheckedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MatchingControllerMarkMatchingProjectRecontactCheckedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/matching-projects/{projectId}/recontact-checked',
    ...options,
  });

/**
 * List of projects info which is in recruiting status in matchingprojects
 * collection, least-recently-recontact-checked first so a caller that takes
 * a bounded `limit` each tick works through the whole list over time.
 */
export const matchingControllerGetRecruitingMatchingProjects = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    MatchingControllerGetRecruitingMatchingProjectsData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    MatchingControllerGetRecruitingMatchingProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/matching-projects/recruiting',
    ...options,
  });

/**
 * Mark-and-return sweep of matching projects recruiting past the cumulative
 * threshold with zero recruitment emails. POST because it has a side
 * effect: returned projects are flagged as alerted (dedup).
 */
export const matchingControllerSweepRecruitingStalledProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerSweepRecruitingStalledProjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MatchingControllerSweepRecruitingStalledProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/matching-projects/recruiting-stalled-sweep',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Scores a batch of newly onboarded participants against every recruiting
 * project. Driven by the initial-matching cron.
 */
export const matchingControllerRunInitialMatchingCheck = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerRunInitialMatchingCheckData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MatchingControllerRunInitialMatchingCheckResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profiles/initial-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const matchingControllerMonitorRecruiting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerMonitorRecruitingData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MatchingControllerMonitorRecruitingResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/matching-projects/monitoring/{projectId}',
    ...options,
  });

export const matchingControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MatchingControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    MatchingControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profiles-rollup/{profileId}/{type}',
    ...options,
  });

export const matchingControllerInsertProfileProjectMatchesEmailEvent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerInsertProfileProjectMatchesEmailEventData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MatchingControllerInsertProfileProjectMatchesEmailEventResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profile-project-matches/email-event',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List of profileIds updated in past N minutes in profileprojectmatches collection
 */
export const matchingControllerGetUpdatedProfileProjectMatches = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerGetUpdatedProfileProjectMatchesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MatchingControllerGetUpdatedProfileProjectMatchesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profile-project-matches',
    ...options,
  });

/**
 * List of profileIds updated in past N minutes in flaggedrespondents collection
 */
export const matchingControllerGetUpdatedFlaggedRespondents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerGetUpdatedFlaggedRespondentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MatchingControllerGetUpdatedFlaggedRespondentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/flagged-respondents',
    ...options,
  });

/**
 * List profileIds updated in past N minutes in respondenttransactions collection for api partner
 */
export const matchingControllerGetUpdatedExternalResearcherRespondentTransactions =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MatchingControllerGetUpdatedExternalResearcherRespondentTransactionsData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      MatchingControllerGetUpdatedExternalResearcherRespondentTransactionsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/matching/respondent-transactions/external-researcher',
      ...options,
    });

/**
 * List profileIds updated in past N minutes in respondenttransactions collection for diy
 */
export const matchingControllerGetUpdatedRespondentTransactions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerGetUpdatedRespondentTransactionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MatchingControllerGetUpdatedRespondentTransactionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/respondent-transactions',
    ...options,
  });

export const matchingControllerGetProfileRollupMetadata = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerGetProfileRollupMetadataData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MatchingControllerGetProfileRollupMetadataResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/profiles-rollup/{profileId}/metadata',
    ...options,
  });

/**
 * Re-predicts the Quotas V2 bucket of every match row of the project that
 * is untagged or tagged against an earlier quota revision; clears the tags
 * when the project has no V2 quota or its organization is off the
 * `quota-dynamic-matching` flag. Run it after a quota's rules change,
 * and once per live project when the flag is first turned on.
 */
export const matchingControllerRebuildQuotaPredictions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchingControllerRebuildQuotaPredictionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MatchingControllerRebuildQuotaPredictionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}/quota-predictions/rebuild',
    ...options,
  });

/**
 * This endpoint is used to trigger a rematch for an existing project.
 */
export const matchingControllerTriggerRematchForExistingProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MatchingControllerTriggerRematchForExistingProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    MatchingControllerTriggerRematchForExistingProjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/matching/projects/{projectId}/organization/{organizationId}/rematch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Returns only fields that are currently locked (within the configured lock expiration window).
 * Fields are locked for a configurable period after their last update.
 */
export const profileLocksControllerGetLockedFieldsByProfileId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProfileLocksControllerGetLockedFieldsByProfileIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProfileLocksControllerGetLockedFieldsByProfileIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profile-locks/profiles/{profileId}/locked-fields',
    ...options,
  });

/**
 * Find a profile lock by profile ID (legacy object format).
 * Kept for backward compatibility.
 */
export const profileLocksControllerGetByProfileId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfileLocksControllerGetByProfileIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfileLocksControllerGetByProfileIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profile-locks/profiles/{profileId}',
    ...options,
  });

/**
 * tooling only — the message appears in the user's pinned "Respondent"
 * thread and the user cannot reply. Set `sendSms` to also text the
 * participant that they have a new message.
 */
export const respondentMessagesControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RespondentMessagesControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RespondentMessagesControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/users/{userId}/respondent-messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * with their unread count. Empty results means the pinned thread is hidden.
 */
export const respondentMessagesControllerGetThread = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RespondentMessagesControllerGetThreadData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    RespondentMessagesControllerGetThreadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/respondent-messages',
    ...options,
  });

export const respondentMessagesControllerMarkAllRead = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RespondentMessagesControllerMarkAllReadData, ThrowOnError>,
) =>
  (options?.client ?? client).patch<
    RespondentMessagesControllerMarkAllReadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/respondent-messages/read',
    ...options,
  });

export const projectsControllerGetRecruitingProjectsData = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ProjectsControllerGetRecruitingProjectsDataData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ProjectsControllerGetRecruitingProjectsDataResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/status/recruiting/data',
    ...options,
  });

export const projectsControllerFindAllRecruitingProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProjectsControllerFindAllRecruitingProjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProjectsControllerFindAllRecruitingProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/status/recruiting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerAutoPauseProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerAutoPauseProjectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerAutoPauseProjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/autopause',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerAutoResumeProjects = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ProjectsControllerAutoResumeProjectsData, ThrowOnError>,
) =>
  (options?.client ?? client).patch<
    ProjectsControllerAutoResumeProjectsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/autoresume',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsControllerFindAllForProjectApproval = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ProjectsControllerFindAllForProjectApprovalData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ProjectsControllerFindAllForProjectApprovalResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects',
    ...options,
  });

export const projectsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProjectsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Lean admin project list — a plain indexed find with none of the approval
 * queue's $search stage, org/team lookups, trust-level gating or implicit
 * status/closed defaults. Declared before `projects/:projectId` so the
 * literal segment matches first.
 */
export const projectsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ProjectsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/all',
    ...options,
  });

/**
 * Admin Projects list — the v4 conversion of the legacy
 * `POST /projects/admin/search` (same Mongo query, house pagination
 * contract). Declared before `projects/:projectId` so the literal segment
 * matches first.
 */
export const projectsControllerAdminList = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ProjectsControllerAdminListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ProjectsControllerAdminListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/admin/list',
    ...options,
  });

export const projectsControllerCopy = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerCopyData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProjectsControllerCopyResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/copy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerGetPitchSuggestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerGetPitchSuggestionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProjectsControllerGetPitchSuggestionsResponses,
    ProjectsControllerGetPitchSuggestionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/suggestions/pitch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerSendAutocompleteEmails = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ProjectsControllerSendAutocompleteEmailsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    ProjectsControllerSendAutocompleteEmailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/emails/autocomplete',
    ...options,
  });

export const projectsControllerDeleteProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerDeleteProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ProjectsControllerDeleteProjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}',
    ...options,
  });

/**
 * Find a project by id.
 * If `populate` is true, populate the project's relationships with the user, professionalIndustries, professionalJobTitles, and desiredSkills loaded.
 * If `stats` is true, and the project is `PAID` get the stats for the project.
 */
export const projectsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}',
    ...options,
  });

export const projectsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find a project by id. For DIY only, will be removed once migration is complete in website.
 * If `populate` is true, populate the project's relationships with the user, professionalIndustries, professionalJobTitles, and desiredSkills loaded.
 * If `stats` is true, and the project is `PAID` get the stats for the project.
 */
export const projectsControllerFindOneDiy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerFindOneDiyData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsControllerFindOneDiyResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/diy',
    ...options,
  });

/**
 * compute project metrics by id.
 */
export const projectsControllerGetComputedProjectMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProjectsControllerGetComputedProjectMetricsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProjectsControllerGetComputedProjectMetricsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/metrics',
    ...options,
  });

export const projectsControllerUpdateProjectMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerUpdateProjectMetricsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerUpdateProjectMetricsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/metrics',
    ...options,
  });

export const projectsControllerGetPlaidVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerGetPlaidVerificationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsControllerGetPlaidVerificationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/verifications',
    ...options,
  });

/**
 * Auto-invites screener responses for all published, unexpired, not-closed
 * projects with auto invite enabled (regardless of recruiting status)
 */
export const projectsControllerProcessAllProjectsAutoInvite = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ProjectsControllerProcessAllProjectsAutoInviteData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).patch<
    ProjectsControllerProcessAllProjectsAutoInviteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/process-auto-invite',
    ...options,
  });

/**
 * Auto-invites screener responses for a published, unexpired, not-closed
 * project with auto-invite enabled (regardless of recruiting status)
 */
export const projectsControllerProcessAutoInvite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerProcessAutoInviteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerProcessAutoInviteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/process-auto-invite',
    ...options,
  });

export const projectsControllerAdminUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerAdminUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerAdminUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/admin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerUploadFilesFormData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerUploadFilesFormDataData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ProjectsControllerUploadFilesFormDataResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/files/form-data',
    ...options,
  });

export const projectsControllerRejectProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerRejectProjectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerRejectProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Replace the project's declared external (partner) external-screener
 * question catalog with the list in the body — the external-screener
 * analogue of the screener-questions bulk endpoint. The pairing with
 * `externalScreenerLink` is deliberately validated at publish
 * (`assertExternalScreenerPublishable`), not here, so a partner may create
 * the project with just the link and declare the catalog afterwards.
 */
export const projectsControllerBulkUpsertExternalQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProjectsControllerBulkUpsertExternalQuestionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    ProjectsControllerBulkUpsertExternalQuestionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/external-questions/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Validate if a project can be published.
 * Returns validation result without actually publishing.
 * The FE should call this before prepaying to check if there are any blocking issues.
 * NOTE: Does not check prepayment - use GET /credits/requirements for financial validation.
 */
export const projectsControllerValidatePublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerValidatePublishData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsControllerValidatePublishResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/validate-publish',
    ...options,
  });

export const projectsControllerPublish = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerPublishData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerPublishResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/publish',
    ...options,
  });

export const projectsControllerPublishAndUpdateTrustLevel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProjectsControllerPublishAndUpdateTrustLevelData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ProjectsControllerPublishAndUpdateTrustLevelResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/publish-and-update-trust-level',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerPause = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerPauseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerPauseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/pause',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerClose = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerCloseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerCloseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/close',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerArchive = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsControllerArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerArchiveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/archive',
    ...options,
  });

export const projectsControllerUpdateRecruitingStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerUpdateRecruitingStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProjectsControllerUpdateRecruitingStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/recruiting-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsControllerFindAllProjectsForTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsControllerFindAllProjectsForTeamData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsControllerFindAllProjectsForTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/projects',
    ...options,
  });

export const projectsControllerGetExternalSchedulingEventTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProjectsControllerGetExternalSchedulingEventTypesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProjectsControllerGetExternalSchedulingEventTypesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/external-scheduling/{provider}',
    ...options,
  });

export const projectsControllerUpdateExternalSchedulingEventTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProjectsControllerUpdateExternalSchedulingEventTypesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    ProjectsControllerUpdateExternalSchedulingEventTypesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/external-scheduling/{provider}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const industriesControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<IndustriesControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    IndustriesControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/industries',
    ...options,
  });

export const industriesControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<IndustriesControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    IndustriesControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/industries/{id}',
    ...options,
  });

export const organizationsControllerCreateNewTeamRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationsControllerCreateNewTeamRequestData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    OrganizationsControllerCreateNewTeamRequestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/new-team-requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationsControllerUpdateNewTeamRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationsControllerUpdateNewTeamRequestData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    OrganizationsControllerUpdateNewTeamRequestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/new-team-requests/{newTeamRequestId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find organizations for user
 * Can be updated later to work with filter
 */
export const organizationsControllerGetOrganizationsForUser = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    OrganizationsControllerGetOrganizationsForUserData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    OrganizationsControllerGetOrganizationsForUserResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations',
    ...options,
  });

export const organizationsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OrganizationsControllerRemoveData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    OrganizationsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}',
    ...options,
  });

/**
 * Find an organization by id
 */
export const organizationsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    OrganizationsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}',
    ...options,
  });

export const organizationsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    OrganizationsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationsControllerMerge = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsControllerMergeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    OrganizationsControllerMergeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/merge/{mergeId}',
    ...options,
  });

export const organizationsControllerUploadFilesFormData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationsControllerUploadFilesFormDataData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    OrganizationsControllerUploadFilesFormDataResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/files/form-data',
    ...options,
  });

export const teamsControllerFindAllForOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamsControllerFindAllForOrganizationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TeamsControllerFindAllForOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams',
    ...options,
  });

export const teamsControllerGetAllTeamsWithUserJoinRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TeamsControllerGetAllTeamsWithUserJoinRequestData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    TeamsControllerGetAllTeamsWithUserJoinRequestResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/join-requests',
    ...options,
  });

export const teamsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<TeamsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TeamsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/{teamId}',
    ...options,
  });

export const teamsControllerCreateJoinRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamsControllerCreateJoinRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TeamsControllerCreateJoinRequestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/{teamId}/join-requests',
    ...options,
  });

export const teamsControllerUpdateJoinRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamsControllerUpdateJoinRequestData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    TeamsControllerUpdateJoinRequestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/{teamId}/join-requests/{joinRequestId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const teamsControllerUploadFilesFormData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamsControllerUploadFilesFormDataData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    TeamsControllerUploadFilesFormDataResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/{teamId}/files/form-data',
    ...options,
  });

export const teamsControllerFindTeamMembers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamsControllerFindTeamMembersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TeamsControllerFindTeamMembersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/{teamId}/members',
    ...options,
  });

export const teamsControllerGetBalanceManagementSettings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TeamsControllerGetBalanceManagementSettingsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    TeamsControllerGetBalanceManagementSettingsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/{teamId}/balance-management-settings',
    ...options,
  });

export const teamsControllerUpdateBalanceManagementSettings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TeamsControllerUpdateBalanceManagementSettingsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    TeamsControllerUpdateBalanceManagementSettingsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/teams/{teamId}/balance-management-settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationRateCardsControllerGetForOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationRateCardsControllerGetForOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    OrganizationRateCardsControllerGetForOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/organizations/{organizationId}/rate-card',
    ...options,
  });

export const organizationRateCardsControllerUpsertForOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationRateCardsControllerUpsertForOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    OrganizationRateCardsControllerUpsertForOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/organizations/{organizationId}/rate-card',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find all pricing credits, filtered and paginated
 */
export const pricingCreditsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingCreditsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find all pricing credits for an organization, filtered and paginated
 */
export const pricingCreditsControllerFindAllForOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingCreditsControllerFindAllForOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PricingCreditsControllerFindAllForOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/organizations/{organizationId}/credits/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find all pricing credits for a team, filtered and paginated
 */
export const pricingCreditsControllerFindAllForTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerFindAllForTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingCreditsControllerFindAllForTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/credits/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find all pricing credits for a team plan, filtered and paginated
 */
export const pricingCreditsControllerFindAllForTeamPlan = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingCreditsControllerFindAllForTeamPlanData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PricingCreditsControllerFindAllForTeamPlanResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{teamPlanId}/credits/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find all expired credits
 */
export const pricingCreditsControllerFindAllExpired = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PricingCreditsControllerFindAllExpiredData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    PricingCreditsControllerFindAllExpiredResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/expired',
    ...options,
  });

/**
 * Find all credits that will expire in one week
 */
export const pricingCreditsControllerFindAllWithOneWeekExpiry = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PricingCreditsControllerFindAllWithOneWeekExpiryData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    PricingCreditsControllerFindAllWithOneWeekExpiryResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/week-expiry',
    ...options,
  });

/**
 * Find one pricing credit by id
 */
export const pricingCreditsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingCreditsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/{id}',
    ...options,
  });

/**
 * Find all expired credits
 * and credits that will expire in one week,
 * then expire credits and send email notfications
 */
export const pricingCreditsControllerManageCreditExpiry = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PricingCreditsControllerManageCreditExpiryData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).post<
    PricingCreditsControllerManageCreditExpiryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/manage-expiry',
    ...options,
  });

/**
 * Find pricing credits by id and expire them
 */
export const pricingCreditsControllerExpireCredit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerExpireCreditData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingCreditsControllerExpireCreditResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/{creditId}/expire',
    ...options,
  });

/**
 * Transfer credits from one team to another
 */
export const pricingCreditsControllerTransfer = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerTransferData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingCreditsControllerTransferResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{teamPlanId}/credits/transfer',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reserve credits for a project
 */
export const pricingCreditsControllerReserve = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerReserveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingCreditsControllerReserveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/credits/reserve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get requirements for a project
 */
export const pricingCreditsControllerGetRequirementsForProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingCreditsControllerGetRequirementsForProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PricingCreditsControllerGetRequirementsForProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/credits/requirements',
    ...options,
  });

/**
 * Get requirements to edit a project
 */
export const pricingCreditsControllerGetRequirementsToEditProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingCreditsControllerGetRequirementsToEditProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PricingCreditsControllerGetRequirementsToEditProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/edit/credits/requirements',
    ...options,
  });

/**
 * Get the current reservations for a project.
 */
export const pricingCreditsControllerReservations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerReservationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingCreditsControllerReservationsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/credits/reservations/summary',
    ...options,
  });

/**
 * Admin tool: Release credits for a specific credit record
 * Use carefully
 */
export const pricingCreditsControllerRelease = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerReleaseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingCreditsControllerReleaseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/credits/{creditId}/release',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Admin tool: Release all reserved credits for a team
 * Use carefully
 */
export const pricingCreditsControllerReleaseAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerReleaseAllData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingCreditsControllerReleaseAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/credits/release',
    ...options,
  });

/**
 * Send credit expiry email
 */
export const pricingCreditsControllerSendNotification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsControllerSendNotificationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingCreditsControllerSendNotificationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/credits/{creditId}/notification',
    ...options,
  });

export const pricingTeamPlansControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/team-plans/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerFindAllForTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerFindAllForTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerFindAllForTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerGetActiveTeamPlan = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerGetActiveTeamPlanData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PricingTeamPlansControllerGetActiveTeamPlanResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/active',
    ...options,
  });

export const pricingTeamPlansControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingTeamPlansControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{id}',
    ...options,
  });

export const pricingTeamPlansControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingTeamPlansControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerUpdateCapabilities = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerUpdateCapabilitiesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    PricingTeamPlansControllerUpdateCapabilitiesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{teamPlanId}/capabilities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerUnpause = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerUnpauseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingTeamPlansControllerUnpauseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{id}/unpause',
    ...options,
  });

export const pricingTeamPlansControllerPause = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerPauseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingTeamPlansControllerPauseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{id}/pause',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerGetActiveRateCard = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerGetActiveRateCardData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PricingTeamPlansControllerGetActiveRateCardResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/rate-cards/active',
    ...options,
  });

export const pricingTeamPlansControllerGetSummaryForTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerGetSummaryForTeamData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PricingTeamPlansControllerGetSummaryForTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/summary',
    ...options,
  });

export const pricingTeamPlansControllerTransferTeamToNewCustomPlan = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerTransferTeamToNewCustomPlanData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerTransferTeamToNewCustomPlanResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/plan',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerTeamUpgrade = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerTeamUpgradeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerTeamUpgradeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/upgrade',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerBulkUpgrade = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingTeamPlansControllerBulkUpgradeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerBulkUpgradeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/upgrade',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingTeamPlansControllerHandleCreditBalanceChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerHandleCreditBalanceChangeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerHandleCreditBalanceChangeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/handle-credit-balance-change',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * ONCALL: migrate a team from V2 to V3. Always runs the legacy migration;
 * optionally (per body fields) sets the V3 rate card in place and re-adds the
 * specified balances. A bare { teamId } body runs the legacy migration only.
 */
export const pricingTeamPlansControllerMigratePricingV2ToV3 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerMigratePricingV2ToV3Data,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PricingTeamPlansControllerMigratePricingV2ToV3Responses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/migrate-v2-to-v3',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Used to determine if a team is eligible for a v2 to v3 pricing migration
 * and how much credit balance they currently have
 */
export const pricingTeamPlansControllerCheckV2TeamDataForMigrationToV3 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingTeamPlansControllerCheckV2TeamDataForMigrationToV3Data,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PricingTeamPlansControllerCheckV2TeamDataForMigrationToV3Responses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/check-v2-pricing-data',
    ...options,
  });

export const pricingChargesControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingChargesControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingChargesControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/charges/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingChargesControllerAddDispute = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingChargesControllerAddDisputeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingChargesControllerAddDisputeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/charges/disputes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingChargesControllerSendReceiptEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingChargesControllerSendReceiptEmailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingChargesControllerSendReceiptEmailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/charges/{id}/send-receipt-email',
    ...options,
  });

export const pricingChargesControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingChargesControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingChargesControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/charges/{id}',
    ...options,
  });

export const pricingChargesControllerFindAllForTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingChargesControllerFindAllForTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingChargesControllerFindAllForTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/charges/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingChargesControllerCreateChargesPdf = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingChargesControllerCreateChargesPdfData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingChargesControllerCreateChargesPdfResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/charges/{chargeId}/receipt',
    ...options,
  });

export const pricingChargesControllerCreateProjectChargesPdf = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingChargesControllerCreateProjectChargesPdfData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PricingChargesControllerCreateProjectChargesPdfResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/receipt',
    ...options,
  });

export const pricingChargesControllerFindAllForOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PricingChargesControllerFindAllForOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PricingChargesControllerFindAllForOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/organizations/{organizationId}/charges/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const respondentTransactionsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RespondentTransactionsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RespondentTransactionsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/respondent-transactions/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const respondentTransactionsControllerFindAllByTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RespondentTransactionsControllerFindAllByTeamData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    RespondentTransactionsControllerFindAllByTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/respondent-transactions',
    ...options,
  });

export const respondentTransactionsControllerGetParticipantPaidCount = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RespondentTransactionsControllerGetParticipantPaidCountData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    RespondentTransactionsControllerGetParticipantPaidCountResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/respondent-transactions/participants/{userId}/paid-count',
    ...options,
  });

/**
 * @deprecated
 */
export const respondentTransactionsControllerDownloadDeprecated = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RespondentTransactionsControllerDownloadDeprecatedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    RespondentTransactionsControllerDownloadDeprecatedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/respondent-transactions/download_deprecated',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const respondentTransactionsControllerDownload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RespondentTransactionsControllerDownloadData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    RespondentTransactionsControllerDownloadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/respondent-transactions/download',
    ...options,
  });

export const surveyResponsesControllerProfileParticipationStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SurveyResponsesControllerProfileParticipationStatsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    SurveyResponsesControllerProfileParticipationStatsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/{id}/stats',
    ...options,
  });

export const surveyResponsesControllerFindAllProjectResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SurveyResponsesControllerFindAllProjectResponsesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SurveyResponsesControllerFindAllProjectResponsesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/projects/{projectId}/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const surveyResponsesControllerDownload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SurveyResponsesControllerDownloadData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SurveyResponsesControllerDownloadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/project/{projectId}/download',
    ...options,
  });

/**
 * @deprecated
 */
export const surveyResponsesControllerDownloadDeprecated = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SurveyResponsesControllerDownloadDeprecatedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SurveyResponsesControllerDownloadDeprecatedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/project/{projectId}/download',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get SurveyResponse details using Survey Id
 */
export const surveyResponsesControllerGetSurveyResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SurveyResponsesControllerGetSurveyResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    SurveyResponsesControllerGetSurveyResponseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/{id}',
    ...options,
  });

export const surveyResponsesControllerUpdateVisibilityByUserId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SurveyResponsesControllerUpdateVisibilityByUserIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    SurveyResponsesControllerUpdateVisibilityByUserIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/users/{userId}/visibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get SurveyResponse details using UserId and ProjectId
 */
export const surveyResponsesControllerGetSurveyResponseByUserAndProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SurveyResponsesControllerGetSurveyResponseByUserAndProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    SurveyResponsesControllerGetSurveyResponseByUserAndProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/survey-responses/users/{userId}/projects/{projectId}',
    ...options,
  });

export const programsControllerFindAll = <ThrowOnError extends boolean = false>(
  options: Options<ProgramsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProgramsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs',
    ...options,
  });

export const programsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProgramsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProgramsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * The reverse lookup, for the breadcrumb on a project page. Returns null when
 * the project belongs to no program, which is the normal case rather than an
 * error.
 *
 * **Must stay declared above `:programId`.** Nest matches routes in
 * declaration order, so below it the literal `by-project` segment would be
 * captured as a program id and rejected by `ParseObjectIdPipe`.
 */
export const programsControllerFindByProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProgramsControllerFindByProjectData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProgramsControllerFindByProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs/by-project/{projectId}',
    ...options,
  });

/**
 * One row per person across every project in the program, in whatever state
 * they reached in each.
 *
 * Declared above `:programId` for the same reason as `by-project`.
 */
export const programsControllerFindParticipants = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProgramsControllerFindParticipantsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProgramsControllerFindParticipantsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs/{programId}/participants',
    ...options,
  });

export const programsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<ProgramsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProgramsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs/{programId}',
    ...options,
  });

export const programsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProgramsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProgramsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs/{programId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Archiving is its own act, so it is a distinct entry in the history.
 */
export const programsControllerArchive = <ThrowOnError extends boolean = false>(
  options: Options<ProgramsControllerArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProgramsControllerArchiveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs/{programId}/archive',
    ...options,
  });

/**
 * The mirror of archive; likewise its own act and its own history entry.
 */
export const programsControllerUnarchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProgramsControllerUnarchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProgramsControllerUnarchiveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs/{programId}/unarchive',
    ...options,
  });

/**
 * Add a project. One-way: there is no counterpart that removes one, and a
 * project already in another program is a conflict rather than a move.
 */
export const programsControllerAddProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProgramsControllerAddProjectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProgramsControllerAddProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/programs/{programId}/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerQuestionsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerQuestionsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ScreenerQuestionsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions',
    ...options,
  });

export const screenerQuestionsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerQuestionsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ScreenerQuestionsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * This endpoint will replace all screener questions with the list in the body.
 */
export const screenerQuestionsControllerBulkUpsert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerQuestionsControllerBulkUpsertData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ScreenerQuestionsControllerBulkUpsertResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search "previously used" screener questions across the team's projects.
 * The route `projectId` is the current project being edited and is excluded
 * from results.
 */
export const screenerQuestionsControllerSearchPreviouslyUsed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerQuestionsControllerSearchPreviouslyUsedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ScreenerQuestionsControllerSearchPreviouslyUsedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/search',
    ...options,
  });

/**
 * Search "previously used" screener questions grouped by project. Same
 * server-side scope / timeframe / current-project exclusion as
 * `screener-questions/search`, but matches the project name (when a
 * `searchText` is given) and returns each project with its non-`isEnd`
 * questions inlined for the drawer's two-pane "Project search" mode. The
 * route `projectId` is the current project being edited and is excluded.
 */
export const screenerQuestionsControllerSearchPreviouslyUsedProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerQuestionsControllerSearchPreviouslyUsedProjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ScreenerQuestionsControllerSearchPreviouslyUsedProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/search-projects',
    ...options,
  });

export const screenerQuestionsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerQuestionsControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ScreenerQuestionsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/{screenerQuestionId}',
    ...options,
  });

export const screenerQuestionsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerQuestionsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ScreenerQuestionsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/{screenerQuestionId}',
    ...options,
  });

export const screenerQuestionsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerQuestionsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerQuestionsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/{screenerQuestionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const screenerQuestionsControllerOrder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenerQuestionsControllerOrderData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ScreenerQuestionsControllerOrderResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/order',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Will throw a bad request exception if any of the questions are invalid.
 * Will return the validated questions if all are valid.
 * Will add an `EndQuestion` if it does not exist.
 */
export const screenerQuestionsControllerValidateQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScreenerQuestionsControllerValidateQuestionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ScreenerQuestionsControllerValidateQuestionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/projects/{projectId}/screener-questions/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const lookupsControllerFindAll = <ThrowOnError extends boolean = false>(
  options: Options<LookupsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    LookupsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/lookups',
    ...options,
  });

export const lookupsControllerFindAllExpanded = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LookupsControllerFindAllExpandedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    LookupsControllerFindAllExpandedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/lookups/expanded',
    ...options,
  });

export const lookupsControllerIndustriesLookup = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<LookupsControllerIndustriesLookupData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    LookupsControllerIndustriesLookupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/lookups/industries',
    ...options,
  });

export const lookupsControllerJobTitlesLookup = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<LookupsControllerJobTitlesLookupData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    LookupsControllerJobTitlesLookupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/lookups/job-titles',
    ...options,
  });

export const lookupsControllerSkillsLookup = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<LookupsControllerSkillsLookupData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    LookupsControllerSkillsLookupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/lookups/skills',
    ...options,
  });

export const lookupsControllerTopicsLookup = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<LookupsControllerTopicsLookupData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    LookupsControllerTopicsLookupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/lookups/topics',
    ...options,
  });

/**
 * Find all job titles, filtered and paginated
 */
export const skillsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<SkillsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    SkillsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/skills',
    ...options,
  });

export const skillsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<SkillsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SkillsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/skills/{id}',
    ...options,
  });

/**
 * Find all topics, filtered and paginated
 */
export const topicsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<TopicsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    TopicsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/topics',
    ...options,
  });

export const topicsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<TopicsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TopicsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/topics/{id}',
    ...options,
  });

export const externalInvitesControllerValidate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExternalInvitesControllerValidateData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExternalInvitesControllerValidateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/external-invites/{inviteCode}',
    ...options,
  });

/**
 * Email a verification code for an external invite application
 *
 * Sends the six-digit code the application must carry, proving the contact address is the applicant's. Gated on a live link and capped per address; never reveals anything about the address.
 */
export const externalInvitesControllerSendVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExternalInvitesControllerSendVerificationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ExternalInvitesControllerSendVerificationResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/participant/external-invites/{inviteCode}/verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const externalInvitesControllerSubmitApplication = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalInvitesControllerSubmitApplicationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ExternalInvitesControllerSubmitApplicationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/external-invites/{inviteCode}/application',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * An external participant's screener
 *
 * Sanitized questions, the NDA requirement and the navigation state against the participant's own draft, for resuming.
 */
export const externalScreenerControllerGetScreener = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExternalScreenerControllerGetScreenerData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExternalScreenerControllerGetScreenerResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/external-projects/{projectId}/screener',
    ...options,
  });

/**
 * Save an external participant's screener answers
 *
 * Saves the answers given and returns where the skip logic leads. The save that completes the screener (and the agreement, when required) files the application, qualified on the answers alone, and admits a qualifying participant to the interview.
 */
export const externalScreenerControllerSaveScreenerResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalScreenerControllerSaveScreenerResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ExternalScreenerControllerSaveScreenerResponseResponses,
    ExternalScreenerControllerSaveScreenerResponseErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/external-projects/{projectId}/screener-responses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectMetricsControllerUpsertDailyMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProjectMetricsControllerUpsertDailyMetricsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ProjectMetricsControllerUpsertDailyMetricsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/project-metrics/projects/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const suggestionsControllerGetIncentiveSuggestion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SuggestionsControllerGetIncentiveSuggestionData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SuggestionsControllerGetIncentiveSuggestionResponses,
    SuggestionsControllerGetIncentiveSuggestionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/suggestions/incentive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminOrganizationsControllerList = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminOrganizationsControllerListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminOrganizationsControllerListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/organizations/list',
    ...options,
  });

export const adminOrganizationsControllerListActiveUsers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminOrganizationsControllerListActiveUsersData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    AdminOrganizationsControllerListActiveUsersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/organizations/{organizationId}/active-users',
    ...options,
  });

export const adminOrganizationsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminOrganizationsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    AdminOrganizationsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/organizations/{organizationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminOrganizationsControllerCreateMerge = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminOrganizationsControllerCreateMergeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminOrganizationsControllerCreateMergeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/organizations/{organizationId}/merge/{childOrganizationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Payouts for one admin lookup; pairs with the payout cancel endpoint.
 * Declared for pricing admins; note the role guard lets any admin through.
 */
export const adminParticipantPaymentsControllerListRespondentPayouts = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    AdminParticipantPaymentsControllerListRespondentPayoutsData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    AdminParticipantPaymentsControllerListRespondentPayoutsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/participant-payments/respondent-payouts/list',
    ...options,
  });

export const adminParticipantsControllerList = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminParticipantsControllerListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminParticipantsControllerListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/participants/list',
    ...options,
  });

/**
 * CSV export of the participants search. Returns the file body directly on
 * the passthrough response (json2csv stream), so the handler resolves with
 * no JSON body; `@ApiOkResponse` documents it as a binary string so the
 * generated clients request it as text.
 */
export const adminParticipantsControllerExport = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminParticipantsControllerExportData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminParticipantsControllerExportResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/participants/export',
    ...options,
  });

export const adminParticipantsControllerUpdateParticipant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminParticipantsControllerUpdateParticipantData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    AdminParticipantsControllerUpdateParticipantResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/participants/{profileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Screener history for one participant: lifetime stats plus the latest 25
 * responses. Read-only; primary reads.
 */
export const adminParticipantsControllerGetParticipantHistory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminParticipantsControllerGetParticipantHistoryData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    AdminParticipantsControllerGetParticipantHistoryResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/participants/{userId}/history',
    ...options,
  });

export const adminProjectsControllerUpdateRecruitingStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminProjectsControllerUpdateRecruitingStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    AdminProjectsControllerUpdateRecruitingStatusResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/projects/{projectId}/recruiting-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Per-project interview + screener rollups for the admin AI-mod analytics
 * dashboard — one grouped read instead of a request per project. POST
 * because the project-id list is too long for a query string.
 */
export const adminProjectsControllerGetAiModProjectStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminProjectsControllerGetAiModProjectStatsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminProjectsControllerGetAiModProjectStatsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/projects/ai-mod-stats',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Where the project-level insights (Tier 2 and the report) stand at one
 * feature schema version, for the Insights tab's dev tools.
 */
export const adminProjectsControllerGetProjectInsightsStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminProjectsControllerGetProjectInsightsStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    AdminProjectsControllerGetProjectInsightsStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/projects/{projectId}/insights-status',
    ...options,
  });

/**
 * Pins the project to another feature schema version.
 */
export const adminProjectsControllerPinFeaturesSchemaVersion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminProjectsControllerPinFeaturesSchemaVersionData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    AdminProjectsControllerPinFeaturesSchemaVersionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/projects/{projectId}/features-schema-version',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminUsersControllerConvertParticipantToResearcher = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminUsersControllerConvertParticipantToResearcherData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminUsersControllerConvertParticipantToResearcherResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/users/convert-to-researcher',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminUsersControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminUsersControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    AdminUsersControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminUsersControllerRemoveUserFromOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminUsersControllerRemoveUserFromOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    AdminUsersControllerRemoveUserFromOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/users/{userId}/organizations/{organizationId}',
    ...options,
  });

export const adminIncentiveAdjustmentsControllerGetProjectIncentiveAdjustments =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AdminIncentiveAdjustmentsControllerGetProjectIncentiveAdjustmentsData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      AdminIncentiveAdjustmentsControllerGetProjectIncentiveAdjustmentsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/admin/projects/{projectId}/incentive-adjustments',
      ...options,
    });

export const adminIncentiveAdjustmentsControllerAdjustProjectIncentives = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminIncentiveAdjustmentsControllerAdjustProjectIncentivesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    AdminIncentiveAdjustmentsControllerAdjustProjectIncentivesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/projects/{projectId}/incentives',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const fraudMetricsControllerGetReportedUsersOverTime = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    FraudMetricsControllerGetReportedUsersOverTimeData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    FraudMetricsControllerGetReportedUsersOverTimeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/fraud-metrics/reported-users',
    ...options,
  });

export const fraudMetricsControllerGetRejectedVpnApplicationsOverTime = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    FraudMetricsControllerGetRejectedVpnApplicationsOverTimeData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    FraudMetricsControllerGetRejectedVpnApplicationsOverTimeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/fraud-metrics/rejected-vpn-applications',
    ...options,
  });

export const fraudMetricsControllerGetRejectedIpApplicationsOverTime = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    FraudMetricsControllerGetRejectedIpApplicationsOverTimeData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    FraudMetricsControllerGetRejectedIpApplicationsOverTimeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/fraud-metrics/rejected-ip-applications',
    ...options,
  });

export const fraudMetricsControllerGetPlaidRiskVerificationsOverTime = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    FraudMetricsControllerGetPlaidRiskVerificationsOverTimeData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    FraudMetricsControllerGetPlaidRiskVerificationsOverTimeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/fraud-metrics/plaid-risk-verifications',
    ...options,
  });

export const aiChatControllerFindByProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AiChatControllerFindByProjectData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    AiChatControllerFindByProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/ai-chat/{projectId}',
    ...options,
  });

export const aiChatControllerUpsert = <ThrowOnError extends boolean = false>(
  options: Options<AiChatControllerUpsertData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AiChatControllerUpsertResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/ai-chat/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const insightsChatControllerListThreads = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InsightsChatControllerListThreadsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    InsightsChatControllerListThreadsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-chat/threads',
    ...options,
  });

export const insightsChatControllerDeleteThread = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InsightsChatControllerDeleteThreadData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    InsightsChatControllerDeleteThreadResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/researcher/projects/{projectId}/insights-chat/threads/{threadId}',
    ...options,
  });

export const insightsChatControllerGetThread = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InsightsChatControllerGetThreadData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    InsightsChatControllerGetThreadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-chat/threads/{threadId}',
    ...options,
  });

export const insightsChatControllerRenameThread = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InsightsChatControllerRenameThreadData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    InsightsChatControllerRenameThreadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-chat/threads/{threadId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * One of the thread's charts evaluated against the study as it stands, split by `breakdown`.
 */
export const insightsChatControllerEvaluateChart = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InsightsChatControllerEvaluateChartData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InsightsChatControllerEvaluateChartResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-chat/threads/{threadId}/charts/evaluate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Streams an AI SDK UI-message stream (SSE); the web app proxies it rather than using the generated SDK.
 */
export const insightsChatControllerSendMessage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InsightsChatControllerSendMessageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InsightsChatControllerSendMessageResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/researcher/projects/{projectId}/insights-chat/messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const authControllerParticipantSignup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AuthControllerParticipantSignupData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthControllerParticipantSignupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/auth/participant-signup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Email a six-digit verification code for the logged-out apply flow.
 *
 * Responds 204 whether or not the address already has an account — an
 * unauthenticated endpoint must not double as an account-existence oracle.
 * Sends are gated on a project opted into public applications and capped
 * per address; see {@link PublicApplyEmailVerificationService}.
 */
export const authControllerSendPublicApplyVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AuthControllerSendPublicApplyVerificationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthControllerSendPublicApplyVerificationResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/auth/public-apply-verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const authControllerResearcherSignup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AuthControllerResearcherSignupData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthControllerResearcherSignupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/auth/researcher-signup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const authControllerInitiatePasswordReset = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AuthControllerInitiatePasswordResetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthControllerInitiatePasswordResetResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/auth/reset-password-initiate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const authControllerVerifyEmail = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerVerifyEmailData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthControllerVerifyEmailResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/auth/verify-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a profile.
 */
export const profilesControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProfilesControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProfilesControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const profilesControllerVerifyPaypal = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerVerifyPaypalData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfilesControllerVerifyPaypalResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/verify-paypal',
    ...options,
  });

export const profilesControllerGetIdByPhoneNumber = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerGetIdByPhoneNumberData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfilesControllerGetIdByPhoneNumberResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/get-id-by-phone-number',
    ...options,
  });

/**
 * Start Verified on LinkedIn OAuth (identityMe + verificationReport; one-shot)
 */
export const profilesControllerStartLinkedinVol = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerStartLinkedinVolData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfilesControllerStartLinkedinVolResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}/linkedin-vol/authorize',
    ...options,
  });

/**
 * OAuth callback for Verified on LinkedIn (identityMe → profile URL only)
 */
export const profilesControllerLinkedinVolOAuthCallback = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ProfilesControllerLinkedinVolOAuthCallbackData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ProfilesControllerLinkedinVolOAuthCallbackResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/linkedin-vol/oauth-callback',
    ...options,
  });

/**
 * Update all profiles whose employment.email contain specified domain.
 */
export const profilesControllerUpdateTrustedCompany = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerUpdateTrustedCompanyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProfilesControllerUpdateTrustedCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/trusted-company',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const profilesControllerUpdateProfileRisk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerUpdateProfileRiskData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProfilesControllerUpdateProfileRiskResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}/risk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find a profile by ID.
 */
export const profilesControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<ProfilesControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfilesControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}',
    ...options,
  });

/**
 * Update a profile.
 */
export const profilesControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProfilesControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProfilesControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get screener cycle data for a profile
 *
 * Get screener cycle data for a profile.
 * Returns the number of screeners taken in the current 24-hour cycle,
 * the limit, and when the cycle expires.
 */
export const profilesControllerGetScreenerCycle = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerGetScreenerCycleData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfilesControllerGetScreenerCycleResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}/screener-cycle',
    ...options,
  });

/**
 * Redeem the click-a-link work email verification token.
 *
 *
 * code — see `POST /v4/participant/profiles/:id/verify-employment-email-code`.
 * This route stays so links already sitting in participants' inboxes, and the
 * legacy Vue participant portal, keep working. Remove it, along with
 * `employment.verificationToken`, once that portal no longer drives work
 * email verification.
 *
 * @deprecated
 */
export const profilesControllerVerifyWorkEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerVerifyWorkEmailData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProfilesControllerVerifyWorkEmailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}/verify/work-email/{token}',
    ...options,
  });

/**
 * Find a profile by user ID.
 */
export const profilesControllerFindByUserId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerFindByUserIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfilesControllerFindByUserIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/user/{userId}',
    ...options,
  });

/**
 * Find a profile by email.
 */
export const profilesControllerFindByEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerFindByEmailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProfilesControllerFindByEmailResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/email/{email}',
    ...options,
  });

/**
 * Get profile survey response participation stats.
 */
export const profilesControllerProfileParticipationStatsForProfile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProfilesControllerProfileParticipationStatsForProfileData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProfilesControllerProfileParticipationStatsForProfileResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}/stats',
    ...options,
  });

export const profilesControllerHandleRejectedProfile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerHandleRejectedProfileData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProfilesControllerHandleRejectedProfileResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/{profileId}/status/rejected',
    ...options,
  });

/**
 * Re-check responses hidden for risk of profiles that are approved now. Dry-run by default.
 *
 * Backfill for the risk-cleared re-check: re-check the responses hidden for
 * risk of profiles that are approved now. Dry-run by default. Driven by
 * scripts/recheck-risk-hidden-responses.ts.
 */
export const profilesControllerRecheckRiskHiddenResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProfilesControllerRecheckRiskHiddenResponsesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ProfilesControllerRecheckRiskHiddenResponsesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/risk-hidden-responses/recheck',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Batch-reject (shadow-ban) profiles: set status=REJECTED and hide their pending screener responses. Dry-run by default.
 *
 * Batch-reject (shadow-ban) profiles: set status=REJECTED and hide each
 * participant's pending screener responses. Dry-run by default.
 */
export const profilesControllerRejectProfiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProfilesControllerRejectProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProfilesControllerRejectProfilesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find External Researcher profiles with missing profile picture.
 */
export const profilesControllerFindExternalResearcherWithoutProfilePicture = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ProfilesControllerFindExternalResearcherWithoutProfilePictureData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ProfilesControllerFindExternalResearcherWithoutProfilePictureResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/profiles/externalresearchers/missing-picture',
    ...options,
  });

export const missingCompanyDomainsControllerGetMissingCompanyDomains = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerGetMissingCompanyDomainsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MissingCompanyDomainsControllerGetMissingCompanyDomainsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains',
    ...options,
  });

export const missingCompanyDomainsControllerListMissingCompanyDomains = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    MissingCompanyDomainsControllerListMissingCompanyDomainsData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    MissingCompanyDomainsControllerListMissingCompanyDomainsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/list',
    ...options,
  });

export const missingCompanyDomainsControllerUpDateDomain = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerUpDateDomainData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MissingCompanyDomainsControllerUpDateDomainResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/name/{domainName}',
    ...options,
  });

export const missingCompanyDomainsControllerGetMissingDomainReview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerGetMissingDomainReviewData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    MissingCompanyDomainsControllerGetMissingDomainReviewResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/name/{domainName}/review',
    ...options,
  });

export const missingCompanyDomainsControllerUpdateWebsiteCheck = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerUpdateWebsiteCheckData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MissingCompanyDomainsControllerUpdateWebsiteCheckResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/name/{domainName}/website-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const missingCompanyDomainsControllerApplyVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerApplyVerificationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MissingCompanyDomainsControllerApplyVerificationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/name/{domainName}/verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const missingCompanyDomainsControllerRecordSecurityCheckAttempt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerRecordSecurityCheckAttemptData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MissingCompanyDomainsControllerRecordSecurityCheckAttemptResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/name/{domainName}/security-check-attempt',
    ...options,
  });

export const missingCompanyDomainsControllerRejectDomainProfiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerRejectDomainProfilesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MissingCompanyDomainsControllerRejectDomainProfilesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/name/{domainName}/reject-profiles',
    ...options,
  });

export const missingCompanyDomainsControllerBulkUpdateMissingDomainStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerBulkUpdateMissingDomainStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MissingCompanyDomainsControllerBulkUpdateMissingDomainStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const missingCompanyDomainsControllerUpdateMissingDomainStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MissingCompanyDomainsControllerUpdateMissingDomainStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    MissingCompanyDomainsControllerUpdateMissingDomainStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/missing-domains/name/{domainName}/status',
    ...options,
  });

export const companiesControllerUpsertCompanyByDomain = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CompaniesControllerUpsertCompanyByDomainData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CompaniesControllerUpsertCompanyByDomainResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/companies/domain/{domainName}',
    ...options,
  });

export const leadsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    LeadsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads',
    ...options,
  });

export const leadsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LeadsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const leadsControllerCreateMany = <ThrowOnError extends boolean = false>(
  options: Options<LeadsControllerCreateManyData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LeadsControllerCreateManyResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const leadsControllerFindUtmTrackedUsers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LeadsControllerFindUtmTrackedUsersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    LeadsControllerFindUtmTrackedUsersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/utm-tracked',
    ...options,
  });

export const leadsControllerFindUtmTrackedResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LeadsControllerFindUtmTrackedResponsesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    LeadsControllerFindUtmTrackedResponsesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/utm-tracked-responses',
    ...options,
  });

export const leadsControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<LeadsControllerDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    LeadsControllerDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/{id}',
    ...options,
  });

export const leadsControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<LeadsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    LeadsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/{id}',
    ...options,
  });

export const leadsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    LeadsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const leadsControllerValidateLead = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LeadsControllerValidateLeadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LeadsControllerValidateLeadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const leadsControllerConsumeLead = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LeadsControllerConsumeLeadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LeadsControllerConsumeLeadResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/consume',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const leadsControllerRejectLead = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsControllerRejectLeadData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    LeadsControllerRejectLeadResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/leads/reject',
    ...options,
  });

export const atlasAppAdminControllerSync = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AtlasAppAdminControllerSyncData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AtlasAppAdminControllerSyncResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/atlas-app-admin/sync',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Report CSP violations.
 */
export const cspControllerReportCspViolation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CspControllerReportCspViolationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CspControllerReportCspViolationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/csp/report',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const emailQueueControllerQueueEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EmailQueueControllerQueueEmailData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EmailQueueControllerQueueEmailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/email-queue',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const emailQueueControllerQueueEmailNewMessageAvailable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EmailQueueControllerQueueEmailNewMessageAvailableData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    EmailQueueControllerQueueEmailNewMessageAvailableResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/email-queue/new-message-available/{conversationUid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Return feedback for exactly one scoped subject: either interviewResponseId or projectId.
 */
export const feedbackControllerFind = <ThrowOnError extends boolean = false>(
  options: Options<FeedbackControllerFindData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    FeedbackControllerFindResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feedback',
    ...options,
  });

export const feedbackControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<FeedbackControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FeedbackControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feedbackControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FeedbackControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    FeedbackControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feedback/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * filtered by context.
 */
export const feedbackControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<FeedbackControllerListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    FeedbackControllerListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/feedback/list',
    ...options,
  });

export const flaggedRespondentsControllerFindAllByOrganizationAndProfile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    FlaggedRespondentsControllerFindAllByOrganizationAndProfileData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    FlaggedRespondentsControllerFindAllByOrganizationAndProfileResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/flagged-respondents/organizations/{organizationId}/profiles/{profileId}',
    ...options,
  });

/**
 * @deprecated
 */
export const flaggedRespondentsControllerFindAllByOrganizationAndProfileQuery =
  <ThrowOnError extends boolean = false>(
    options: Options<
      FlaggedRespondentsControllerFindAllByOrganizationAndProfileQueryData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      FlaggedRespondentsControllerFindAllByOrganizationAndProfileQueryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/flagged-respondents',
      ...options,
    });

export const flaggedRespondentsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FlaggedRespondentsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FlaggedRespondentsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/flagged-respondents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const flaggedRespondentsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FlaggedRespondentsControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    FlaggedRespondentsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/flagged-respondents/{id}',
    ...options,
  });

export const flaggedRespondentsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FlaggedRespondentsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    FlaggedRespondentsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/flagged-respondents/{id}',
    ...options,
  });

export const flaggedRespondentsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FlaggedRespondentsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    FlaggedRespondentsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/flagged-respondents/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const forbiddenWorkDomainsControllerAddForbiddenWorkDomain = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ForbiddenWorkDomainsControllerAddForbiddenWorkDomainData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ForbiddenWorkDomainsControllerAddForbiddenWorkDomainResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/forbidden-work-domains',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all gdpr_deletion documents
 */
export const gdprDeletionsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GdprDeletionsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GdprDeletionsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/gdpr-deletions/list',
    ...options,
  });

/**
 * Create a gdpr_deletion document
 */
export const gdprDeletionsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GdprDeletionsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GdprDeletionsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/gdpr-deletions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a gdpr_deletion document
 */
export const gdprDeletionsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GdprDeletionsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    GdprDeletionsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/gdpr-deletions/{gdprDeletionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * This endpoint is used to delete a ghost inspector organization.
 */
export const ghostInspectorControllerDeleteOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GhostInspectorControllerDeleteOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    GhostInspectorControllerDeleteOrganizationResponses,
    GhostInspectorControllerDeleteOrganizationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/ghost-inspector/{orgId}',
    ...options,
  });

export const participantPaymentsControllerGetPaymentBatchesPendingPayment = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ParticipantPaymentsControllerGetPaymentBatchesPendingPaymentData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ParticipantPaymentsControllerGetPaymentBatchesPendingPaymentResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant-payments/payment-batches/pending-payment',
    ...options,
  });

export const participantPaymentsControllerGetPaymentBatchesPendingConfirmation =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ParticipantPaymentsControllerGetPaymentBatchesPendingConfirmationData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      ParticipantPaymentsControllerGetPaymentBatchesPendingConfirmationResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/participant-payments/payment-batches/pending-confirmation',
      ...options,
    });

export const participantPaymentsControllerUpdateManyPaymentBatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantPaymentsControllerUpdateManyPaymentBatchData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ParticipantPaymentsControllerUpdateManyPaymentBatchResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant-payments/payment-batches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const participantPaymentsControllerCreatePaymentBatches = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantPaymentsControllerCreatePaymentBatchesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantPaymentsControllerCreatePaymentBatchesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant-payments/payment-batches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const participantPaymentsControllerGetPendingRespondentPayoutsBeforeDate =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ParticipantPaymentsControllerGetPendingRespondentPayoutsBeforeDateData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      ParticipantPaymentsControllerGetPendingRespondentPayoutsBeforeDateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/participant-payments/respondent-payouts/pending-payments',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

export const participantPaymentsControllerUpdatePaymentBatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantPaymentsControllerUpdatePaymentBatchData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ParticipantPaymentsControllerUpdatePaymentBatchResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant-payments/payment-batches/{paymentBatchId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const participantPaymentsControllerUpdateRespondentPayouts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantPaymentsControllerUpdateRespondentPayoutsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ParticipantPaymentsControllerUpdateRespondentPayoutsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant-payments/respondent-payouts/{respondentPayoutId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const participantPaymentsControllerUpdateManyRespondentPayouts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantPaymentsControllerUpdateManyRespondentPayoutsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ParticipantPaymentsControllerUpdateManyRespondentPayoutsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant-payments/respondent-payouts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search matched projects for participant
 *
 * Returns a paginated list of projects matched for a specific participant profile. Supports filtering by research type, incentive range, time required, and more.
 */
export const participantMatchingControllerFindMatchedProjectsForParticipant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantMatchingControllerFindMatchedProjectsForParticipantData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantMatchingControllerFindMatchedProjectsForParticipantResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/matching/projects/search/profiles/{profileId}',
    ...options,
  });

/**
 * Check pre-qualification for a project
 *
 * Checks whether a participant qualifies for the given project by reading directly from the profiles collection.
 */
export const participantMatchingControllerCheckQualificationForProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantMatchingControllerCheckQualificationForProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantMatchingControllerCheckQualificationForProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/matching/projects/{projectId}/qualify/profiles/{profileId}',
    ...options,
  });

/**
 * Update profile and check pre-qualification for a project
 *
 * Atomically updates the participant profile and checks whether they qualify for the project, reading directly from the profiles table to avoid stale reads from the eventually-consistent search index.
 */
export const participantMatchingControllerUpdateProfileAndCheckQualification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantMatchingControllerUpdateProfileAndCheckQualificationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantMatchingControllerUpdateProfileAndCheckQualificationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/matching/projects/{projectId}/qualify/profiles/{profileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepair = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminRepairControllerAdminRepairData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairMethodologyPricing = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairMethodologyPricingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairMethodologyPricingResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/methodology-pricing',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairPricingPlanCapabilities = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairPricingPlanCapabilitiesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairPricingPlanCapabilitiesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/pricing-plan-capabilities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairJobTitleGrouping = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairJobTitleGroupingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairJobTitleGroupingResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/job-title-grouping',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairProjectTitleFamilies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairProjectTitleFamiliesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairProjectTitleFamiliesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/project-title-families-backfill',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairProfilesRollup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairProfilesRollupData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairProfilesRollupResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/profiles-rollup-backfill',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairProfileRiskManualReviewAudit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairProfileRiskManualReviewAuditData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairProfileRiskManualReviewAuditResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/profile-risk-manual-review-audit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairProfileRiskPlaidTemplateId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairProfileRiskPlaidTemplateIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairProfileRiskPlaidTemplateIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/profile-risk-plaid-template-id',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairProfileProjectMatchEmailEligibility =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AdminRepairControllerAdminRepairProfileProjectMatchEmailEligibilityData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      AdminRepairControllerAdminRepairProfileProjectMatchEmailEligibilityResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/admin/repair/profile-project-match-email-eligibility',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

export const adminRepairControllerAdminRepairProfileProjectMatchTargetedResearchInvitation =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AdminRepairControllerAdminRepairProfileProjectMatchTargetedResearchInvitationData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      AdminRepairControllerAdminRepairProfileProjectMatchTargetedResearchInvitationResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v4/admin/repair/profile-project-match-targeted-research-invitation',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

export const adminRepairControllerAdminRepairAtlasDisableTriggers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairAtlasDisableTriggersData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairAtlasDisableTriggersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/atlas/disable-triggers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairAtlasDisableTriggersCatchup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairAtlasDisableTriggersCatchupData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairAtlasDisableTriggersCatchupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/atlas/disable-triggers-catchup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairAtlasEnableTriggersCatchup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairAtlasEnableTriggersCatchupData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairAtlasEnableTriggersCatchupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/atlas/enable-triggers-catchup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const adminRepairControllerAdminRepairAtlasEnableTriggers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AdminRepairControllerAdminRepairAtlasEnableTriggersData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AdminRepairControllerAdminRepairAtlasEnableTriggersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/admin/repair/atlas/enable-triggers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Admin tool: Cancel specific amount of credits
 */
export const creditsManagementControllerCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditsManagementControllerCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CreditsManagementControllerCancelResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/{creditId}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find pricing credit by id and extends it
 */
export const creditsManagementControllerExtendCredit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditsManagementControllerExtendCreditData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CreditsManagementControllerExtendCreditResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/{creditId}/extend',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Admin tool: Restore (un-expire) specific amount of credits
 */
export const creditsManagementControllerRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditsManagementControllerRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CreditsManagementControllerRestoreResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits/{creditId}/restore',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get credit expiry information for a team
 */
export const creditsManagementControllerGetCreditExpirySummaryForTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreditsManagementControllerGetCreditExpirySummaryForTeamData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    CreditsManagementControllerGetCreditExpirySummaryForTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/credits/expiry/summary',
    ...options,
  });

/**
 * Internal endpoint to trigger balance management processing.
 * Called by the cron job Lambda handler.
 */
export const balanceManagementControllerProcessBalanceManagement = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    BalanceManagementControllerProcessBalanceManagementData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).post<
    BalanceManagementControllerProcessBalanceManagementResponses,
    unknown,
    ThrowOnError
  >({ url: '/v4/pricing/balance-management/process', ...options });

export const balancesControllerFindAll = <ThrowOnError extends boolean = false>(
  options: Options<BalancesControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    BalancesControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/balances',
    ...options,
  });

export const balancesControllerDownload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BalancesControllerDownloadData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    BalancesControllerDownloadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/balances/download',
    ...options,
  });

export const billingHistoryControllerFindAllForTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BillingHistoryControllerFindAllForTeamData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    BillingHistoryControllerFindAllForTeamResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/billing-history',
    ...options,
  });

export const manageTeamPlansControllerManagePricingTeamCreateCustomPlan = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManageTeamPlansControllerManagePricingTeamCreateCustomPlanData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ManageTeamPlansControllerManagePricingTeamCreateCustomPlanResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/v3/teams/{teamId}/plan',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const manageTeamPlansControllerManagePricingTeamBalance = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ManageTeamPlansControllerManagePricingTeamBalanceData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ManageTeamPlansControllerManagePricingTeamBalanceResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/v3/teams/{teamId}/balance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find all plans set for auto-renewal that have upcoming renewals,
 * send renewal notifications at 3 months, 1 month, 1 week, and 2 days
 * before renewal prior to charging for the renewal.
 */
export const manageTeamPlansControllerManagePlanRenewals = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ManageTeamPlansControllerManagePlanRenewalsData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).post<
    ManageTeamPlansControllerManagePlanRenewalsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/team-plans/renewals/plan',
    ...options,
  });

/**
 * Find all paused plans and charge monthly pause fee if due, and
 * otherwise if a plan has been paused for a year, auto-unpause
 * the plan.
 */
export const manageTeamPlansControllerManagePausedPlans = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ManageTeamPlansControllerManagePausedPlansData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).post<
    ManageTeamPlansControllerManagePausedPlansResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/team-plans/renewals/pause',
    ...options,
  });

/**
 * Aggregated data for the project Payments tab header tiles, right-rail
 * summary, and UI gating.
 */
export const paymentProcessingControllerGetOverview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PaymentProcessingControllerGetOverviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PaymentProcessingControllerGetOverviewResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/payments/overview',
    ...options,
  });

/**
 * Eligible participants to pay for the project — ATTENDED responses that
 * have not yet been paid. Once a participant has any past payment they
 * disappear from this list and re-enter only via the client-side "Pay
 * again" flow.
 */
export const paymentProcessingControllerListParticipantsToPay = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PaymentProcessingControllerListParticipantsToPayData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PaymentProcessingControllerListParticipantsToPayResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/payments/participants-to-pay',
    ...options,
  });

/**
 * Past payments for the project — one row per recorded transaction. Powers
 * the "Past payments" table on the project Payments tab.
 */
export const paymentProcessingControllerListPastPayments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PaymentProcessingControllerListPastPaymentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PaymentProcessingControllerListPastPaymentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/payments/past-payments',
    ...options,
  });

/**
 * All past payments for the project as a CSV attachment — the "export"
 * action on the Past payments table. Unpaginated and unfiltered.
 */
export const paymentProcessingControllerDownloadPastPayments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PaymentProcessingControllerDownloadPastPaymentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PaymentProcessingControllerDownloadPastPaymentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/payments/past-payments/download',
    ...options,
  });

/**
 * Legacy V2 payments for the project — sourced from the pre-V3 `payments`
 * collection. Only meaningful for teams flagged `hasLegacyPricing`; surfaces
 * an empty list otherwise.
 */
export const paymentProcessingControllerListLegacyProjectPayments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PaymentProcessingControllerListLegacyProjectPaymentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    PaymentProcessingControllerListLegacyProjectPaymentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/payments/legacy',
    ...options,
  });

/**
 * Summary of payout for a project
 */
export const paymentProcessingControllerPayoutSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PaymentProcessingControllerPayoutSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentProcessingControllerPayoutSummaryResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/credits/payout/summary',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Buy pay as you go credits
 */
export const paymentProcessingControllerCreatePayg = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PaymentProcessingControllerCreatePaygData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentProcessingControllerCreatePaygResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/team-plans/{teamPlanId}/credits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Payout a project
 */
export const paymentProcessingControllerPayoutProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PaymentProcessingControllerPayoutProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentProcessingControllerPayoutProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/credits/payout',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * endpoint to be triggered by a cron that will process all the auto-payments pending for a team
 */
export const paymentProcessingControllerProcessAutoPay = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PaymentProcessingControllerProcessAutoPayData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentProcessingControllerProcessAutoPayResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/payments/teams/{teamId}/process-auto-pay',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Cancel a pending payout
 */
export const paymentProcessingControllerPayoutCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PaymentProcessingControllerPayoutCancelData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentProcessingControllerPayoutCancelResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/payments/respondentPayouts/{respondentPayoutId}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Process prepayment for a project.
 * Charges the team's credit card for the shortfall to reach 20% minimum deposit.
 */
export const prepayControllerPrepayProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PrepayControllerPrepayProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PrepayControllerPrepayProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/projects/{projectId}/prepay',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingCreditsAuditControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingCreditsAuditControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingCreditsAuditControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/credits-audit/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPromotionsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPromotionsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingPromotionsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/promotions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPromotionsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPromotionsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingPromotionsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/promotions/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPromotionsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPromotionsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingPromotionsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/promotions/{id}',
    ...options,
  });

export const pricingPromotionsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPromotionsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingPromotionsControllerUpdateResponses,
    PricingPromotionsControllerUpdateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/promotions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPromotionsControllerRedeem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPromotionsControllerRedeemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingPromotionsControllerRedeemResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/teams/{teamId}/promotions/redeem',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPurchaseOrdersControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPurchaseOrdersControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingPurchaseOrdersControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/purchase-orders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPurchaseOrdersControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPurchaseOrdersControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PricingPurchaseOrdersControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/purchase-orders/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const pricingPurchaseOrdersControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPurchaseOrdersControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PricingPurchaseOrdersControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/purchase-orders/{id}',
    ...options,
  });

export const pricingPurchaseOrdersControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PricingPurchaseOrdersControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PricingPurchaseOrdersControllerUpdateResponses,
    PricingPurchaseOrdersControllerUpdateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/pricing/purchase-orders/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find a profile by user ID.
 */
export const participantProfilesControllerFindByUserId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantProfilesControllerFindByUserIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ParticipantProfilesControllerFindByUserIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/profiles/user/{userId}',
    ...options,
  });

/**
 * Accept the code of conduct for the authenticated user.
 */
export const participantProfilesControllerAcceptCodeOfConduct = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ParticipantProfilesControllerAcceptCodeOfConductData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).post<
    ParticipantProfilesControllerAcceptCodeOfConductResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/profiles/user/accept-code-of-conduct',
    ...options,
  });

/**
 * Email a one-time verification code to the profile's work email address.
 *
 * Rate limited per profile: one send per minute, and a small hourly cap.
 */
export const participantProfilesControllerSendEmploymentEmailVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProfilesControllerSendEmploymentEmailVerificationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProfilesControllerSendEmploymentEmailVerificationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/profiles/{id}/send-employment-email-verification',
    ...options,
  });

/**
 * Verify a profile's work email using the code that was emailed to it.
 *
 * Responds 400 for a wrong or absent code, 429 once the per-code attempt cap
 * is exceeded, and 409 if another account has already verified that address.
 */
export const participantProfilesControllerVerifyEmploymentEmailCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProfilesControllerVerifyEmploymentEmailCodeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProfilesControllerVerifyEmploymentEmailCodeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/profiles/{id}/verify-employment-email-code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Change the authenticated user's password.
 * Validates the current password before updating.
 */
export const participantProfilesControllerChangePassword = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProfilesControllerChangePasswordData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    ParticipantProfilesControllerChangePasswordResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/profiles/change-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deactivate the authenticated participant's account.
 * Sets isActive to false and sends a deactivation email.
 */
export const participantProfilesControllerDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ParticipantProfilesControllerDeactivateData, ThrowOnError>,
) =>
  (options?.client ?? client).put<
    ParticipantProfilesControllerDeactivateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/profiles/deactivate',
    ...options,
  });

/**
 * View project details for marketplace
 *
 * Returns project details for participants viewing a project in the marketplace. Works for both anonymous and authenticated users. Authenticated users get prequalification results and personalized referral data.
 */
export const participantProjectsControllerViewProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantProjectsControllerViewProjectData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerViewProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/view/{id}',
    ...options,
  });

/**
 * Get project details for the marketplace / apply flow, with no user required.
 */
export const participantProjectsControllerGetProjectDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetProjectDetailsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetProjectDetailsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/details',
    ...options,
  });

/**
 * Screener questions for a project, with no user required.
 */
export const participantProjectsControllerGetScreenerQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetScreenerQuestionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetScreenerQuestionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/screener-questions',
    ...options,
  });

/**
 * Get the next screener question for a set of answers
 *
 * Evaluates the project screener skip logic against the answers supplied and returns where to go next. Publicly accessible: no user is required and nothing is persisted — no screener response is created or updated. Exists so skip-logic configuration never has to be sent to the client. No qualification is run and no qualification verdict is returned.
 */
export const participantProjectsControllerGetNextScreenerQuestion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetNextScreenerQuestionData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerGetNextScreenerQuestionResponses,
    ParticipantProjectsControllerGetNextScreenerQuestionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/screener-questions/next',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all profile questions a project asks for
 *
 * Returns a question for every profile attribute the project targets. Publicly accessible: no user is required, and because there is no profile to compare against, every targeted attribute is asked. Only published projects are exposed. Logged-in participants should use the profile-completion endpoint instead, which asks only for the attributes their profile is missing.
 */
export const participantProjectsControllerGetProjectProfileQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetProjectProfileQuestionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetProjectProfileQuestionsResponses,
    ParticipantProjectsControllerGetProjectProfileQuestionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{projectId}/profile-questions',
    ...options,
  });

/**
 * Get all B2B employment questions a project asks for
 *
 * Returns a question for every bespoke B2B employment field the project targets (industry, job title, job functions, seniority level, company size). Publicly accessible: no user is required. Empty for non-B2B projects. Only published projects are exposed. Intended for the public application flow only — the signed-in flow deliberately does not collect B2B employment fields just-in-time. Answers are written to the matching fields under `employment` in the profile update submitted with the public application.
 */
export const participantProjectsControllerGetProjectB2bQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetProjectB2bQuestionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetProjectB2bQuestionsResponses,
    ParticipantProjectsControllerGetProjectB2bQuestionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{projectId}/b2b-questions',
    ...options,
  });

/**
 * Get screener questions for a project
 *
 * Returns screener questions and NDA info for participants. Questions are sanitized to remove qualification rules (answerValue). Also returns existing response info for resuming drafts.
 */
export const participantProjectsControllerGetScreener = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantProjectsControllerGetScreenerData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetScreenerResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/screener',
    ...options,
  });

/**
 * Recalculate screener status for a project
 *
 * Recalculates the screener status for a project.
 */
export const participantProjectsControllerRecalculateScreenerStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerRecalculateScreenerStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerRecalculateScreenerStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{projectId}/recalculate-screener-status',
    ...options,
  });

/**
 * Mark Plaid identity flow complete for a screener response
 *
 * Sets qualifiedPendingIdVerification on the participant screener response for this project. The authenticated respondent is identified from the session (userId); projectId is taken from the path.
 */
export const participantProjectsControllerMarkPlaidComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerMarkPlaidCompleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerMarkPlaidCompleteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{projectId}/mark-plaid-complete',
    ...options,
  });

/**
 * Apply to a project from the public (logged-out) flow
 *
 * Creates a participant account after verifying email ownership via the emailed code, then writes profile answers and saves the screener response. Only available for projects with publicApplicationsEnabled.
 */
export const participantProjectsControllerSubmitPublicApplication = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerSubmitPublicApplicationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerSubmitPublicApplicationResponses,
    ParticipantProjectsControllerSubmitPublicApplicationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/public-application',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check whether a work email can be used (public apply)
 *
 * Returns whether the address is free to use as a work email: not on a forbidden domain and not already verified on another account. Advisory — the submit re-checks. Only available for projects with publicApplicationsEnabled.
 */
export const participantProjectsControllerCheckPublicApplyWorkEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerCheckPublicApplyWorkEmailData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerCheckPublicApplyWorkEmailResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/public-apply-work-email-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save screener responses for a project
 *
 * Saves or updates screener responses for a participant. Calculates qualification, matching, and visibility server-side.
 */
export const participantProjectsControllerSaveScreenerResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerSaveScreenerResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerSaveScreenerResponseResponses,
    ParticipantProjectsControllerSaveScreenerResponseErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/screener-responses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start an unmoderated project
 *
 * Builds and returns the survey URL for an unmoderated project. The participant must have a screener response for this project.
 */
export const participantProjectsControllerStartUnmoderatedProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerStartUnmoderatedProjectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerStartUnmoderatedProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/start',
    ...options,
  });

export const participantProjectsControllerStartExternalScreener = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerStartExternalScreenerData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerStartExternalScreenerResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/external-screener',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Hide a project (not interested)
 *
 * Marks a project as hidden for the current user. Hidden projects will not appear in the marketplace project list.
 */
export const participantProjectsControllerHideProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantProjectsControllerHideProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerHideProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/hide/{id}',
    ...options,
  });

/**
 * Resend payout email
 *
 * Resends the project payout notification email to the current user. User must have a payout (respondent transaction) for this project.
 */
export const participantProjectsControllerResendPayoutEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerResendPayoutEmailData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerResendPayoutEmailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{projectId}/resend-payout-email',
    ...options,
  });

/**
 * Get profile completion questions for a project
 *
 * Returns questions for profile attributes that are missing but required by the project. If the profile is complete for the project, returns an empty array.
 */
export const participantProjectsControllerGetProfileCompletionQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetProfileCompletionQuestionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetProfileCompletionQuestionsResponses,
    ParticipantProjectsControllerGetProfileCompletionQuestionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{projectId}/profile-completion',
    ...options,
  });

export const participantProjectsControllerGetParticipantPaidCount = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetParticipantPaidCountData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetParticipantPaidCountResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/participants/{userId}/paid-count',
    ...options,
  });

/**
 * Signals about the participant's submitted applications
 *
 * Returns whether the participant has submitted any application, and whether any of them is on a B2B project. Used by onboarding to decide which optional steps to show.
 */
export const participantProjectsControllerGetApplicationSignals = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetApplicationSignalsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetApplicationSignalsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/participants/{userId}/application-signals',
    ...options,
  });

/**
 * Cancel application for a project
 *
 * Cancels the application for a project
 */
export const participantProjectsControllerCancelApplication = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerCancelApplicationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerCancelApplicationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/participants/{userId}/projects/{projectId}/cancel-application',
    ...options,
  });

/**
 * Get interview data for AI-moderated project
 *
 * Returns interview questions and configuration for a participant. Creates an interview response record on first access. Questions are sanitized to remove researcher-only fields.
 */
export const participantProjectsControllerGetInterview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantProjectsControllerGetInterviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetInterviewResponses,
    ParticipantProjectsControllerGetInterviewErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/interview',
    ...options,
  });

/**
 * Re-sign the media for one interview question
 *
 * Returns freshly-signed URLs for a question’s images and PDF. Called when the participant reaches the question, so the URLs cannot have expired in a long interview.
 */
export const participantProjectsControllerGetInterviewQuestionMedia = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetInterviewQuestionMediaData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetInterviewQuestionMediaResponses,
    ParticipantProjectsControllerGetInterviewQuestionMediaErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/interview/questions/{questionUid}/media',
    ...options,
  });

/**
 * Set interview response language
 *
 * Sets the language the participant will respond in. Must be one of the project's allowed response languages. Immutable once the participant has submitted an answer (idempotent re-set to the same value is allowed).
 */
export const participantProjectsControllerSetInterviewResponseLanguage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerSetInterviewResponseLanguageData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    ParticipantProjectsControllerSetInterviewResponseLanguageResponses,
    ParticipantProjectsControllerSetInterviewResponseLanguageErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/interview/response-language',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save interview responses
 *
 * Saves one or more interview question responses. Supports incremental save (per-question) for resume capability. Upserts by questionUid — re-saving overwrites the previous answer.
 */
export const participantProjectsControllerSaveInterviewResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerSaveInterviewResponsesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerSaveInterviewResponsesResponses,
    ParticipantProjectsControllerSaveInterviewResponsesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/interview/responses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete AI-moderated interview
 *
 * Marks the interview as complete after validating all questions are answered. Transitions the participant status from INVITED to ATTENDED.
 */
export const participantProjectsControllerCompleteInterview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerCompleteInterviewData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerCompleteInterviewResponses,
    ParticipantProjectsControllerCompleteInterviewErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/interview/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate AI follow-up question
 *
 * Generates an AI follow-up question for a previously answered interview question. Can also save the participant answer to a previous follow-up before generating the next one.
 */
export const participantProjectsControllerGenerateFollowUp = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGenerateFollowUpData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantProjectsControllerGenerateFollowUpResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{id}/interview/follow-up',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const participantProjectsControllerGetMyProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetMyProjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetMyProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{userId}/my-projects',
    ...options,
  });

/**
 * Projects the participant can message on (qualifying survey response:
 * invited/scheduled/attended/paid), with the existing conversation uid when
 * a thread has already been started. Powers the participant "New message"
 * recipient picker.
 */
export const participantProjectsControllerGetMessagingProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetMessagingProjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetMessagingProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{userId}/messaging-projects',
    ...options,
  });

export const participantProjectsControllerGetPastProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantProjectsControllerGetPastProjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantProjectsControllerGetPastProjectsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant/projects/{userId}/past-projects',
    ...options,
  });

export const participantBookingControllerGetBooking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantBookingControllerGetBookingData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ParticipantBookingControllerGetBookingResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/projects/{projectId}/booking',
    ...options,
  });

export const participantBookingControllerBook = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantBookingControllerBookData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ParticipantBookingControllerBookResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/projects/{projectId}/booking',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const participantBookingControllerFindTimes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantBookingControllerFindTimesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ParticipantBookingControllerFindTimesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/projects/{projectId}/booking/find-times',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const participantBookingControllerReschedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantBookingControllerRescheduleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ParticipantBookingControllerRescheduleResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/projects/{projectId}/booking/reschedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Cancel the participant's booking
 *
 * Cancels the scheduler booking and the application (CANCELLED, as the legacy flow did), releases the Zoom meeting and the reminders, and emails the followers who have cancellation notifications on.
 */
export const participantBookingControllerCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParticipantBookingControllerCancelData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ParticipantBookingControllerCancelResponses,
    ParticipantBookingControllerCancelErrors,
    ThrowOnError
  >({
    url: '/v4/participant/projects/{projectId}/booking/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Tell the researcher none of the times work
 *
 * Emails every follower of the project with the participant's note so they can add availability.
 */
export const participantBookingControllerNotifyResearcher = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantBookingControllerNotifyResearcherData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ParticipantBookingControllerNotifyResearcherResponses,
    ParticipantBookingControllerNotifyResearcherErrors,
    ThrowOnError
  >({
    url: '/v4/participant/projects/{projectId}/booking/notify-researcher',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Initiate a multipart upload for interview media
 */
export const interviewMediaControllerInitiateUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InterviewMediaControllerInitiateUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InterviewMediaControllerInitiateUploadResponses,
    InterviewMediaControllerInitiateUploadErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/interview-media/initiate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload a single part of a multipart upload
 */
export const interviewMediaControllerUploadPart = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InterviewMediaControllerUploadPartData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InterviewMediaControllerUploadPartResponses,
    InterviewMediaControllerUploadPartErrors,
    ThrowOnError
  >({
    url: '/v4/participant/interview-media/upload-part',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete a multipart upload
 */
export const interviewMediaControllerCompleteUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InterviewMediaControllerCompleteUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InterviewMediaControllerCompleteUploadResponses,
    InterviewMediaControllerCompleteUploadErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/interview-media/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Abort a multipart upload
 */
export const interviewMediaControllerAbortUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InterviewMediaControllerAbortUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InterviewMediaControllerAbortUploadResponses,
    InterviewMediaControllerAbortUploadErrors,
    ThrowOnError
  >({
    url: '/v4/participant/interview-media/abort',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload a recording's word-level transcript timeline (S3 sidecar)
 */
export const interviewMediaControllerUploadTranscriptWords = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    InterviewMediaControllerUploadTranscriptWordsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    InterviewMediaControllerUploadTranscriptWordsResponses,
    InterviewMediaControllerUploadTranscriptWordsErrors,
    ThrowOnError
  >({
    url: '/v4/participant/interview-media/transcript-words',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a temporary Deepgram API key for transcription / read-aloud
 */
export const interviewMediaControllerGetTranscriptionToken = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    InterviewMediaControllerGetTranscriptionTokenData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    InterviewMediaControllerGetTranscriptionTokenResponses,
    InterviewMediaControllerGetTranscriptionTokenErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/participant/interview-media/transcription-token',
    ...options,
  });

/**
 * Get caption cues for one interview recording, in a given language
 */
export const getInterviewCaptions = <ThrowOnError extends boolean = false>(
  options: Options<GetInterviewCaptionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetInterviewCaptionsResponses,
    GetInterviewCaptionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/interview-media/captions',
    ...options,
  });

export const researcherProjectsControllerChat = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerChatData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerChatResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/researcher/projects/chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const researcherProjectsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects',
    ...options,
  });

export const researcherProjectsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const researcherProjectsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}',
    ...options,
  });

export const researcherProjectsControllerUpdateDraft = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerUpdateDraftData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ResearcherProjectsControllerUpdateDraftResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * What the study's pricing multiplier is and why — live-computed from
 * current targeting on drafts, the frozen stamp after publish. Powers the
 * fee explanation on the launch and payments pages.
 */
export const researcherProjectsControllerGetPricingMultiplier = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetPricingMultiplierData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetPricingMultiplierResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/pricing-multiplier',
    ...options,
  });

/**
 * The participant incentive recommendation for the study — point and
 * range. Always live-computed. Advice only; `enabled: false` outside the
 * rollout.
 */
export const researcherProjectsControllerGetIncentiveRecommendation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetIncentiveRecommendationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetIncentiveRecommendationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/incentive-recommendation',
    ...options,
  });

/**
 * Recruitment funnel rollup for the project workspace's recruitment
 * activity panel: started/completed/qualified totals plus per-question
 * reach, abandonment, verdict and option splits.
 */
export const researcherProjectsControllerGetRecruitmentStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetRecruitmentStatsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetRecruitmentStatsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/recruitment-stats',
    ...options,
  });

export const researcherProjectsControllerUpdatePublishedDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerUpdatePublishedDetailsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ResearcherProjectsControllerUpdatePublishedDetailsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/published-details',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const researcherProjectsControllerLaunch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerLaunchData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerLaunchResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/launch',
    ...options,
  });

/**
 * Upload an NDA file for a draft researcher project.
 *
 * The file must be multipart/form-data under the field `files` (matching
 * the conventions of the existing `*ControllerUploadFilesFormData`
 * endpoints). On success the project's `ndaFileUrl` and `ndaType` are
 * persisted as a side-effect of the upload.
 */
export const researcherProjectsControllerUploadNdaFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerUploadNdaFileData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ResearcherProjectsControllerUploadNdaFileResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/nda-file',
    ...options,
  });

/**
 * Upload a file to attach to a participant message. Returns the durable S3
 * bucket key (stored on the message so the URL can be re-signed) and a
 * freshly-signed preview URL. Does not require the project to be in DRAFT.
 */
export const researcherProjectsControllerUploadMessageAttachment = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerUploadMessageAttachmentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    ResearcherProjectsControllerUploadMessageAttachmentResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/message-attachment',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Start a chunked upload of a file to attach to a participant message. For
 * files too large for the single-request upload above (e.g. videos);
 * continue with `messaging/attachment-uploads*`.
 */
export const researcherProjectsControllerInitiateMessageAttachmentUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerInitiateMessageAttachmentUploadData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerInitiateMessageAttachmentUploadResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/message-attachment-uploads/initiate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload a media image for an interview question on a draft project.
 *
 * Returns the durable bucket key plus a short-lived preview URL; the key is
 * only persisted onto the question by the normal draft-save call, so this
 * endpoint never writes to the interview script itself.
 */
export const researcherProjectsControllerUploadProjectMedia = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerUploadProjectMediaData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerUploadProjectMediaResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/project-media/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Import a media image from a researcher-supplied URL. The image is
 * fetched server-side (SSRF-guarded), stored in our bucket, and the source
 * URL discarded — participants are never served live external media.
 */
export const researcherProjectsControllerImportProjectMediaFromUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerImportProjectMediaFromUrlData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerImportProjectMediaFromUrlResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/project-media/import-url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Will the browser let us frame this page? Known prototype hosts answer
 * from a table; anything else is probed for `X-Frame-Options` / CSP
 * `frame-ancestors` through the SSRF-guarded header fetch (body never
 * read). Stateless: the verdict is a default for the media's
 * `embedEnabled`, which the researcher can override in the drawer.
 */
export const researcherProjectsControllerCheckProjectMediaEmbed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerCheckProjectMediaEmbedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerCheckProjectMediaEmbedResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/project-media/embed-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Draft a researcher-editable description of a question's attached
 * media. IMAGE media only (LINK context is researcher-written — the server
 * never fetches researcher-supplied URLs for generation). Stateless: the
 * endpoint never writes to the project.
 */
export const researcherProjectsControllerGenerateProjectMediaContext = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGenerateProjectMediaContextData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerGenerateProjectMediaContextResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview-questions/{questionUid}/media-context',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const researcherProjectsControllerGetAllInterviewResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetAllInterviewResponsesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetAllInterviewResponsesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview-responses',
    ...options,
  });

/**
 * Per-question summarization for the researcher "Details" tab: option
 * distributions, ranking matrices, and open-ended themes aggregated across
 * the analyzed cohort (responses with feature extraction COMPLETED), at the
 * pinned feature schema version or the one `featuresSchemaVersion` asks for.
 */
export const researcherProjectsControllerGetQuestionSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetQuestionSummariesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetQuestionSummariesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/question-summaries',
    ...options,
  });

/**
 * The researcher "Concepts" tab for a concept-testing study: what was shown,
 * how each concept landed, and which reactions were specific to one concept
 * rather than true of all of them. Returns an empty `sections` array for a
 * study with no concept section. Read at the pinned feature schema version or
 * the one `featuresSchemaVersion` asks for.
 */
export const researcherProjectsControllerGetConceptReport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetConceptReportData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetConceptReportResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/concept-report',
    ...options,
  });

/**
 * The researcher "Clips" tab: physical video/audio clips cut for the
 * exemplar-selected insights quotes, grouped question → theme. Joined live
 * against the current theme taxonomy, so quotes displaced by a
 * re-consolidation drop out; a selected quote the cutting pipeline hasn't
 * reached yet comes back with a synthetic PENDING status. Read at the pinned
 * feature schema version or the one `featuresSchemaVersion` asks for.
 */
export const researcherProjectsControllerGetQuoteClips = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerGetQuoteClipsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetQuoteClipsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/quote-clips',
    ...options,
  });

/**
 * The feature schema versions the Insights tab can be read and built at, for
 * the dev version picker. Admin only, like the rest of the dev tools.
 */
export const researcherProjectsControllerGetFeaturesSchemaVersions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetFeaturesSchemaVersionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetFeaturesSchemaVersionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/features-schema-versions',
    ...options,
  });

/**
 * Read a study's insights report
 *
 * The study's insights report, at its pinned feature schema version or at
 * the one `featuresSchemaVersion` asks for. The version is resolved here, not
 * by the caller: a sectioned report comes back as `report`, drawn section by
 * section, and a study pinned to a version from before it gets its themes
 * report whole as `legacy`. A study with no report yet returns
 * `found: false`.
 *
 * `Roles.ADMIN` is on the list for the same reason the sibling routes carry
 * it, and it also reads past the organisation check: `RoleGuard` scopes to
 * the caller's organisation only for `Roles.RESEARCHER`, so a Respondent
 * staff member can read a report belonging to a customer.
 */
export const researcherProjectsControllerGetInsightsReport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetInsightsReportData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetInsightsReportResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-report',
    ...options,
  });

/**
 * Re-evaluate a chart in a study's insights report
 *
 * One of the report's charts, re-evaluated with a different breakdown.
 */
export const researcherProjectsControllerEvaluateInsightsReportChart = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerEvaluateInsightsReportChartData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerEvaluateInsightsReportChartResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-report/charts/evaluate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read the positions on statements in a study's insights report
 *
 * Every position on the named statements in full: why each was recorded and
 * the participant's own words. The report itself carries the statements and
 * who holds or denies each.
 */
export const researcherProjectsControllerGetInsightsReportStatements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetInsightsReportStatementsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetInsightsReportStatementsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-report/statements',
    ...options,
  });

/**
 * Search what participants said across a study's insights report
 *
 * The statements whose recorded reasons, conditions or quotes contain `q`.
 */
export const researcherProjectsControllerSearchInsightsReportStatements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerSearchInsightsReportStatementsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerSearchInsightsReportStatementsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-report/statements/search',
    ...options,
  });

/**
 * Export the legacy themes report as a PDF. Streams synchronously from the
 * structured `LegacyInsightsReportDto` document (headline through every section and
 * pull quote) without touching the receipt-PDF path.
 */
export const researcherProjectsControllerDownloadLegacyInsightsReportPdf = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerDownloadLegacyInsightsReportPdfData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerDownloadLegacyInsightsReportPdfResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/researcher/projects/{projectId}/insights-report/pdf',
    ...options,
  });

/**
 * Dev/testing tool: enqueue the project for Tier-3 study-report
 * (re)generation. Admin only: `?dev=true` only decides whether the UI shows
 * it, and a forced run deletes the version's project insights first.
 */
export const researcherProjectsControllerRegenerateInsightsReport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerRegenerateInsightsReportData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerRegenerateInsightsReportResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/insights-report/regenerate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Broadcast that a project's AI-mod insights were (re)generated
 *
 * Service-to-service endpoint the eventbridge insights pipeline calls to emit the realtime insights.updated signal on the project channel.
 */
export const researcherProjectsControllerNotifyInsightsUpdated = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerNotifyInsightsUpdatedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerNotifyInsightsUpdatedResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/researcher/projects/{projectId}/realtime/insights-updated',
    ...options,
  });

/**
 * Generate one AI turn (retake or probe) for the researcher interview
 * preview. Stateless: the client replays the preview conversation on every
 * call and nothing is persisted — see
 * {@link InterviewResponsesService.generatePreviewFollowUp}.
 */
export const researcherProjectsControllerGeneratePreviewFollowUp = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGeneratePreviewFollowUpData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerGeneratePreviewFollowUpResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview/preview-follow-up',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * The cached translation of the scripted interview content for one
 * response language, for pre-launch review. Generates and caches the
 * translation when missing/stale (one blocking LLM call), so reviewing
 * also warms the cache participants read.
 */
export const researcherProjectsControllerGetInterviewContentTranslation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetInterviewContentTranslationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetInterviewContentTranslationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview-content-translations/{language}',
    ...options,
  });

/**
 * Manually override translated blocks for one response language. Each
 * edited block must echo the `*SourceHash` from the GET; 409 when the
 * source script changed in between. Edits persist until the underlying
 * source block changes, which re-translates and drops the override.
 */
export const researcherProjectsControllerUpdateInterviewContentTranslation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerUpdateInterviewContentTranslationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    ResearcherProjectsControllerUpdateInterviewContentTranslationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview-content-translations/{language}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const researcherProjectsControllerGetInterviewResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerGetInterviewResponsesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerGetInterviewResponsesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview-responses/{participantUserId}',
    ...options,
  });

/**
 * Batch include/exclude completed responses from insights generation.
 * Reversible; transcripts remain visible in Results. Triggers a single
 * insights rebuild when anything actually changed.
 */
export const researcherProjectsControllerUpdateInsightsInclusion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerUpdateInsightsInclusionData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    ResearcherProjectsControllerUpdateInsightsInclusionResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview-responses/insights-inclusion',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Dev/testing tool: re-enqueue a single response for feature extraction.
 * Admin only: `?dev=true` only decides whether the UI shows it, and a forced
 * run deletes the response's insights at the version first.
 */
export const researcherProjectsControllerReExtractInterviewResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerReExtractInterviewResponseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerReExtractInterviewResponseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/interview-responses/{participantUserId}/re-extract',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const researcherProjectsControllerListFollowers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerListFollowersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ResearcherProjectsControllerListFollowersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/followers',
    ...options,
  });

export const researcherProjectsControllerAddFollower = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResearcherProjectsControllerAddFollowerData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResearcherProjectsControllerAddFollowerResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/followers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const researcherProjectsControllerRemoveFollower = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResearcherProjectsControllerRemoveFollowerData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    ResearcherProjectsControllerRemoveFollowerResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/followers/{userId}',
    ...options,
  });

/**
 * Run the AI study checks on the project's saved screener (advisory; never blocks launch)
 */
export const studyChecksControllerCheck = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StudyChecksControllerCheckData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StudyChecksControllerCheckResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/researcher/projects/{projectId}/study-checks',
    ...options,
  });

/**
 * Record how the researcher reacted to a study-check finding (ignored, acted on, edited)
 */
export const studyChecksControllerFeedback = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StudyChecksControllerFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StudyChecksControllerFeedbackResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/researcher/projects/{projectId}/study-checks/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Record how the researcher used study checks in the editor (product analytics only)
 */
export const studyChecksControllerRecordEvents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StudyChecksControllerRecordEventsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StudyChecksControllerRecordEventsResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/researcher/projects/{projectId}/study-checks/events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all referrals for a given referrer user, filtered and paginated
 */
export const participantReferralsControllerFindByReferrerUserId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ParticipantReferralsControllerFindByReferrerUserIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ParticipantReferralsControllerFindByReferrerUserIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/participant-referrals/referrer/{userId}',
    ...options,
  });

export const schedulerEventsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchedulerEventsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SchedulerEventsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const schedulerEventsControllerListForProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchedulerEventsControllerListForProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SchedulerEventsControllerListForProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/events/find',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const schedulerEventsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchedulerEventsControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    SchedulerEventsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/events/{uid}',
    ...options,
  });

export const schedulerEventsControllerGetByUid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchedulerEventsControllerGetByUidData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SchedulerEventsControllerGetByUidResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/events/{uid}',
    ...options,
  });

export const schedulerEventsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchedulerEventsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    SchedulerEventsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/events/{uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const schedulerEventsControllerDuplicate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchedulerEventsControllerDuplicateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SchedulerEventsControllerDuplicateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/events/{uid}/duplicate',
    ...options,
  });

export const calendarConnectionControllerDisconnect = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CalendarConnectionControllerDisconnectData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    CalendarConnectionControllerDisconnectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/calendar-connection',
    ...options,
  });

export const calendarConnectionControllerGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CalendarConnectionControllerGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    CalendarConnectionControllerGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/calendar-connection',
    ...options,
  });

export const calendarConnectionControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CalendarConnectionControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    CalendarConnectionControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/scheduler/calendar-connection',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Find a team respondent by profile Id and team Id.
 */
export const teamRespondentsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamRespondentsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TeamRespondentsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/team-respondents/teams/{teamId}/profiles/{profileId}',
    ...options,
  });

/**
 * Search all team respondents.
 */
export const teamRespondentsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamRespondentsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TeamRespondentsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/team-respondents/teams/{teamId}',
    ...options,
  });

/**
 * Invite multiple team respondents to a project.
 *
 * A researcher must belong to the project's team. A platform admin may
 * invite on any team — the admin bulk-invite-by-user-ids tool runs as the
 * admin's own account, not as a team member — and so may an admin
 * impersonating a member (`adminUser`), who already passes as that member.
 */
export const teamRespondentsControllerBatchInvite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TeamRespondentsControllerBatchInviteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    TeamRespondentsControllerBatchInviteResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/team-respondents/teams/{teamId}/batch-invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deletes all data associated with a user.
 * Disabled in production.
 */
export const testSetupControllerDeleteUserData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerDeleteUserDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    TestSetupControllerDeleteUserDataResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/users/{userId}',
    ...options,
  });

/**
 * Sets a user's trustLevel and/or isActive flag.
 * Disabled in production.
 */
export const testSetupControllerUpdateTestUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerUpdateTestUserData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    TestSetupControllerUpdateTestUserResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Disabled in production.
 */
export const testSetupControllerDeleteSurveyResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerDeleteSurveyResponsesData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    TestSetupControllerDeleteSurveyResponsesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/users/{userId}/survey-responses',
    ...options,
  });

/**
 * Fetches the verificationToken from the user model.
 * Disabled in production.
 */
export const testSetupControllerGetUserVerificationToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerGetUserVerificationTokenData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    TestSetupControllerGetUserVerificationTokenResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/email/{email}/verification-token',
    ...options,
  });

/**
 * Returns the participant work-email verification link for a user.
 * Requires the verification send to have already run. Disabled in production.
 */
export const testSetupControllerGetWorkEmailVerificationLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerGetWorkEmailVerificationLinkData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    TestSetupControllerGetWorkEmailVerificationLinkResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/users/{userId}/work-email-verification-link',
    ...options,
  });

/**
 * Issues a fresh participant work-email verification code and returns it in
 * plaintext. Only the digest is stored, so an already-sent code cannot be read
 * back — this mints a new one. Disabled in production.
 */
export const testSetupControllerGetWorkEmailVerificationCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerGetWorkEmailVerificationCodeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    TestSetupControllerGetWorkEmailVerificationCodeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/users/{userId}/work-email-verification-code',
    ...options,
  });

/**
 * Ensures a feature flag is on for an organization: adds it to the
 * allowOrganizations list, sets isActive, and drops any deny entry for the
 * same org (the lists are kept mutually exclusive). When the flag is already
 * active for every organization (empty allowlist), only the deny entry is
 * cleared — allow-listing there would narrow the flag to allowlist-only mode.
 * Disabled in production.
 */
export const testSetupControllerAddFeatureFlagAllowOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerAddFeatureFlagAllowOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    TestSetupControllerAddFeatureFlagAllowOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/feature-flags/allow-organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Removes an organization from a feature flag's allowOrganizations list.
 * Disabled in production.
 */
export const testSetupControllerRemoveFeatureFlagAllowOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerRemoveFeatureFlagAllowOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    TestSetupControllerRemoveFeatureFlagAllowOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/feature-flags/{name}/allow-organizations/{organizationId}',
    ...options,
  });

/**
 * Adds an organization to a feature flag's denyOrganizations list and drops
 * any allow entry for the same org (the lists are kept mutually exclusive).
 * Disabled in production.
 */
export const testSetupControllerAddFeatureFlagDenyOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerAddFeatureFlagDenyOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    TestSetupControllerAddFeatureFlagDenyOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/feature-flags/deny-organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Removes an organization from a feature flag's denyOrganizations list.
 * Disabled in production.
 */
export const testSetupControllerRemoveFeatureFlagDenyOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerRemoveFeatureFlagDenyOrganizationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    TestSetupControllerRemoveFeatureFlagDenyOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/feature-flags/{name}/deny-organizations/{organizationId}',
    ...options,
  });

export const testSetupControllerCreateProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerCreateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TestSetupControllerCreateProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/users/{userId}/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const testSetupControllerPublishProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerPublishProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TestSetupControllerPublishProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/projects/{projectId}/publish',
    ...options,
  });

export const testSetupControllerBulkUpsertScreenerQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TestSetupControllerBulkUpsertScreenerQuestionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    TestSetupControllerBulkUpsertScreenerQuestionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/projects/{projectId}/screener-questions/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const testSetupControllerDeleteProjectData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerDeleteProjectDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    TestSetupControllerDeleteProjectDataResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/projects/{projectId}',
    ...options,
  });

export const testSetupControllerFindUserByEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerFindUserByEmailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TestSetupControllerFindUserByEmailResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/users/email/{email}',
    ...options,
  });

export const testSetupControllerInviteScreenerResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerInviteScreenerResponseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    TestSetupControllerInviteScreenerResponseResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/survey-responses/projects/{projectId}/users/{userId}/invite',
    ...options,
  });

/**
 * Sets the profile risk inputs that production writes from a scoring job
 * and a Twilio lookup. Disabled in production.
 */
export const testSetupControllerSetProfileRiskSignals = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerSetProfileRiskSignalsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    TestSetupControllerSetProfileRiskSignalsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/profiles/{profileId}/risk-signals',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Recomputes and persists the profile's overall risk level now, and returns
 * it. Disabled in production.
 */
export const testSetupControllerRecomputeProfileRisk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestSetupControllerRecomputeProfileRiskData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TestSetupControllerRecomputeProfileRiskResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/test-setup/profiles/{profileId}/risk/recompute',
    ...options,
  });

export const verificationControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VerificationControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    VerificationControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const verificationControllerVerifyCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VerificationControllerVerifyCodeData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    VerificationControllerVerifyCodeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/verification/{code}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const verificationsControllerTwilioCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VerificationsControllerTwilioCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    VerificationsControllerTwilioCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/verifications/twilio',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const verificationsControllerTwilioVerifyCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VerificationsControllerTwilioVerifyCodeData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    VerificationsControllerTwilioVerifyCodeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/verifications/twilio/{code}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const verificationsControllerGetPlaidVerificationLinkToken = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    VerificationsControllerGetPlaidVerificationLinkTokenData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    VerificationsControllerGetPlaidVerificationLinkTokenResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/verifications/plaid/link-token',
    ...options,
  });

/**
 * Endpoint called from WebhooksPlaidHandler in serverless-internal-integrations to handle updated Plaid session.
 * Will only ever receive requests on QA or Production environments.
 */
export const verificationsControllerPatchPlaidSession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VerificationsControllerPatchPlaidSessionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    VerificationsControllerPatchPlaidSessionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/verifications/plaid/{plaidSessionId}',
    ...options,
  });

/**
 * Endpoint called from WebhooksPersonaHandler in serverless-internal-integrations
 * when a Persona inquiry changes. Re-fetches the inquiry from Persona and
 * applies the verdict exactly like a Plaid session.
 */
export const verificationsControllerPatchPersonaInquiry = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    VerificationsControllerPatchPersonaInquiryData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    VerificationsControllerPatchPersonaInquiryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/verifications/persona/{inquiryId}',
    ...options,
  });

/**
 * Get webhook for an organization. Will only ever return one.
 */
export const webhooksOrganizationsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksOrganizationsControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    WebhooksOrganizationsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/webhooks',
    ...options,
  });

/**
 * An organization can have a single webhook url setup which we will send all events to.
 * To change the url of the webhook send another post request with the new url.
 * This will deactivate the previous webhook and create a new one.
 */
export const webhooksOrganizationsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksOrganizationsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WebhooksOrganizationsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/webhooks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deactivate a webhook
 */
export const webhooksOrganizationsControllerDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksOrganizationsControllerDeactivateData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    WebhooksOrganizationsControllerDeactivateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/webhooks/{webhookId}',
    ...options,
  });

/**
 * Get a webhook by id
 */
export const webhooksOrganizationsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksOrganizationsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    WebhooksOrganizationsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/webhooks/{webhookId}',
    ...options,
  });

/**
 * Get all event types that can be sent to a webhook
 */
export const webhooksOrganizationsControllerFindEventTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    WebhooksOrganizationsControllerFindEventTypesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    WebhooksOrganizationsControllerFindEventTypesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/webhooks/{webhookId}/event-types',
    ...options,
  });

/**
 * Making a request to this endpoint will cause our system to trigger a webhook for the specified event.
 * This can be very useful when testing the setup that processes webhooks on your end.
 * Will use random resource ids for the event (not a real project or screener).
 */
export const webhooksOrganizationsControllerSimulate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksOrganizationsControllerSimulateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WebhooksOrganizationsControllerSimulateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/organizations/{organizationId}/webhooks/{webhookId}/simulate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get webhook for a team. Will only ever return one.
 */
export const webhooksControllerFindAll = <ThrowOnError extends boolean = false>(
  options: Options<WebhooksControllerFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    WebhooksControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/webhooks',
    ...options,
  });

/**
 * A team can have a single webhook url setup which we will send all events to.
 * To change the url of the webhook send another post request with the new url.
 * This will deactivate the previous webhook and create a new one.
 */
export const webhooksControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<WebhooksControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WebhooksControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/webhooks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deactivate a webhook
 */
export const webhooksControllerDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksControllerDeactivateData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    WebhooksControllerDeactivateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/webhooks/{webhookId}',
    ...options,
  });

/**
 * Get a webhook by id
 */
export const webhooksControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<WebhooksControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    WebhooksControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/webhooks/{webhookId}',
    ...options,
  });

/**
 * Get all event types that can be sent to a webhook
 */
export const webhooksControllerFindEventTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksControllerFindEventTypesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    WebhooksControllerFindEventTypesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/webhooks/{webhookId}/event-types',
    ...options,
  });

/**
 * Making a request to this endpoint will cause our system to trigger a webhook for the specified event.
 * This can be very useful when testing the setup that processes webhooks on your end.
 * Will use random resource ids for the event (not a real project or screener).
 */
export const webhooksControllerSimulate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksControllerSimulateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WebhooksControllerSimulateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/teams/{teamId}/webhooks/{webhookId}/simulate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Received Webhooks.
 * Used for e2e tests only.
 */
export const webhooksReceivedControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<WebhooksReceivedControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    WebhooksReceivedControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/webhooks-received',
    ...options,
  });

/**
 * Save Received Webhooks
 * Used for e2e tests only.
 */
export const webhooksReceivedControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksReceivedControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WebhooksReceivedControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/webhooks-received',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Received Webhooks by webhookId.
 * Used for e2e tests only.
 */
export const webhooksReceivedControllerDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksReceivedControllerDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    WebhooksReceivedControllerDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/webhooks-received/{webhookId}',
    ...options,
  });

/**
 * This endpoint is used to test receiving webhook events.
 * Setup a webhook with the url of this endpoint and send a test event.
 * Use ngrok to expose your local server to the internet and use the ngrok url as the webhook url.
 */
export const webhooksReceivedControllerTest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WebhooksReceivedControllerTestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WebhooksReceivedControllerTestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/webhooks-received/{webhookId}/test',
    ...options,
  });

export const emailEventsControllerCreateEmailEvent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EmailEventsControllerCreateEmailEventData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EmailEventsControllerCreateEmailEventResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/email-events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const usersSessionsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersSessionsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UsersSessionsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users-sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const usersSessionsControllerGetOneByUserId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersSessionsControllerGetOneByUserIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersSessionsControllerGetOneByUserIdResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/users-sessions/{userId}',
    ...options,
  });

export const clearbitRiskHistoryControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClearbitRiskHistoryControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ClearbitRiskHistoryControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/clearbit-risk-history',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const roundtableVerificationsControllerFindAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RoundtableVerificationsControllerFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    RoundtableVerificationsControllerFindAllResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/roundtable-verifications',
    ...options,
  });

export const roundtableVerificationsControllerTriggerRoundtableVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RoundtableVerificationsControllerTriggerRoundtableVerificationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    RoundtableVerificationsControllerTriggerRoundtableVerificationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/roundtable-verifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const roundtableVerificationsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RoundtableVerificationsControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RoundtableVerificationsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/roundtable-verifications/{id}',
    ...options,
  });

export const roundtableVerificationsControllerFindOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RoundtableVerificationsControllerFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    RoundtableVerificationsControllerFindOneResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/roundtable-verifications/{id}',
    ...options,
  });

export const roundtableVerificationsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RoundtableVerificationsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    RoundtableVerificationsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v4/roundtable-verifications/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const creditCardsControllerGetClientToken = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CreditCardsControllerGetClientTokenData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    CreditCardsControllerGetClientTokenResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/braintree/client-token',
    ...options,
  });

export const creditCardsControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditCardsControllerGetAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    CreditCardsControllerGetAllResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/teams/{teamId}/credit-cards',
    ...options,
  });

export const creditCardsControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditCardsControllerUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CreditCardsControllerUpdateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/teams/{teamId}/credit-cards',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const creditCardsControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditCardsControllerCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreditCardsControllerCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/v4/teams/{teamId}/credit-cards',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const creditCardsControllerUpdateDefaultCard = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditCardsControllerUpdateDefaultCardData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CreditCardsControllerUpdateDefaultCardResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v4/teams/{teamId}/credit-cards/default',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const creditCardsControllerRemove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreditCardsControllerRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    CreditCardsControllerRemoveResponses,
    unknown,
    ThrowOnError
  >({ url: '/v4/teams/{teamId}/credit-cards/{token}', ...options });
